import { Console } from "console";
import { C, s } from "@fullcalendar/core/internal-common";
import az_AZ from "antd/es/locale/az_AZ";
import bg_BG from "antd/es/locale/bg_BG";
import ca_ES from "antd/es/locale/ca_ES";
import cs_CZ from "antd/es/locale/cs_CZ";
import da_DK from "antd/es/locale/da_DK";
import de_DE from "antd/es/locale/de_DE";
import el_GR from "antd/es/locale/el_GR";
import en_GB from "antd/es/locale/en_GB";
import en_US from "antd/es/locale/en_US";
import es_ES from "antd/es/locale/es_ES";
import et_EE from "antd/es/locale/et_EE";
import fi_FI from "antd/es/locale/fi_FI";
import fr_FR from "antd/es/locale/fr_FR";
import hr_HR from "antd/es/locale/hr_HR";
import hu_HU from "antd/es/locale/hu_HU";
import hy_AM from "antd/es/locale/hy_AM";
import is_IS from "antd/es/locale/is_IS";
import it_IT from "antd/es/locale/it_IT";
import ka_GE from "antd/es/locale/ka_GE";
import kk_KZ from "antd/es/locale/kk_KZ";
import lt_LT from "antd/es/locale/lt_LT";
import lv_LV from "antd/es/locale/lv_LV";
import mk_MK from "antd/es/locale/mk_MK";
import nb_NO from "antd/es/locale/nb_NO";
import nl_NL from "antd/es/locale/nl_NL";
import pl_PL from "antd/es/locale/pl_PL";
import pt_PT from "antd/es/locale/pt_PT";
import ro_RO from "antd/es/locale/ro_RO";
import ru_RU from "antd/es/locale/ru_RU";
import sk_SK from "antd/es/locale/sk_SK";
import sl_SI from "antd/es/locale/sl_SI";
import sr_RS from "antd/es/locale/sr_RS";
import sv_SE from "antd/es/locale/sv_SE";
import tr_TR from "antd/es/locale/tr_TR";
import uk_UA from "antd/es/locale/uk_UA";
import axios from "axios";
import { Guid } from "guid-typescript";
import _ from "lodash";
import moment from "moment";
import querystringify from "querystringify";
import { store } from "react-notifications-component";
import Swal from "sweetalert2";
import { setTimeout } from "worker-timers";
import LocalStorageService from "../../auth/local-storage-service";
import { IChangePasswordDto } from "../../models/dto/change-password.dto";
import { ICreateUserWithPasswordDto } from "../../models/dto/create-user-with-password";
import { ICreateUserDto } from "../../models/dto/createuser";
import { IImportMappedExcelColumnMapDefinition, IImportMappedExcelParameter } from "../../models/dto/excel";
import { IForgotPasswordDto } from "../../models/dto/forgotpassword.dto";
import { IIyzicoAddressDto, IIyzicoCheckoutFormDto } from "../../models/dto/iyzico.dto";
import { IResetPasswordWithTokenDto } from "../../models/dto/reset-password-with-token";
import { IRestResult } from "../../models/dto/rest-result.dto";
import { ISignupDto } from "../../models/dto/signup.dto";
import { IStripePayment } from "../../models/dto/stripe-payment";
import {
  IStripeCaptureDto,
  IStripeChargePaymentMethodDto,
  IStripeConnectedAccountDto,
  IStripeConnectedAccountOnboardingDto,
  IStripeConnectedAccountPayout,
  IStripeConnectedAccountWithdraw,
  IStripeCreateConnectedAccountDto,
  IStripeDeletePaymentMethodDto,
  IStripePaymentDto,
  IStripeRefundDto,
  IStripeUpdateCustomerDto
} from "../../models/dto/stripe.dto";
import { IUpdateUserStartingScreen } from "../../models/dto/update-user-starting-screen.dto";
import { IUpdateUsernameDto } from "../../models/dto/update-username.dto";
import { IUserRoleDto } from "../../models/dto/userrole.dto";
import { ITaskDataParameters, getDictionaryValueByKey } from "../../models/dto/workflow-task.dto";
import { EAccountStatus } from "../../models/enum/auth";
import { ELanguage } from "../../models/enum/language";
import { translationService } from "../../services/_singletons";
import { CacheService } from "../../services/cache-service";
import ServerFilesService from "../../services/files-download-service";
import HelperService from "../../services/helper-service";
import { IyzicoService } from "../../services/iyzico-service";
import KuikaCoreWasmBridgeService from "../../services/kuika-core-wasm-bridge-service";
import { LanguageService } from "../../services/language-service";
import NotificationService from "../../services/notification-service";
import OfflineDbPersistenceService from "../../services/offline-db-persistence-service";
import OfflineSyncService from "../../services/offline-sync-service";
import { StripeService } from "../../services/stripe-service";
import { UserService } from "../../services/user-service";
import { WorkflowService } from "../../services/workflow-service";
import { KNavigator } from "../hoc/with-history";
import { OTP_ALGORITHM, OTP_DIGITS, OTP_PERIOD, OTP_SECRET_KEY } from "../json/otp.json";
import { DateFormatValidator } from "./date-format-validator";
import { KuikaAppManager } from "./kuika-app-manager";
import { KMainFunctions } from "./main-functions";


declare let window: Window & { [key: string]: any };
declare let google: any;
let TOKEN = "";
let USER = "";
let enteredPassword = "";

let watchPositionId: number | null = null;
let watchPositionData: {
  latitude: number;
  longitude: number;
  accuracy: number;
} | null = null;

export class ReactSystemFunctions {
  // Static bags storage for global access across the app
  private static bags: { [key: string]: any } = {};

  private static translateCache = new WeakMap<
    object,
    {
      byName: Map<string, { idProp: Map<string, string>; propOnly: Map<string, string> }>;
      byShortName: Map<string, { idProp: Map<string, string>; propOnly: Map<string, string> }>;
    }
  >();

  private static getTranslateCache(languages: any[]) {
    let cache = ReactSystemFunctions.translateCache.get(languages);
    if (cache) return cache;

    type PhraseMaps = { idProp: Map<string, string>; propOnly: Map<string, string> };
    const byName = new Map<string, PhraseMaps>();
    const byShortName = new Map<string, PhraseMaps>();

    for (const lang of languages) {
      const idPropMap = new Map<string, string>();
      const propOnlyMap = new Map<string, string>();

      if (lang.LanguagePhrases) {
        for (const phrase of lang.LanguagePhrases) {
          if (phrase.Value) {
            if (phrase.Id) {
              idPropMap.set(`${phrase.Id}\0${phrase.PropertyName}`, phrase.Value);
            }
            if (phrase.PropertyName) {
              propOnlyMap.set(phrase.PropertyName, phrase.Value);
            }
          }
        }
      }

      const combined: PhraseMaps = { idProp: idPropMap, propOnly: propOnlyMap };
      if (lang.Name) byName.set(lang.Name, combined);
      if (lang.ShortName) byShortName.set(lang.ShortName, combined);
    }

    cache = { byName, byShortName };
    ReactSystemFunctions.translateCache.set(languages, cache);
    return cache;
  }

  public static convertToTypeByName(data: any, targetTypeName: string): any {
    if ((data == null || data == undefined) && targetTypeName == "boolean") {
      return false;
    }
    if (data == null) return null;
    targetTypeName = targetTypeName.toLowerCase();
    if (targetTypeName === "string" || targetTypeName === "string?") {
      if (data !== undefined && data !== null) {
        if (this.isValidDateWithFormat(data)) {
          const momentDate = moment(data);
          if (momentDate.isValid()) {
            const mlValue = localStorage.getItem("ml") || "";
            const userLocale = mlValue ? mlValue.split("_")[0] : "";
            moment.locale(userLocale);
            const hasTimeComponent =
              typeof data === "string"
                ? data.includes(":")
                : momentDate.hour() !== 0 || momentDate.minute() !== 0 || momentDate.second() !== 0;

            return momentDate.format(
              hasTimeComponent
                ? `${moment.localeData().longDateFormat("L")} ${moment.localeData().longDateFormat("LT")}`
                : moment.localeData().longDateFormat("L")
            );
          }
          return data.toString();
        }
      }

      return data?.toString();
    }
    if (targetTypeName === "guid" || targetTypeName === "guid?") {
      if (data !== undefined && data !== null && Guid.isGuid(data)) {
        return data.toString();
      }
      return null;
    }
    if (targetTypeName === "boolean" || targetTypeName === "boolean?")
      return !!(data && data.toString && data.toString().toLowerCase() === "true");
    if (targetTypeName === "date" || targetTypeName === "date?") return this.getDate(data);
    if (targetTypeName === "number" || targetTypeName === "number?") {
      const value: number = parseFloat(data);
      return Number.isNaN(value) ? null : value;
    }
    if (targetTypeName.includes("[]")) {
      if (Array.isArray(data)) return data;
      return data !== undefined && data !== null ? [...data.split(",")] : [];
    }
    return data;
  }

  static getDate = (data: string) => {
    if (data !== undefined && data !== null && data !== "") {
      const date = moment(data);

      if (date.hour() === 0 && date.minute() === 0 && date.second() === 0 && date.millisecond() === 0) {
        const utcOffset = date.utcOffset() === 0 ? date.utcOffset() : date.utcOffset() / 60;
        date.add(utcOffset, "hours");
      }

      return date;
    }

    return null;
  };

  public static getDynamicInputDataType(screen: any, componentId: string): string | null {
    const dynamicInputRef = screen[`${componentId}_kuikaTextInputRef`];
    if (
      dynamicInputRef &&
      dynamicInputRef.current &&
      dynamicInputRef.current.props &&
      dynamicInputRef.current.props.dataType
    ) {
      return dynamicInputRef.current.props.dataType;
    }

    return null;
  }

  public static getValueWithDynamicType(screen: any, componentId: string, targetTypeName: string, value: any): any {
    const rawValue = value;

    const dynamicDataType = this.getDynamicInputDataType(screen, `${componentId}_value`);

    const _dynamicDataType = (() => {
      if (
        targetTypeName?.toLowerCase() === "guid" ||
        targetTypeName?.toLowerCase() === "guid?" ||
        targetTypeName?.includes("[]")
      ) {
        return null;
      }
      switch (dynamicDataType) {
        case "String":
          return "string";
        case "Number":
          return "number";
        case "Boolean":
          return "boolean";
        case "DateTimeOffset":
          return "date";
        default:
          return null;
      }
    })();

    if (_dynamicDataType) {
      return this.convertToTypeByName(rawValue, _dynamicDataType);
    }

    if (targetTypeName) {
      return this.convertToTypeByName(rawValue, targetTypeName);
    }

    return rawValue;
  }

  private static toCamelCase = (str: string): string => {
    return str.replace(/^([A-Z])|[\s-](\w)/g, (match, p1, p2) => {
      if (p2) {
        return p2.toUpperCase();
      }

      return p1.toLowerCase();
    });
  };

  private static parseHashUrl(url: string): { pathname: string; hash: string } {
    const hashIndex = url.indexOf("#");
    if (hashIndex === -1) {
      return { pathname: url, hash: "" };
    }
    return {
      pathname: url.substring(0, hashIndex),
      hash: url.substring(hashIndex)
    };
  }

  private static getValueFromPath = (data: object, path: string, index?: number): any => {
    if (!path || !data) return data;

    // Split path and filter based on [selected] marker
    const fields: string[] = path
      .split(".")
      .filter((field: string, idx: number, array: string[]) => {
        const theFieldIndexContainingSelected = array.findIndex((x) => x.includes("[selected]"));

        if (theFieldIndexContainingSelected > -1) {
          return idx > theFieldIndexContainingSelected;
        }

        return true;
      })
      .map((x) => ReactSystemFunctions.toCamelCase(x));

    const value = fields.reduce((prev: any, curr: string) => {
      if (!prev) return "";
      let result = null;

      if (curr.endsWith("[first]")) {
        const field: string = curr.replace("[first]", "");
        result = prev?.[field]?.at?.(0);
      } else if (curr.endsWith("[last]")) {
        const field: string = curr.replace("[last]", "");
        result = prev?.[field]?.at?.(-1);
      } else if (curr.endsWith("[selected]")) {
        const field: string = curr.replace("[selected]", "");
        result = prev?.[field]?.at?.(index ?? 0);
      } else {
        const field: string = curr;
        result = prev?.[field];
      }

      return result;
    }, data);

    return value;
  };

  // public static async listMyTasks(that: any, showPool: any, page: any, pageSize: any, searchKey: any) {
  //   const user = that.props?.context?.userInfo?.username;
  //   if (user === undefined) {
  //     return [];
  //   }
  //   const request = {
  //     user,
  //     app: window.kuika.info.applicationName,
  //     searchKey,
  //     showPool,
  //     page,
  //     pageSize
  //   };
  //   const tasks = await WorkflowService.ListMyTasks(request);
  //   return tasks;
  // }

  // public static async listMyRequests(
  //   that: any,
  //   showCompleted: any,
  //   page: any,
  //   pageSize: any,
  //   processName: any,
  //   searchKey: any
  // ) {
  //   const user = that.props?.context?.userInfo?.username;
  //   if (user === undefined) {
  //     return [];
  //   }
  //   const request = {
  //     user,
  //     app: window.kuika.info.applicationName,
  //     searchKey,
  //     processName,
  //     showCompleted,
  //     page,
  //     pageSize
  //   };
  //   const tasks = await WorkflowService.ListMyRequests(request);
  //   return tasks;
  // }

  // public static async getTaskDetail(stepInstance: string) {
  //   const history = await WorkflowService.GetTaskDetail(stepInstance.toString());
  //   return history;
  // }

  // public static async showHistory(processInstance: string) {
  //   const history = await WorkflowService.ShowWorkflowHistory(processInstance);
  //   return history;
  // }

  // Authentication
  // signup({a0}, {a1}, {a2}, {a3})

  public static async signup(
    _screen: any,
    username: string,
    password: string,
    firstName: string,
    lastName: string,
    confirmEmail?: boolean,
    dontSendEmail?: boolean,
    phoneNumber?: string,
    language?: string
  ) {
    const credientials = {
      username,
      password,
      firstName,
      lastName,
      VerifyEMailAddress: confirmEmail || false,
      dontSendEmail: dontSendEmail || false,
      phoneNumber: phoneNumber || "",
      language: language || ""
    } as ISignupDto;
    LocalStorageService.clearToken();
    window.userInfo = undefined;
    const res = await UserService.SignUp(credientials);
    USER = username;
    enteredPassword = password;
    if (res?.data?.status !== undefined) {
      LocalStorageService.setLoginStatus(res.data.status);
      LocalStorageService.setVerificationUserName(
        res.data.status === EAccountStatus.TwoFactorAuthentication ? username : ""
      );
    }
    return res;
  }

  public static async isVerificationCodeValid(_screen: any, verificationCode: string) {
    TOKEN = verificationCode;
    const loginStatus = LocalStorageService.getLoginStatus();
    if (OTP_SECRET_KEY) {
      const userName = USER || LocalStorageService.getVerificationUserName();
      const otp = await this.generateOTP(userName || "");
      if (otp === verificationCode) {
        return true;
      }
    }
    if (loginStatus === EAccountStatus.TwoFactorAuthentication.toString()) return;

    const res = await UserService.VerifyVerificationCode({
      username: USER,
      verificationCode
    });
    if (KMainFunctions.IsResStatus2XX(res)) {
      LocalStorageService.setVerificationStatus("true");
      return true;
    }
    LocalStorageService.setVerificationStatus("false");
    return false;
  }

  public static async setPasswordWithVerificationCode(
    _screen: any,
    userName: string,
    verificationCode: string,
    newPassword: string,
    language?: string
  ) {
    const res = await UserService.ResetPasswordWithToken({
      UserName: userName,
      newPassword,
      token: verificationCode,
      dontSendEmail: false,
      language: language || ""
    });
    if (KMainFunctions.IsResStatus2XX(res)) {
      LocalStorageService.setResetPasswordStatus(EAccountStatus.Valid);
      return true;
    }

    LocalStorageService.setResetPasswordStatus(EAccountStatus.ForceResetPassword);
    return false;
  }

  public static async encryptedSignin(username: string, password: string) {
    USER = username;
    TOKEN = password;
    enteredPassword = password;
    return this.signin(undefined, username, password, true);
  }

  public static async signin(
    _screen: any,
    username: string,
    password: string,
    isEncrypted: boolean = false
  ): Promise<any> {
    let loginFunction = UserService.Login;
    if (!isEncrypted) {
      USER = username;
      enteredPassword = password;
      TOKEN = password;
    } else {
      loginFunction = UserService.EncryptedLogin;
    }

    await loginFunction({
      username,
      password
    }).then(
      (res) => {
        LocalStorageService.setLoginStatus(res.data?.status?.toString());
        LocalStorageService.setVerificationUserName(
          res.data?.status === EAccountStatus.TwoFactorAuthentication ? username : ""
        );
        return res;
      },
      (error) => {
        if (
          error.message === "Your password has expired" ||
          error.message === "Şifrenizin süresi doldu" ||
          error.message === "Votre mot de passe a expiré"
        ) {
          KMainFunctions.displayWarningNotification(error.message);
          LocalStorageService.setLoginStatus("1");
        }

        if (error.response?.data?.message) {
          alert(error.response.data.message);
          window.location.reload();
        }
      }
    );
    return {};
  }

  public static async SigninWithDelegation(toUserName: string): Promise<any> {
    await UserService.ReLoginWithDelegation({
      ToUserName: toUserName
    }).then(
      (res) => {
        LocalStorageService.setLoginStatus(res.data?.status?.toString());
        return res;
      },
      (error) => {
        if (
          error.message === "Your password has expired" ||
          error.message === "Şifrenizin süresi doldu" ||
          error.message === "Votre mot de passe a expiré"
        ) {
          KMainFunctions.displayWarningNotification(error.message);
          LocalStorageService.setLoginStatus("1");
        }

        if (error.response?.data?.message) {
          alert(error.response.data.message);
          window.location.reload();
        }
      }
    );
    return {};
  }

  public static async ReturnToUserSessionFromDelegation(): Promise<any> {
    await UserService.ReturnToUserSessionFromDelegation().then(
      (res) => {
        LocalStorageService.setLoginStatus(res.data?.status?.toString());
        return res;
      },
      (error) => {
        if (
          error.message === "Your password has expired" ||
          error.message === "Şifrenizin süresi doldu" ||
          error.message === "Votre mot de passe a expiré"
        ) {
          KMainFunctions.displayWarningNotification(error.message);
          LocalStorageService.setLoginStatus("1");
        }

        if (error.response?.data?.message) {
          alert(error.response.data.message);
          window.location.reload();
        }
      }
    );
    return {};
  }

  public static async signinWithVerificationCode(): Promise<any> {
    await UserService.LoginWithVerificationCode({
      username: USER,
      verificationCode: TOKEN
    }).then(
      (res) => {
        if (res.data?.status) LocalStorageService.setLoginStatus(res.data?.status?.toString());
        return res;
      },
      (error) => {
        if (error.response?.data?.message) {
          alert(error.response.data.message);
          window.location.reload();
        }
      }
    );
    return {};
  }

  public static async goToNextScreenAfterSignup(screen: any) {
    const status = LocalStorageService.getLoginStatus();
    if (status == EAccountStatus.ShouldActivated.toString()) {
      screen.props.navigator.goToVerificationCodeScreen();
    } else if (status == EAccountStatus.Valid.toString()) {
      await this.signin(this, USER, enteredPassword);
      this.goToNextScreenAfterLogin(screen);
    }
    return true;
  }

  public static goToNextScreenAfterLogin(screen: any) {
    const status = LocalStorageService.getLoginStatus();
    const uriParams = querystringify.parse(window.location.search) as {
      redirectUri?: string;
    };
    if (status == EAccountStatus.ForceResetPassword.toString()) {
      screen.props.navigator.goToResetPasswordScreen();
    } else if (
      status == EAccountStatus.ShouldActivated.toString() ||
      status == EAccountStatus.TwoFactorAuthentication.toString()
    ) {
      screen.props.navigator.goToVerificationCodeScreen();
    } else if (status == EAccountStatus.Valid.toString() && Object.keys(uriParams).length === 0) {
      screen.props.navigator.gotoStartingScreen();
    } else if (status == EAccountStatus.Valid.toString() && Object.keys(uriParams).length > 0) {
      screen.props.navigator.gotoUrl(uriParams.redirectUri);
    }
    return true;
  }

  public static goToSignInActivity(screen: any) {
    if (LocalStorageService.getResetPasswordStatus() === EAccountStatus.ForceResetPassword.toString()) {
      LocalStorageService.setResetPasswordStatus("");
      return;
    }

    if (LocalStorageService.getResetPasswordStatus() == EAccountStatus.Valid.toString()) {
      LocalStorageService.setResetPasswordStatus("");
      HelperService.gotoLogin();
    } else {
      LocalStorageService.setResetPasswordStatus("");
      LocalStorageService.clearToken();
      window.userInfo = undefined;
      screen.props.navigator.gotoStartingScreen("/");
    }
  }

  public static async goToNextScreenAfterVerifyCode(screen: any) {
    const status = LocalStorageService.getLoginStatus();
    const verificationStatus = LocalStorageService.getVerificationStatus();
    if (status == EAccountStatus.ShouldActivated.toString()) {
      await this.signin(this, USER, enteredPassword);
      this.goToNextScreenAfterLogin(screen);
    } else if (status == EAccountStatus.TwoFactorAuthentication.toString()) {
      await this.signinWithVerificationCode();
      this.goToNextScreenAfterLogin(screen);
    } else if (verificationStatus === "true") {
      screen.props.navigator.goToResetPasswordScreen();
    }
    return true;
  }

  public static goToVerificationCodeActivity(screen: {
    props: { navigator: { goToVerificationCodeScreen: () => void } };
  }) {
    const email = LocalStorageService.getForgotPasswordEmail();
    if (email) screen.props.navigator.goToVerificationCodeScreen();
  }

  public static async forgotPassword(
    _screen: any,
    username: string,
    dontSendEmail?: boolean,
    language?: string
  ): Promise<any> {
    USER = username;
    const credientials = {
      email: username,
      dontSendEmail: dontSendEmail || false,
      language: language || ""
    } as IForgotPasswordDto;

    await UserService.ForgotPassword(credientials);
  }

  public static async createUser(
    username: string,
    firstName: string,
    lastName: string,
    dontSendEmail?: boolean,
    phoneNumber?: string,
    language?: string
  ): Promise<any> {
    const credientials = {
      username,
      firstName,
      lastName,
      dontSendEmail: dontSendEmail || false,
      phoneNumber: phoneNumber || "",
      language: language || ""
    } as ICreateUserDto;

    return UserService.CreateUser(credientials);
  }

  public static async createUserWithPassword(
    username: string,
    password: string,
    firstName: string,
    lastName: string,
    dontSendEmail?: boolean,
    phoneNumber?: string,
    language?: string
  ): Promise<string> {
    const credientials = {
      username,
      password,
      firstName,
      lastName,
      dontSendEmail: dontSendEmail || false,
      phoneNumber: phoneNumber || "",
      language: language || ""
    } as ICreateUserWithPasswordDto;

    return UserService.CreateUserWithPassword(credientials);
  }

  public static async resetPassword(
    _screen: any,
    newpassword: string,
    dontSendEmail?: boolean,
    language?: string
  ): Promise<void> {
    const credientials = {
      newPassword: newpassword,
      token: TOKEN,
      UserName: USER,
      dontSendEmail: dontSendEmail || false,
      language: language || ""
    } as IResetPasswordWithTokenDto;
    enteredPassword = newpassword;
    const res = await UserService.ResetPassword(credientials);

    if (KMainFunctions.IsResStatus2XX(res)) {
      LocalStorageService.setResetPasswordStatus(EAccountStatus.Valid);
    } else {
      LocalStorageService.setResetPasswordStatus(EAccountStatus.ForceResetPassword);
    }
  }

  public static async addUserToRole(roleName: string, userName: string) {
    const credientials = {
      roleName,
      userName
    } as IUserRoleDto;

    const res = await UserService.AddUserToRole(credientials);
    if (KMainFunctions.IsResStatus2XX(res) && res.data) return res.data;
    return null;
  }

  public static async removeUserFromRole(roleName: string, userName: string) {
    const credientials = {
      roleName,
      userName
    } as IUserRoleDto;

    const res = await UserService.RemoveUserFromRole(credientials);
    if (KMainFunctions.IsResStatus2XX(res) && res.data) return res.data;
    return null;
  }

  public static async enableUser(userName: string): Promise<any> {
    let data = (await UserService.EnableUser(userName)).data;
    return data;
  }

  public static async disableUser(userName: string): Promise<any> {
    let data = (await UserService.DisableUser(userName)).data;
    return data;
  }

  // signin: _signin,
  // signup: _signup,
  // createUser: _createUser,
  // getMyUsername: _getMyUsername,
  // sendResetPasswordMail: _sendResetPasswordMail,
  // resetPassword: _resetPassword,
  // changePassword: _changePassword,
  // logout: _logout,
  // hasRole: _hasRole,
  // hasOneOfRoles: _hasOneOfRoles,

  public static sendResetPasswordMail(_val: string) {
    console.log("TODO!");
  }

  // Convertion
  public static dateAddYears(date: any, yearsToAdd: any) {
    const d = moment(date);
    d.add(yearsToAdd, "years");
    return d;
  }

  public static dateAddDays(date: any, daysToAdd: any) {
    const d = moment(date);
    d.add(daysToAdd, "days");
    return d;
  }

  public static dateAddMinutes(date: any, minutesToAdd: any) {
    const d = moment(date);
    d.add(minutesToAdd, "minutes");
    return d;
  }

  public static dateAddHours(date: any, hoursToAdd: any) {
    const d = moment(date);
    d.add(hoursToAdd, "hours");
    return d;
  }

  public static dateDiffInMinutes(date1: any, date2: any) {
    const a = moment(date1);
    const b = moment(date2);

    return b.diff(a, "minutes");
  }

  public static dateDiffInHours(date1: any, date2: any) {
    const a = moment(date1);
    const b = moment(date2);

    return b.diff(a, "hours");
  }

  public static dateDiffInDays(date1: any, date2: any) {
    const a = moment(date1);
    const b = moment(date2);

    return b.diff(a, "days");
  }

  public static value(
    screen: any,
    val: any,
    varName?: string,
    actionName?: string,
    pkFieldName?: string,
    targetField?: string
  ) {
    if (
      actionName &&
      actionName.length > 0 &&
      pkFieldName &&
      pkFieldName.length > 0 &&
      targetField &&
      targetField.length > 0 &&
      pkFieldName !== targetField
    ) {
      if (
        varName != undefined &&
        screen[`${val}_kuikaSelectBoxRef`] != undefined &&
        screen[`${val}_kuikaSelectBoxRef`] != null &&
        screen[`${val}_kuikaSelectBoxRef`].current != undefined &&
        screen[`${val}_kuikaSelectBoxRef`].current != null &&
        screen[`${val}_kuikaSelectBoxRef`].current.getAllData != undefined
      ) {
        const selectBoxOptionsProp = screen[`${val}_kuikaSelectBoxRef`].current.getAllData();
        if (selectBoxOptionsProp && selectBoxOptionsProp.find) {
          const result = selectBoxOptionsProp.find(
            (x: { [x: string]: any }) => x[pkFieldName] == screen.props.form.getFieldValue(val)
          );
          if (result && result[targetField] !== undefined) return result[targetField];
        }
      } else {
        if (Array.isArray(screen.props.form.getFieldValue(val))) {
          const result = screen.state[actionName]?.filter((x: { [x: string]: any }) =>
            screen.props.form.getFieldValue?.(val)?.includes?.(x?.[pkFieldName])
          );
          if (result && result.length > 0 && result?.[0] && result?.[0]?.[targetField] !== undefined) {
            return result?.map?.((x: { [x: string]: any }) => x?.[targetField]);
          }
        }
        const result = screen.state[actionName].find(
          (x: { [x: string]: any }) => x[pkFieldName] == screen.props.form.getFieldValue(val)
        );
        if (result && result[targetField] !== undefined) return result[targetField];
      }
    }
    if (
      varName != undefined &&
      screen[`${val}_kuikaMultiSelectRef`] != undefined &&
      screen[`${val}_kuikaMultiSelectRef`] != null &&
      screen[`${val}_kuikaMultiSelectRef`].current != undefined &&
      screen[`${val}_kuikaMultiSelectRef`].current != null &&
      screen[`${val}_kuikaMultiSelectRef`].current.getAllData != undefined
    ) {
      const selectBoxOptionsProp = screen[`${val}_kuikaMultiSelectRef`].current.getAllData();
      if (selectBoxOptionsProp && selectBoxOptionsProp.find) {
        const result = selectBoxOptionsProp?.filter((x: { [x: string]: any }) =>
          screen.props.form.getFieldValue?.(val)?.includes?.(x?.[pkFieldName])
        );
        if (result && result.length > 0 && result?.[0] && result?.[0]?.[targetField] !== undefined) {
          return result?.map?.((x: { [x: string]: any }) => x?.[targetField]);
        }
      }
    }

    if (
      varName != undefined &&
      screen[`${val}_kuikaNoneRef`] != undefined &&
      screen[`${val}_kuikaNoneRef`] != null &&
      screen[`${val}_kuikaNoneRef`].current != undefined &&
      screen[`${val}_kuikaNoneRef`].current != null
    ) {
      if (varName == "fileId") return screen[`${val}_kuikaNoneRef`].current.state.fileGuid;
      if (varName == "fileName") return screen[`${val}_kuikaNoneRef`].current.state.fileToBeUpload.name;
    }

    if (
      varName != undefined &&
      screen[`${val}_kuikaRecaptchaRef`] != undefined &&
      screen[`${val}_kuikaRecaptchaRef`] != null &&
      screen[`${val}_kuikaRecaptchaRef`].current != undefined &&
      screen[`${val}_kuikaRecaptchaRef`].current != null
    ) {
      if (varName == "token") return screen[`${val}_kuikaRecaptchaRef`].current.state.token;
    }

    if (
      varName != undefined &&
      screen[`${val}_kuikaTableRef`] != undefined &&
      screen[`${val}_kuikaTableRef`] != null &&
      screen[`${val}_kuikaTableRef`].current != undefined &&
      screen[`${val}_kuikaTableRef`].current != null &&
      screen[`${val}_kuikaTableRef`].current.getSelectedRowData != undefined
    ) {
      const currentTableRef = screen[`${val}_kuikaTableRef`].current;

      const parentTableId = currentTableRef?.getParentTableIdIfExist();
      const newVal = val.replace(currentTableRef?.props?.id, parentTableId);
      const parentTableRef = this.getParentOfBaseTableElementRef(screen, newVal);

      if (parentTableRef?.current) {
        const dataSourcePath = currentTableRef.props?.dataSourceOriginal?.match(
          /\[datafield:((?:(?!\[datafield:).)*)\]/
        );
        const dataSourcePathValue = dataSourcePath ? dataSourcePath[1] : "";

        const nestedTableRowIdx = parentTableRef.current.getNestedTableSelectedIndex(
          document.getElementById(parentTableId)
        );

        if (
          nestedTableRowIdx !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue] !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx] !== undefined
        ) {
          return parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx][varName];
        }
      }

      if (varName.charAt(0) === ".") varName = varName.substr(1);
      if (varName === "k_rowIndex") {
        return screen[`${val}_kuikaTableRef`].current.getSelectedIndex();
      }
      if (varName === "k_columnIndex") {
        return screen[`${val}_kuikaTableRef`].current.getSelectedColumnIndex();
      }
      if (varName === "selectedValues") {
        return screen[`${val}_kuikaTableRef`].current.getSelectedValues();
      }
      if (varName === "dataSource") {
        return screen[`${val}_kuikaTableRef`].current.getDataSource();
      }
      const rowData = screen[`${val}_kuikaTableRef`].current.getSelectedRowData();
      if (!rowData) return undefined;
      if (_.isEmpty(varName)) return rowData;
      // Use path resolving for nested fields with modifiers like [first], [last], [selected]
      return varName.includes(".") || varName.includes("[")
        ? ReactSystemFunctions.getValueFromPath(
            rowData,
            varName,
            screen[`${val}_kuikaTableRef`].current.getSelectedIndex()
          )
        : rowData[varName];
    }

    if (
      varName != undefined &&
      screen[`${val}_kuikaKanbanBoardRef`] != undefined &&
      screen[`${val}_kuikaKanbanBoardRef`] != null &&
      screen[`${val}_kuikaKanbanBoardRef`].current != undefined &&
      screen[`${val}_kuikaKanbanBoardRef`].current != null
    ) {
      if (varName === "laneId" || targetField === "k_laneId") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getLaneId();
      }

      if (varName === "laneTitle" || targetField === "k_laneTitle") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getLaneTitle();
      }

      if (varName === "laneLabel" || targetField === "k_laneLabel") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getLaneLabel();
      }

      if (varName === "laneDroppable" || targetField === "k_laneDroppable") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getLaneDroppable();
      }

      if (varName === "laneIndex" || targetField === "k_laneIndex") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getLaneIndex();
      }

      if (varName === "laneTargetIndex" || targetField === "k_laneTargetIndex") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getLaneTargetIndex();
      }

      if (varName === "cardId" || targetField === "k_cardId") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardId();
      }

      if (varName === "cardLaneId" || targetField === "k_cardLaneId") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardLaneId();
      }

      if (varName === "cardTargetLaneId" || targetField === "k_cardTargetLaneId") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardTargetLaneId();
      }

      if (varName === "cardTitle" || targetField === "k_cardTitle") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardTitle();
      }

      if (varName === "cardLabel" || targetField === "k_cardLabel") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardLabel();
      }

      if (varName === "cardSubTitle" || targetField === "k_cardSubTitle") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardSubTitle();
      }

      if (varName === "cardDescription" || targetField === "k_cardDescription") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardDescription();
      }

      if (varName === "cardEscalationText" || targetField === "k_cardEscalationText") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardEscalationText();
      }

      if (varName === "cardDraggable" || targetField === "k_cardDraggable") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardDraggable();
      }

      if (varName === "cardIndex" || targetField === "k_cardIndex") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardIndex();
      }

      if (varName === "cardTargetIndex" || targetField === "k_cardTargetIndex") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardTargetIndex();
      }

      if (varName.charAt(0) === ".") varName = varName.substr(1);

      const keys = varName.split(".");

      // if selected card/lane data requested
      if (keys.length > 1) {
        let value = keys.reduce(
          (obj, key) => obj[key?.replaceAll("?", "")],
          screen[`${val}_kuikaKanbanBoardRef`].current
        );

        return value;
      }

      return (
        screen[`${val}_kuikaKanbanBoardRef`].current.getSelectedData() &&
        screen[`${val}_kuikaKanbanBoardRef`].current.getSelectedData()[varName]
      );
    }

    if (
      varName != undefined &&
      screen[`${val}_kuikaNodeTreeRef`] != undefined &&
      screen[`${val}_kuikaNodeTreeRef`] != null &&
      screen[`${val}_kuikaNodeTreeRef`].current != undefined &&
      screen[`${val}_kuikaNodeTreeRef`].current != null
    ) {
      if (varName.charAt(0) === ".") varName = varName.substr(1);

      const keys = varName.split(".");

      if (keys.length > 1) {
        let value = keys.reduce((obj, key) => obj[key?.replaceAll("?", "")], screen[`${val}_kuikaNodeTreeRef`].current);

        return value;
      }

      return (
        screen[`${val}_kuikaNodeTreeRef`].current.getSelectedData() &&
        screen[`${val}_kuikaNodeTreeRef`].current.getSelectedData()[varName]
      );
    }

    if (
      varName != undefined &&
      screen[`${val}_kuikaGalleryViewRef`] != undefined &&
      screen[`${val}_kuikaGalleryViewRef`] != null &&
      screen[`${val}_kuikaGalleryViewRef`].current != undefined &&
      screen[`${val}_kuikaGalleryViewRef`].current != null &&
      screen[`${val}_kuikaGalleryViewRef`].current.getSelectedRowData != undefined
    ) {
      const currentGalleryRef = screen[`${val}_kuikaGalleryViewRef`].current;

      const parentTableId = currentGalleryRef?.getParentTableIdIfExist?.();
      const newVal = val.replace(currentGalleryRef?.props?.id, parentTableId);

      const parentTableRef = this.getParentOfBaseTableElementRef(screen, newVal);

      if (parentTableRef?.current) {
        const dataSourcePath = currentGalleryRef.props?.dataSourceOriginal?.match(
          /\[datafield:((?:(?!\[datafield:).)*)\]/
        );
        const dataSourcePathValue = dataSourcePath ? dataSourcePath[1] : "";

        const nestedTableRowIdx = parentTableRef.current.getNestedTableSelectedIndex(
          document.getElementById(parentTableId)
        );

        if (
          nestedTableRowIdx !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue] !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx] !== undefined
        ) {
          return parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx][varName];
        }
      }

      if (varName.charAt(0) === ".") varName = varName.substr(1);

      if (varName === "k_rowIndex") {
        return screen[`${val}_kuikaGalleryViewRef`].current.getSelectedIndex();
      }

      const rowData = screen[`${val}_kuikaGalleryViewRef`].current.getSelectedRowData();
      if (!rowData) return undefined;
      if (_.isEmpty(varName)) return rowData;
      // Use path resolving for nested fields with modifiers like [first], [last], [selected]
      return varName.includes(".") || varName.includes("[")
        ? ReactSystemFunctions.getValueFromPath(
            rowData,
            varName,
            screen[`${val}_kuikaGalleryViewRef`].current.getSelectedIndex()
          )
        : rowData[varName];
    }
    if (
      varName != undefined &&
      screen[`${val}_kuikaCarouselRef`] != undefined &&
      screen[`${val}_kuikaCarouselRef`] != null &&
      screen[`${val}_kuikaCarouselRef`].current != undefined &&
      screen[`${val}_kuikaCarouselRef`].current != null &&
      screen[`${val}_kuikaCarouselRef`].current.getSelectedRowData != undefined
    ) {
      const currentCarouselRef = screen[`${val}_kuikaCarouselRef`].current;

      const parentTableId = currentCarouselRef?.getParentTableIdIfExist?.();
      const newVal = val.replace(currentCarouselRef?.props?.id, parentTableId);

      const parentTableRef = this.getParentOfBaseTableElementRef(screen, newVal);

      if (parentTableRef?.current) {
        const dataSourcePath = currentCarouselRef.props?.dataSourceOriginal?.match(
          /\[datafield:((?:(?!\[datafield:).)*)\]/
        );
        const dataSourcePathValue = dataSourcePath ? dataSourcePath[1] : "";

        const nestedTableRowIdx = parentTableRef.current.getNestedTableSelectedIndex(
          document.getElementById(parentTableId)
        );

        if (
          nestedTableRowIdx !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue] !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx] !== undefined
        ) {
          return parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx][varName];
        }
      }

      if (varName.charAt(0) === ".") varName = varName.substr(1);

      if (varName === "k_rowIndex") {
        return screen[`${val}_kuikaCarouselRef`].current.getSelectedIndex();
      }

      const rowData = screen[`${val}_kuikaCarouselRef`].current.getCarouselCurrentData();
      if (!rowData) return undefined;
      if (_.isEmpty(varName)) return rowData;
      // Use path resolving for nested fields with modifiers like [first], [last], [selected]
      return varName.includes(".") || varName.includes("[")
        ? ReactSystemFunctions.getValueFromPath(
            rowData,
            varName,
            screen[`${val}_kuikaCarouselRef`].current.getSelectedIndex()
          )
        : rowData[varName];
    }
    if (
      varName != undefined &&
      screen[`${val}_kuikaFlexGridRef`] != undefined &&
      screen[`${val}_kuikaFlexGridRef`] != null &&
      screen[`${val}_kuikaFlexGridRef`].current != undefined &&
      screen[`${val}_kuikaFlexGridRef`].current != null &&
      screen[`${val}_kuikaFlexGridRef`].current.getSelectedRowData != undefined
    ) {
      const currentFlexGridRef = screen[`${val}_kuikaFlexGridRef`].current;

      const parentTableId = currentFlexGridRef?.getParentTableIdIfExist?.();
      const newVal = val.replace(currentFlexGridRef?.props?.id, parentTableId);

      const parentTableRef = this.getParentOfBaseTableElementRef(screen, newVal);

      if (parentTableRef?.current) {
        const dataSourcePath = currentFlexGridRef.props?.dataSourceOriginal?.match(
          /\[datafield:((?:(?!\[datafield:).)*)\]/
        );
        const dataSourcePathValue = dataSourcePath ? dataSourcePath[1] : "";

        const nestedTableRowIdx = parentTableRef.current.getNestedTableSelectedIndex(
          document.getElementById(parentTableId)
        );

        if (
          nestedTableRowIdx !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue] !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx] !== undefined
        ) {
          return parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx][varName];
        }
      }

      if (varName.charAt(0) === ".") varName = varName.substr(1);

      if (varName === "k_rowIndex") {
        return screen[`${val}_kuikaFlexGridRef`].current.getSelectedIndex();
      }

      const rowData = screen[`${val}_kuikaFlexGridRef`].current.getSelectedRowData();
      if (!rowData) return undefined;
      if (_.isEmpty(varName)) return rowData;
      // Use path resolving for nested fields with modifiers like [first], [last], [selected]
      return varName.includes(".") || varName.includes("[")
        ? ReactSystemFunctions.getValueFromPath(
            rowData,
            varName,
            screen[`${val}_kuikaFlexGridRef`].current.getSelectedIndex()
          )
        : rowData[varName];
    }
    if (
      varName != undefined &&
      screen[`${val}_kuikaHorizontalTableRef`] != undefined &&
      screen[`${val}_kuikaHorizontalTableRef`] != null &&
      screen[`${val}_kuikaHorizontalTableRef`].current != undefined &&
      screen[`${val}_kuikaHorizontalTableRef`].current != null &&
      screen[`${val}_kuikaHorizontalTableRef`].current.getSelectedRowData != undefined
    ) {
      const currentHorizontalTableRef = screen[`${val}_kuikaHorizontalTableRef`].current;

      const parentTableId = currentHorizontalTableRef?.getParentTableIdIfExist?.();
      const newVal = val.replace(currentHorizontalTableRef?.props?.id, parentTableId);

      const parentTableRef = this.getParentOfBaseTableElementRef(screen, newVal);

      if (parentTableRef?.current) {
        const dataSourcePath = currentHorizontalTableRef.props?.dataSourceOriginal?.match(
          /\[datafield:((?:(?!\[datafield:).)*)\]/
        );
        const dataSourcePathValue = dataSourcePath ? dataSourcePath[1] : "";

        const nestedTableRowIdx = parentTableRef.current.getNestedTableSelectedIndex(
          document.getElementById(parentTableId)
        );

        if (
          nestedTableRowIdx !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue] !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx] !== undefined
        ) {
          return parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx][varName];
        }
      }

      if (varName.charAt(0) === ".") varName = varName.substr(1);

      if (varName === "k_rowIndex") {
        return screen[`${val}_kuikaHorizontalTableRef`].current.getSelectedIndex();
      }

      const rowData = screen[`${val}_kuikaHorizontalTableRef`].current.getSelectedRowData();
      if (!rowData) return undefined;
      if (_.isEmpty(varName)) return rowData;
      // Use path resolving for nested fields with modifiers like [first], [last], [selected]
      return varName.includes(".") || varName.includes("[")
        ? ReactSystemFunctions.getValueFromPath(
            rowData,
            varName,
            screen[`${val}_kuikaHorizontalTableRef`].current.getSelectedIndex()
          )
        : rowData[varName];
    }
    if (
      varName != undefined &&
      screen[`${val}_kuikaMarqueeRef`] != undefined &&
      screen[`${val}_kuikaMarqueeRef`] != null &&
      screen[`${val}_kuikaMarqueeRef`].current != undefined &&
      screen[`${val}_kuikaMarqueeRef`].current != null &&
      screen[`${val}_kuikaMarqueeRef`].current.getSelectedRowData != undefined
    ) {
      if (varName.charAt(0) === ".") varName = varName.substr(1);

      if (varName === "k_rowIndex") {
        return screen[`${val}_kuikaMarqueeRef`].current.getSelectedIndex();
      }

      const rowData = screen[`${val}_kuikaMarqueeRef`].current.getSelectedRowData();
      if (!rowData) return undefined;
      // Use path resolving for nested fields with modifiers like [first], [last], [selected]
      return varName.includes(".") || varName.includes("[")
        ? ReactSystemFunctions.getValueFromPath(
            rowData,
            varName,
            screen[`${val}_kuikaMarqueeRef`].current.getSelectedIndex()
          )
        : rowData[varName];
    }
    if (
      varName != undefined &&
      screen[`${val}_kuikaPaginationRef`] != undefined &&
      screen[`${val}_kuikaPaginationRef`] != null
    ) {
      if (
        screen[`${val}_kuikaPaginationRef`].current != undefined &&
        screen[`${val}_kuikaPaginationRef`].current != null &&
        screen[`${val}_kuikaPaginationRef`].current.getCurrentData != undefined
      ) {
        if (varName.charAt(0) === ".") varName = varName.substr(1);
        return (
          screen[`${val}_kuikaPaginationRef`].current.getCurrentData() &&
          screen[`${val}_kuikaPaginationRef`].current.getCurrentData()[varName]
        );
      }
      if (varName === "current") return 1;
      return 10;
    }
    if (
      varName != undefined &&
      screen[`${val}_kuikaSelectBoxRef`] != undefined &&
      screen[`${val}_kuikaSelectBoxRef`] != null &&
      screen[`${val}_kuikaSelectBoxRef`].current != undefined &&
      screen[`${val}_kuikaSelectBoxRef`].current != null &&
      screen[`${val}_kuikaSelectBoxRef`].current.getSearchValue != undefined
    ) {
      if (targetField && targetField.charAt(0) === ".") targetField = targetField.substr(1);
      if (targetField === "k_searchValue") {
        return screen[`${val}_kuikaSelectBoxRef`].current.getSearchValue();
      }
    } else if (
      varName != undefined &&
      screen[`${val}_kuikaMultiSelectRef`] != undefined &&
      screen[`${val}_kuikaMultiSelectRef`] != null &&
      screen[`${val}_kuikaMultiSelectRef`].current != undefined &&
      screen[`${val}_kuikaMultiSelectRef`].current != null &&
      screen[`${val}_kuikaMultiSelectRef`].current.getSearchValue != undefined
    ) {
      if (targetField && targetField.charAt(0) === ".") targetField = targetField.substr(1);
      if (targetField === "k_searchValue") {
        return screen[`${val}_kuikaMultiSelectRef`].current.getSearchValue();
      }
    } else if (
      varName != undefined &&
      screen[`${val}_kuikaAutoCompleteRef`] != undefined &&
      screen[`${val}_kuikaAutoCompleteRef`] != null &&
      screen[`${val}_kuikaAutoCompleteRef`].current != undefined &&
      screen[`${val}_kuikaAutoCompleteRef`].current != null &&
      screen[`${val}_kuikaAutoCompleteRef`].current.getSearchValue != undefined
    ) {
      if (targetField && targetField.charAt(0) === ".") targetField = targetField.substr(1);
      if (targetField === "k_searchValue") {
        return screen[`${val}_kuikaAutoCompleteRef`].current.getSearchValue();
      }
    } else if (
      varName != undefined &&
      screen[`${val}_kuikaGoogleMapsRef`] != undefined &&
      screen[`${val}_kuikaGoogleMapsRef`] != null &&
      screen[`${val}_kuikaGoogleMapsRef`].current != undefined &&
      screen[`${val}_kuikaGoogleMapsRef`].current != null &&
      screen[`${val}_kuikaGoogleMapsRef`].current.getLatValue != undefined
    ) {
      if (targetField && targetField.charAt(0) === ".") targetField = targetField.substr(1);
      if (varName === "Latitude") {
        return screen[`${val}_kuikaGoogleMapsRef`].current.getLatValue();
      }
      if (varName === "Longitude") {
        return screen[`${val}_kuikaGoogleMapsRef`].current.getLngValue();
      }
      if (varName.charAt(0) === ".") varName = varName.substr(1);
      return (
        screen[`${val}_kuikaGoogleMapsRef`].current.getSelectedRowData() &&
        screen[`${val}_kuikaGoogleMapsRef`].current.getSelectedRowData()[varName]
      );
    } else if (
      varName != undefined &&
      screen[`${val}_kuikaChatRef`] != undefined &&
      screen[`${val}_kuikaChatRef`] != null &&
      screen[`${val}_kuikaChatRef`].current != undefined &&
      screen[`${val}_kuikaChatRef`].current != null &&
      screen[`${val}_kuikaChatRef`].current.getMessage != undefined &&
      screen[`${val}_kuikaChatRef`].current.getCurrentlyEditingMessageId != undefined
    ) {
      if (varName === "message" || targetField === "k_message") {
        return screen[`${val}_kuikaChatRef`].current.getMessage();
      }

      if (varName === "currentlyEditingMessageId" || targetField === "k_currentlyEditingMessageId") {
        return screen[`${val}_kuikaChatRef`].current.getCurrentlyEditingMessageId();
      }

      if (varName === "messageIdToBeDeleted" || targetField === "k_messageIdToBeDeleted") {
        return screen[`${val}_kuikaChatRef`].current.messageIdToBeDeleted;
      }
    } else if (
      varName != undefined &&
      screen[`${val}_kuikaPlacesAutocompleteInputRef`] != undefined &&
      screen[`${val}_kuikaPlacesAutocompleteInputRef`] != null &&
      screen[`${val}_kuikaPlacesAutocompleteInputRef`].current != undefined &&
      screen[`${val}_kuikaPlacesAutocompleteInputRef`].current != null &&
      screen[`${val}_kuikaPlacesAutocompleteInputRef`].current.getLatitude != undefined
    ) {
      if (varName === "Latitude" || targetField === "k_latitude") {
        return screen[`${val}_kuikaPlacesAutocompleteInputRef`].current.getLatitude();
      }
      if (varName === "Longitude" || targetField === "k_longitude") {
        return screen[`${val}_kuikaPlacesAutocompleteInputRef`].current.getLongitude();
      }
      if (varName === "Address" || targetField === "k_address") {
        return screen[`${val}_kuikaPlacesAutocompleteInputRef`].current.getAddress();
      }
    } else if (
      varName != undefined &&
      screen[`${val}_kuikaLocationPickerComponentRef`] &&
      screen[`${val}_kuikaLocationPickerComponentRef`] != undefined &&
      screen[`${val}_kuikaLocationPickerComponentRef`] != null &&
      screen[`${val}_kuikaLocationPickerComponentRef`].current != undefined &&
      screen[`${val}_kuikaLocationPickerComponentRef`].current != null &&
      screen[`${val}_kuikaLocationPickerComponentRef`].current.getLatitude != undefined
    ) {
      if (varName === "Latitude" || targetField === "k_latitude") {
        return screen[`${val}_kuikaLocationPickerComponentRef`].current.getLatitude();
      }
      if (varName === "Longitude" || targetField === "k_longitude") {
        return screen[`${val}_kuikaLocationPickerComponentRef`].current.getLongitude();
      }
    } else if (
      varName != undefined &&
      screen[`${val}_kuikaStepperComponentRef`] &&
      screen[`${val}_kuikaStepperComponentRef`] != undefined &&
      screen[`${val}_kuikaStepperComponentRef`] != null &&
      screen[`${val}_kuikaStepperComponentRef`].current != undefined &&
      screen[`${val}_kuikaStepperComponentRef`].current != null &&
      screen[`${val}_kuikaStepperComponentRef`].current.getIndex != undefined
    ) {
      let index = screen[`${val}_kuikaStepperComponentRef`].current.getIndex();
      if (index === null || index === undefined || index < 0) return;

      return index + 1;
    } else if (
      screen[`${val}_kuikaWebViewRef`] &&
      screen[`${val}_kuikaWebViewRef`] != undefined &&
      screen[`${val}_kuikaWebViewRef`] != null &&
      screen[`${val}_kuikaWebViewRef`].current != undefined &&
      screen[`${val}_kuikaWebViewRef`].current != null &&
      screen[`${val}_kuikaWebViewRef`].current.getUrl != undefined
    ) {
      if (varName === "url" || targetField === "k_url") {
        return screen[`${val}_kuikaWebViewRef`].current.getUrl();
      }
    } else if (
      screen?.[`${val}_kuikaCalendarRef`]?.current != undefined &&
      screen?.[`${val}_kuikaCalendarRef`]?.current != null
    ) {
      if (varName === "panel" || varName === "k_panel" || targetField === "k_panel") {
        return screen[`${val}_kuikaCalendarRef`].current?.getPanel?.();
      }

      if (varName === "currentDate" || varName === "k_currentDate" || targetField === "k_currentDate") {
        return screen[`${val}_kuikaCalendarRef`].current?.getCurrentDate?.();
      }

      if (varName === "currentDay" || varName === "k_currentDay" || targetField === "k_currentDay") {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentDay?.();
      }

      if (varName === "currentMonth" || varName === "k_currentMonth" || targetField === "k_currentMonth") {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentMonth?.();
      }

      if (varName === "currentYear" || varName === "k_currentYear" || targetField === "k_currentYear") {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentYear?.();
      }

      if (
        varName === "currentRangeStart" ||
        varName === "k_currentRangeStart" ||
        targetField === "k_currentRangeStart"
      ) {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentRangeStart?.();
      }

      if (varName === "currentRangeEnd" || varName === "k_currentRangeEnd" || targetField === "k_currentRangeEnd") {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentRangeEnd?.();
      }

      if (
        varName === "k_eventId" ||
        varName === "k_currentEvent.k_eventId" ||
        targetField === "k_eventId" ||
        targetField === "k_currentEvent.k_eventId"
      ) {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentEvent?.()?.id;
      }

      if (
        varName === "k_eventTitle" ||
        varName === "k_currentEvent.k_eventTitle" ||
        targetField === "k_eventTitle" ||
        targetField === "k_currentEvent.k_eventTitle"
      ) {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentEvent?.()?.title;
      }

      if (
        varName === "k_eventStartDate" ||
        varName === "k_currentEvent.k_eventStartDate" ||
        targetField === "k_eventStartDate" ||
        targetField === "k_currentEvent.k_eventStartDate"
      ) {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentEvent?.()?.start;
      }

      if (
        varName === "k_eventEndDate" ||
        varName === "k_currentEvent.k_eventEndDate" ||
        targetField === "k_eventEndDate" ||
        targetField === "k_currentEvent.k_eventEndDate"
      ) {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentEvent?.()?.end;
      }

      if (
        varName === "k_eventColor" ||
        varName === "k_currentEvent.k_eventColor" ||
        targetField === "k_eventColor" ||
        targetField === "k_currentEvent.k_eventColor"
      ) {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentEvent?.()?.backgroundColor;
      }

      return screen[`${val}_kuikaCalendarRef`].current.getCurrentEvent?.()?.[varName?.toLowerCase()];
    } else if (
      screen[`${val}_kuikaStopwatchRef`] &&
      screen[`${val}_kuikaStopwatchRef`] != undefined &&
      screen[`${val}_kuikaStopwatchRef`] != null &&
      screen[`${val}_kuikaStopwatchRef`].current != undefined &&
      screen[`${val}_kuikaStopwatchRef`].current != null &&
      screen[`${val}_kuikaStopwatchRef`].current.getValue != undefined
    ) {
      return screen[`${val}_kuikaStopwatchRef`].current.getValue();
    } else if (
      screen[`${val}_kuikaTreeRef`] &&
      screen[`${val}_kuikaTreeRef`] != undefined &&
      screen[`${val}_kuikaTreeRef`] != null &&
      screen[`${val}_kuikaTreeRef`].current != undefined &&
      screen[`${val}_kuikaTreeRef`].current != null
    ) {
      if (varName === "checkedKeys" && screen[`${val}_kuikaTreeRef`].current.getCheckedKeys != undefined) {
        return screen[`${val}_kuikaTreeRef`].current.getCheckedKeys();
      }
      if (screen[`${val}_kuikaTreeRef`].current.getSelectedData != undefined) {
        const selectedData = screen[`${val}_kuikaTreeRef`].current.getSelectedData();
        if (targetField && selectedData) {
          return selectedData[targetField];
        }
        if (varName && selectedData) {
          return selectedData[varName];
        }
        if (!varName && screen[`${val}_kuikaTreeRef`].current.getSelectedKey != undefined) {
          return screen[`${val}_kuikaTreeRef`].current.getSelectedKey();
        }
      }
    } else if (
      screen[`${val}_kuikaDirectoryRef`] &&
      screen[`${val}_kuikaDirectoryRef`] != undefined &&
      screen[`${val}_kuikaDirectoryRef`] != null &&
      screen[`${val}_kuikaDirectoryRef`].current != undefined &&
      screen[`${val}_kuikaDirectoryRef`].current != null
    ) {
      const varNameLower = varName?.toLowerCase();
      if (varNameLower === "nodeid") return screen[`${val}_kuikaDirectoryRef`].current.getSelectedNodeId();
      if (varNameLower === "nodename") return screen[`${val}_kuikaDirectoryRef`].current.getSelectedNodeName();
      if (varNameLower === "isnodebranch") return screen[`${val}_kuikaDirectoryRef`].current.getSelectedNodeIsBranch();
      if (varNameLower === "selecteddocumentid")
        return screen[`${val}_kuikaDirectoryRef`].current.getSelectedDocumentId();
      if (varNameLower === "selectedfolderid") return screen[`${val}_kuikaDirectoryRef`].current.getSelectedFolderId();
    } else if (varName === undefined) return val;

    const formVal = screen.props.form.getFieldValue(val);
    if (formVal == undefined && varName == "checked")
      return screen.props.form.getFieldValue(val.replace("_value", "_checked"));
    if (val.endsWith("_value") && varName == "checked") return formVal ?? false;
    if (formVal != null && val.endsWith("_value") && varName !== "value") {
      // Multiple value component
      return formVal[varName];
    }
    if (formVal != null && val.endsWith("_selectedkey") && varName == "selectedKey") {
      // Menu Component Case!
      return formVal[varName];
    }

    return formVal;
  }

  public static isFieldVisible(id: string): boolean {
    let element = document.querySelector(`[id~='${id}']`);
    if (!element) {
      element = document.querySelector(`[data-id~='${id}']`);
    }
    if (!element) return false;

    const style = window.getComputedStyle(element);
    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      style.opacity !== "0" &&
      parseFloat(style.opacity || "1") > 0.1
    );
  }

  public static dateIsWeekDay = (date: string | number | Date) => {
    if (!date) return false;
    return moment(date).isoWeekday() <= 5;
  };

  public static dateGetDay = (val1, val2) => {
    if (!val1 || !val2) return 0;
    if (typeof val1 === "string" && moment(val1).isValid()) {
      return moment(val1).date();
    }
    return moment(val2).date();
  };

  public static dateGetMonth = (val1, val2) => {
    if (!val1 || !val2) return 0;
    if (typeof val1 === "string" && moment(val1).isValid()) {
      return moment(val1).month() + 1;
    }
    return moment(val2).month() + 1;
  };

  public static dateGetYear = (val1, val2) => {
    if (!val1 || !val2) return 0;
    if (typeof val1 === "string" && moment(val1).isValid()) {
      return moment(val1).year();
    }
    return moment(val2).year();
  };

  public static toString = (_screen: any, val: any) => {
    if (val === null || val === undefined) return ""; // false değeri için böyle kalmalı
    if (Array.isArray(val)) {
      const returnValue: any[] = [];
      for (let i = 0; i < val.length; i++) {
        const vi: any = val[i];
        returnValue.push(vi.toString());
      }
      return returnValue;
    }
    return val.toString();
  };

  public static toBoolean = (_screen: any, val: any) => {
    if (!val) return false;
    if (val instanceof Boolean) return val;
    if (val instanceof String) {
      val = val.toLowerCase();
    }
    switch (val) {
      case true:
      case "true":
      case "on":
      case "yes":
      case 1:
        return true;
      default:
        return false;
    }
  };

  public static toDecimal = (_screen: any, val: any) => {
    if (!val) return val;

    if (val instanceof Date) {
      return val.getTime();
    }

    if (val instanceof moment) {
      return val.valueOf();
    }

    if ((parseFloat(val).toString() === "NaN") === true) {
      return val;
    }

    return parseFloat(val);
  };

  public static toDate(_screen: any, value: any) {
    if (!value) return null;

    if (value instanceof moment) return value;

    const dateFormat = this.getFormat(value);
    if (dateFormat === null) return null;
    return moment(value, dateFormat);
  }

  private static getDateFormat() {
    return {
      kuika_hhmm: "HH:mm",
      kuika_hhmmss: "HH:mm:ss",
      kuika_ddmmyyyy: "DD.MM.YYYY",
      kuika_ddmmyyyyhh: "DD.MM.YYYY HH",
      kuika_ddmmyyyyhhmm: "DD.MM.YYYY HH:mm",
      kuika_ddmmyyyyhhmmss: "DD.MM.YYYY HH:mm:ss",
      kuika_ddmmyyyymmddhhmmss: "YYYY-MM-DD HH:mm:ss",
      iso_int: "YYYY-MM-DD",
      short_date: "DD/MM/YYYY",
      iso_date_time: "YYYY-MM-DDTHH:mm:ss",
      iso_date_time_utc: "YYYY-MM-DDTHH:mm:ssZ"
    };
  }

  private static getFormat(d: moment.MomentInput) {
    const dateFormats = this.getDateFormat();
    for (const prop in dateFormats) {
      if (moment(d, dateFormats[prop], true).isValid()) {
        return dateFormats[prop];
      }
    }
    return null;
  }

  private static isValidDateWithFormat(value: any): boolean {
    return DateFormatValidator.isValid(value);
  }

  public static toInteger = (screen: any, val: any, varName?: string) => {
    if (!val) return val;
    if (varName && varName.length) {
      return this.toInteger(screen, this.value(screen, val, varName));
    }
    if (val === "") return val;
    if (val === true) return 1;
    if (val === false) return 0;
    if (val === "true") return 1;
    if (val === "false") return 0;
    if (val === "True") return 1;
    if (val === "False") return 0;
    if ((parseInt(val, 10).toString() === "NaN") === true) {
      return val;
    }
    return parseInt(val, 10);
  };

  public static toDouble = (screen: any, val: any, varName?: string) => {
    if (!val) return val;
    if (varName && varName.length) {
      return this.toDouble(screen, this.value(screen, val, varName));
    }
    if (val === "") return val;
    if (val === true) return 1;
    if (val === false) return 0;
    if (val === "true") return 1;
    if (val === "false") return 0;
    if (val === "True") return 1;
    if (val === "False") return 0;
    if ((parseFloat(val).toString() === "NaN") === true) {
      return val;
    }
    return parseFloat(val);
  };

  public static toGuid(_screen: any, val: string) {
    if (!val) return null;
    if (!Guid.isGuid(val)) return null;

    return Guid.parse(val);
  }

  public static async navigateToTask(
    screen: any,
    _callback: any,
    StepKey: string,
    fromScreen: string,
    toScreen: string,
    _toUrl: string,
    openAs: string | null,
    navigationKuikaId: string | null,
    _title: string | null,
    _placement: string | null,
    _closable: string | null,
    _width: string | null,
    _height: string | null,
    executePageInitActionsAfterClose: boolean,
    disableSmartExecutePageInit: boolean
  ) {
    var isCallerMicroApp = window.location.hash !== "";
    const stepInfo = (await WorkflowService.GetNavigationParameters(StepKey, isCallerMicroApp)).data;

    if (stepInfo?.canNavigateToTask === false) {
      this.notify(screen, "You are not authorized to claim this task.", "warning", "bottom-right", 3, null, null, null);
      return;
    }

    const screenName =
      stepInfo.screenToNavigate?.length > 0
        ? stepInfo.screenToNavigate
        : (await WorkflowService.GetStepScreen(stepInfo.processId, stepInfo.stepId, stepInfo.appId)).data;

    if (screenName !== "") {
      let calculatedScreenName = screenName;
      let baseUrl = KuikaAppManager.GetFrontEndUrl();
      const urlHasHash = window.location.hash !== "";
      const hasMicroAppScreen = stepInfo.microAppContainingScreen && stepInfo.microAppContainingScreen !== "";
      const webViewUrl = stepInfo.webViewUrl;
      const screenExistsInApp = this.doesScreenExist(screenName);

      if (hasMicroAppScreen) {
        calculatedScreenName = `${stepInfo.microAppContainingScreen}#/${screenName}`;
        if (urlHasHash) {
          const indexOfHash = window.location.href.indexOf(`/${stepInfo.microAppContainingScreen}#`);
          baseUrl = window.location.href.substring(0, indexOfHash);
        }
      } else if (!screenExistsInApp && webViewUrl && webViewUrl !== "") {
        const isSameOriginWithVDir = this.isSameOriginAndVirtualDir(webViewUrl, window.location.href);
        if (!isSameOriginWithVDir) {
          window.open(webViewUrl, "_blank");
          return;
        }
      }
      if (openAs === "newTab" || openAs === "newWindow") {
        window.open(`${baseUrl}/${calculatedScreenName}?workflowStepInstanceId=${StepKey}`, "_blank");
        return;
      }
      if (openAs === "currentPage") {
        if (urlHasHash) {
          const { history } = screen.props.navigator;
          history.push({
            pathname: screenName,
            search: `workflowStepInstanceId=${StepKey}`,
            state: {
              screenInputs: {}
            }
          });
        } else {
          const newPath = `${baseUrl}/${calculatedScreenName}?workflowStepInstanceId=${StepKey}`;
          window.location.assign(newPath);
        }
        return;
      }

      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(screenName, "workflowStepInstanceId", StepKey);
      screen.setState({ wfScreenName: screenName });
      return this.navigate(
        screen,
        _callback,
        fromScreen,
        screenName,
        _toUrl,
        openAs,
        navigationKuikaId,
        _title,
        _placement,
        _closable,
        _width,
        _height,
        executePageInitActionsAfterClose,
        disableSmartExecutePageInit
      );
    }
    if (stepInfo.webViewUrl && stepInfo.webViewUrl !== "") {
      window.location.replace(stepInfo.webViewUrl);
    }
  }

  public static async loadWorkflowStepInstanceParameters(screen: any, StepKey: string) {
    const stepdata = (await WorkflowService.GetTaskInstanceParameters(StepKey)).data;
    if (stepdata) {
      if (stepdata.showMessage) {
        this.notify(this, stepdata.message, "warning", "bottom-right", 3, null, null, null);
      }
      if (stepdata.redirect) {
        screen.props.navigator.gotoStartingScreen();
      }
      return stepdata;
    }
    return undefined;
  }

  public static getProcessParameterValue(form: any, screenName, diId, propertyName) {
    if (form) {
      const value = form.getFieldValue(`${screenName}_${diId}_${propertyName}`);
      if (value && value !== "") return value;
      return "";
    }
    return "";
  }

  public static getStepDataValue(bag: ITaskDataParameters, key: string) {
    if (bag !== undefined) {
      if (key == "StepInstanceId") return bag.workflowStepInstanceId;
      if (key == "ProcessInstanceId") return bag.processInstance;
      if (key == "showResumeProcessButton") return bag.showResumeProcessButton;
      if (bag.stepData && bag.stepData.length > 0) {
        const data = bag.stepData.find((b) => b.key === key);
        if (data !== undefined) return data.value;
      }
    }
    return "";
  }

  public static postWebKitMessage(scope: any, messageBody) {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosKuikaListener)
      window.webkit.messageHandlers.iosKuikaListener.postMessage(messageBody);
    // {"actionType":"CLOSE_WEBVIEW"}
    else if (window.AndroidKuikaListener) window.AndroidKuikaListener.postMessage(JSON.stringify(messageBody));
    else console.log("Mobile message handlers not supported by browser");
  }

  // obsolete
  // public static getStepScreenId = (processId, stepId): string => {
  //   const cnf = ProcessConfig.processScreens as IProcessConfigData[];
  //   const screenConfig = cnf.find((s) => s.processId == processId && s.stepId === stepId);
  //   if (screenConfig !== undefined) return screenConfig.screenId;
  //   return undefined;
  // };

  public static getScreenNameById = (screenId: string): string => {
    const screenList = this.getScreenList();
    const screenName = getDictionaryValueByKey(screenList, screenId);
    return screenName;
  };

  public static getScreenNameByActiveUserRoles = (): string => {
    const roleStartingScreenIdList = this.getRoleStartingScreenIdList();
    const userRoles = window?.userInfo?.roles;
    let result = "";
    userRoles?.forEach((role: { name: string }) => {
      const screenId = getDictionaryValueByKey(roleStartingScreenIdList, role?.name);
      if (screenId !== undefined) {
        const startingScreenName = this.getScreenNameById(screenId);
        if (startingScreenName !== undefined && startingScreenName !== "") {
          result = startingScreenName;
        }
      }
    });
    return result;
  };

  public static getScreenList = () => {
    return [ { key: "2edda8df-be2e-4bed-a32d-0a72431124d2", value: "Anasayfacopy"}, { key: "9aa15566-a262-4473-ae5e-0af3df07c57c", value: "STDReportsUser"}, { key: "4f2015e0-6ed5-4a73-80db-107336b192c1", value: "TeslimTesellumWeb"}, { key: "24ad6e55-9c27-42e9-b01c-1527be6482ae", value: "Layout2"}, { key: "bc257cf6-c2fb-4a64-848f-15e8c82821b6", value: "STDReportsUsercopy"}, { key: "2768be76-7a72-4bd9-a17b-1aa830570a47", value: "AddForeCast"}, { key: "67792066-a548-46dd-8502-1f72e01c6759", value: "STDOrders_List"}, { key: "85482f60-0d55-4f84-b64d-2197b53119f9", value: "LabelPdf"}, { key: "2a421d27-5669-40d8-bc2f-28eb0ee951be", value: "DuzeltilecekKirilimEkrani"}, { key: "d1072b2a-a06d-4424-b519-29c492fb3aae", value: "MailGrubuYetkiliEkle"}, { key: "a738ebc0-3cff-4c3c-8ede-2f43396f90b5", value: "BoxLogs"}, { key: "cedec7ae-ae55-4d5a-b8d7-429dca35f03d", value: "STDNoScreen_Form"}, { key: "37a390a5-7f3e-4918-8e1e-43462585e6d3", value: "TeslimTesellumFinal"}, { key: "7be4db66-57a9-4ef6-af89-4847603eb469", value: "STDUsers_List"}, { key: "ff5a97e6-0b63-4d7e-bb17-48c64621c37c", value: "UserGroup_Listcopy"}, { key: "d9f7f616-b9d3-4628-b10a-4ae9f30dfb9e", value: "TestReport"}, { key: "02007d63-de46-4dea-aa56-5057b2185e93", value: "STDOrders_Form"}, { key: "a8e7184a-8ca1-4baa-a79e-5224c7f760db", value: "Eslestirme"}, { key: "85e7bfcf-6b32-43eb-994b-523de104431a", value: "Station_List"}, { key: "8cbe5dec-963a-4166-9b91-5cb9b0c58ab4", value: "Orders_List"}, { key: "8eb905b4-97e7-4157-8785-5cd98d08534e", value: "STDUserGroup_List"}, { key: "90693512-0d8e-4e54-8b76-604e3f623ca3", value: "Signup"}, { key: "ea854ccb-1dec-49f5-952d-65d46480b672", value: "Signin"}, { key: "fe2718ff-f2a7-496e-953a-68a2b32bbd33", value: "STDOrders_FormQR"}, { key: "2aa578ba-64ae-444e-bf0c-6b49faded0d0", value: "NavigateScreen"}, { key: "5c94e817-d115-4cc3-87d2-6e211715b14a", value: "STDReportsUserOld"}, { key: "36a903c7-578c-445d-bc87-6f348a8038aa", value: "STDSapUser_Form"}, { key: "0072b419-0953-4851-ac2f-764d4996a126", value: "STDCustomer_Form"}, { key: "eb08de4f-e852-4f29-83dd-77a7cc88367d", value: "EslestirmeTeslimTesellum"}, { key: "c726cdfe-1159-484b-a975-7909745fd243", value: "STDProducts_Form"}, { key: "f257c14c-b595-485d-a92f-80f2a482f492", value: "STDSapUser_View"}, { key: "4b50067a-3641-4614-8012-84e360e00520", value: "STDBoxes_Details"}, { key: "02175b47-f23f-4a4f-9765-8fb6d0ee269e", value: "User_Form"}, { key: "f80b2ff0-3ce1-4ac2-879b-93b18524c7a7", value: "ResetPassword"}, { key: "19533074-9804-44f8-9ecb-9af2591174ba", value: "ForgotPassword"}, { key: "c0f4c58e-3da8-42f9-8e7f-9e42d732db0d", value: "STDBoxes_Form_Manuel"}, { key: "bce53a31-6547-4850-9ffe-9eb9bd974ead", value: "Screen_Group_Employee_Grid_Card_with_Search"}, { key: "c0468bcc-5ba3-47d1-83ca-a52ba73fe896", value: "STDBoxes_List"}, { key: "919da34b-358b-45db-9c43-a5a3010539cc", value: "DefaLogoutScreen"}, { key: "614aeee8-c85d-4920-b161-ab0ded3caa87", value: "OrdersReport"}, { key: "3d1d8b67-97b8-42af-8472-aca30f17f0ad", value: "STDBoxes_Form"}, { key: "cce1483f-2d35-4657-85a4-acec7badbab9", value: "CustomerProducts"}, { key: "542a7b58-0e50-42ef-b264-b838697a2c5b", value: "SQLQueryScreen"}, { key: "36921a36-84d0-49ca-bfe8-bb037ce580ca", value: "AdminPanel"}, { key: "67573b22-f708-4360-aaa6-bb5bc64a6cf6", value: "STDBoxes_Listcopy"}, { key: "82987f54-faaf-41ab-865d-bba77c9ee9b2", value: "STDMailGroups_Form"}, { key: "9aa62eba-eebd-4cfd-9b50-bc60ca01aec1", value: "STDUserGroups_Form"}, { key: "5126fd7f-18b2-46a0-8e08-beb630ced3af", value: "Layout1"}, { key: "ae860b30-035a-4473-b505-bf9572a91efc", value: "Station_View"}, { key: "7731b02f-7aed-4f3e-b0fd-bff5263e539f", value: "STDProducts_View"}, { key: "35fa0d18-2bab-43bb-b2e6-c41caa5503d8", value: "UserGroup_List"}, { key: "1026f290-33c5-43d2-b801-c44c7703fbc9", value: "Anasayfa"}, { key: "3601f100-90a6-4b88-b53e-c69cba1ee02a", value: "STDProducts_Equivalence_Form"}, { key: "20e0f1e4-3b0d-4c88-89e5-cbecebc47bad", value: "EslestirmeOld"}, { key: "d9e2bafd-6515-4b93-a765-cc4cc51c371e", value: "Customer_List"}, { key: "744be0e6-a4a5-4d36-8c78-cd3b0bf065fb", value: "STDNoScreen_List"}, { key: "71244b4e-0ca0-4d23-8bbf-d6ad312232b6", value: "STDCustomer_View"}, { key: "2dccbc4e-18a3-4cbd-8a36-d9cfd03c8987", value: "LeftMenu"}, { key: "9a5c1b9d-4652-47b5-8f16-e006246fac06", value: "STDNoScreen_View"}, { key: "5673960b-53a8-4505-a6d0-e682fdfbe22a", value: "STDSapUser_List"}, { key: "a35fc565-0093-4abe-a6b4-e9e68bed6673", value: "MailGroups"}, { key: "9d94cbad-3e3c-4422-8c57-ec1fbb0248f8", value: "NewLayout"}, { key: "0b873b5e-ee3c-4450-83ad-ed366e24f238", value: "STDOrders_View"}, { key: "00e7abc8-3ee2-44ae-9a84-ee94bce02986", value: "CustomerByProductId"}, { key: "749208c1-5ba4-4e59-a30b-f11c14f46594", value: "VerificationCode"}, { key: "75ad0fa2-1f0a-4287-9693-f3c592365262", value: "Screen_Group_Grid_Card_with_Search"}, { key: "3efe2ca4-dc71-414c-98d0-fcb5dba1d32b", value: "STDStations_Form"}, { key: "469228e2-dca2-49ec-98e4-fe50fc9db742", value: "Product_List"},];
  };

  public static getRoleStartingScreenIdList = () => {
    return [];
  };

  private static doesScreenExist = (screenName: string): boolean => {
    if (!screenName) return false;
    const screens = this.getScreenList() || [];
    return screens.some((s: { key?: string; value?: string }) => {
      const keyMatch = s?.key?.toLowerCase() === screenName.toLowerCase();
      const valueMatch = s?.value?.toLowerCase() === screenName.toLowerCase();
      return keyMatch || valueMatch;
    });
  };

  private static originWithVirtualDirectory = (rawUrl: string): string | null => {
    try {
      const parsed = new URL(rawUrl, window.location.href);
      const segments = parsed.pathname.split("/").filter(Boolean);
      const virtualDir = segments.length > 0 ? `/${segments[0]}` : "";
      return `${parsed.origin}${virtualDir}`.toLowerCase();
    } catch (err) {
      return null;
    }
  };

  private static isSameOriginAndVirtualDir = (targetUrl: string, currentUrl: string): boolean => {
    const target = this.originWithVirtualDirectory(targetUrl);
    const current = this.originWithVirtualDirectory(currentUrl);
    return !!target && !!current && target === current;
  };

  // Navigation
  // 0: {name: "fromScreenId", Typename: "String", cardinality: 1, isMandatory: false, ownerClassName: null, …}
  // 1: {name: "toScreenId", Typename: "String", cardinality: 1, isMandatory: false, ownerClassName: null, …}
  // 2: {name: "toUrl", Typename: "String", cardinality: 1, isMandatory: false, ownerClassName: null, …}
  // 3: {name: "openAs", Typename: "String", cardinality: 1, isMandatory: false, ownerClassName: null, …}
  // 4: {name: "navigationKuikaId", Typename: "String", cardinality: 1, isMandatory: false, ownerClassName: null, …}
  public static navigate(
    screen: any,
    _callback: any,
    fromScreen: string,
    toScreen: string,
    _toUrl: string,
    openAs: string | null,
    navigationKuikaId: string | null,
    _title: string | null,
    _placement: string | null,
    _closable: string | null,
    _width: string | null,
    _height: string | null,
    executePageInitActionsAfterClose: boolean,
    disableSmartExecutePageInit: boolean = false
  ): string {
    const { history } = screen.props.navigator;

    let screenInputsQuery = "";
    if (window.kuika?.navigationScreenInputs && !_.isEmpty(window.kuika?.navigationScreenInputs)) {
      screenInputsQuery = querystringify.stringify(window.kuika?.navigationScreenInputs, true);
    }

    if (!window.kuika) window.kuika = {};

    if ((screen.props.navigator as any)?.history?.location?.search?.includes("redirectOnMobile=true")) {
      this.postWebKitMessage(null, {
        actionType: "NAVIGATE",
        openAs: `${openAs}`,
        width: `${_width}`,
        height: `${_height}`,
        placement: `${_placement}`,
        toScreen: `${toScreen}`,
        triggerPageInit: `${executePageInitActionsAfterClose}`,
        disableSmartExecutePageInit: `${disableSmartExecutePageInit}`,
        screenInputs: `${screenInputsQuery}`
      });
      return "";
    }

    switch (openAs) {
      case "currentPage":
        history.push({
          pathname: toScreen,
          search: screenInputsQuery,
          state: {
            screenInputs: {
              // TODO
            }
          }
        });

        if (fromScreen === toScreen || toScreen === window.kuika?.navigationComponentMasterScreen) {
          window.location.reload();
        }
        // delete window.kuika?.navigationComponentMasterScreen;

        window.kuika.pageInitCallers ??= {};
        window.kuika.pageInitCallers[fromScreen] = executePageInitActionsAfterClose;

        break;

      case "newTab":
      case "newWindow":
        HelperService.redirectToPath(`/${toScreen}${screenInputsQuery}`, {
          openInNewTab: true
        });
        break;

      default:
        window.kuika.disableSmartExecutePageInit ??= {};
        window.kuika.disableSmartExecutePageInit[fromScreen] = disableSmartExecutePageInit ?? false;
        if (!window.kuika?.navigationComponentMasterScreen) window.kuika.navigationComponentMasterScreen = fromScreen;
        else if (
          window.kuika.navigationComponentMasterScreen &&
          fromScreen !== window.kuika.navigationComponentMasterScreen
        ) {
          window.kuika.navigationComponentMasterScreen = fromScreen;
        }
        const obj = {};
        obj[`NavVisible${navigationKuikaId}`] = true;
        screen.setState(obj);
        break;
    }

    return "";
  }

  // GoBack
  public static goBack(
    screen: { props: { onClose: () => void; navigator: KNavigator } },
    triggerParentAppGoBack: boolean = false
  ) {
    if (screen?.props?.onClose) {
      KuikaAppManager.hideSpinner(screen);
      screen.props.onClose();
      return;
    }

    if (triggerParentAppGoBack && this.getIsMicroApp() && window.parentScreen) {
      const parentScreen = window.parentScreen;
      ReactSystemFunctions.goBack(parentScreen);
      return;
    }

    if (screen.props.navigator.goBack) {
      if ((screen.props.navigator as any)?.history?.location?.search?.includes("redirectOnMobile=true")) {
        this.postWebKitMessage(null, { actionType: "GO_BACK" });
      } else {
        const isWebView = window.location !== window.parent.location;
        if (isWebView) {
          const hasHistory = (screen.props.navigator as any)?.history?.action === "PUSH";
          const parentWindow = window.parent;

          if (parentWindow) {
            const antDrawerWrapperBody = parentWindow.document.querySelector(".ant-drawer-wrapper-body");
            const antModal = parentWindow.document.querySelector(".ant-modal-root");

            if (antModal) {
              const antModalClose: any = antModal.querySelector(".ant-modal-close");

              if (antModalClose) {
                hasHistory ? screen.props.navigator.goBack() : antModalClose.click();
              }
            } else if (antDrawerWrapperBody) {
              const antDrawerClose: any = antDrawerWrapperBody.querySelector(".ant-drawer-close");

              if (antDrawerClose) {
                hasHistory ? screen.props.navigator.goBack() : antDrawerClose.click();
              }
            } else {
              screen.props.navigator.goBack();
            }
          }
        } else {
          screen.props.navigator.goBack();
        }
      }
    }
  }

  public static getMyUsername(): string {
    return window?.userInfo?.username;
  }

  public static getMyUserId(): string | undefined {
    return window?.userInfo?.id;
  }

  public static getMyFirstName(): string {
    return window?.userInfo?.firstName;
  }

  public static getMyLastName(): string {
    return window?.userInfo?.lastName;
  }

  public static getMyFullName(): string {
    const f = window?.userInfo?.firstName;
    const l = window?.userInfo?.lastName;
    return f && l ? `${f} ${l}` : f || l;
  }

  public static getMyPhoneNumber(): string {
    return window?.userInfo?.phoneNumber;
  }

  public static getMyRoleNames(): string {
    return window?.userInfo?.roleNames;
  }

  public static getIsMicroApp(): boolean {
    return KuikaAppManager.IsWebComponent();
  }

  public static async logout(): Promise<void> {
    await UserService.Logout();
  }

  public static async signinwithMSAL(): Promise<void> {
    sessionStorage.setItem("msalRedirectionStarted", "loaded");
    HelperService.gotoLogin();
  }

  // Notification
  // sendPushNotificationToUsername: _sendPushNotificationToUsername,
  // sendPushNotificationToApp: _sendPushNotificationToApp,
  public static notify(
    screen: any,
    message: string,
    type: "success" | "danger" | "info" | "default" | "warning" | "custom",
    position:
      | "top-left"
      | "top-right"
      | "top-center"
      | "bottom-left"
      | "bottom-right"
      | "bottom-center"
      | "top"
      | "bottom",
    duration: number,
    backgroundColor: string | null,
    textColor: string | null,
    fontSize: number | null
  ): boolean | undefined {
    if (message === undefined || message === null) message = "";
    if (typeof message === "object") message = JSON.stringify(message);
    else if (typeof message !== "string" && (message as any).toString) message = (message as any).toString();
    if (message) {
      // todo message = ReactSystemFunctions.translateCustomActions(screen.ml, "{actionID}", screen.this.defaultML, message);

      if (duration === null || duration === undefined || duration < 0) {
        switch (type) {
          case "success": {
            duration = KMainFunctions.NOTIFY_ACTION_DEFAULT_SUCCESS_DURATION;
            break;
          }
          case "danger": {
            duration = KMainFunctions.NOTIFY_ACTION_DEFAULT_ERROR_DURATION;
            break;
          }
          case "info": {
            duration = KMainFunctions.NOTIFY_ACTION_DEFAULT_INFO_DURATION;
            break;
          }
          case "warning": {
            duration = KMainFunctions.NOTIFY_ACTION_DEFAULT_WARNING_DURATION;
            break;
          }
          case "default":
          default: {
            duration = KMainFunctions.NOTIFY_ACTION_DEFAULT_DEFAULT_DURATION;
            break;
          }
        }
      }
      if (position === "top") position = "top-center";
      if (position === "bottom") position = "bottom-center";

      const instanceId = Guid.create().toString();

      let customStyle: string | undefined;

      if (type === "custom") {
        type = "default";

        const style = document.getElementById("dynamic_style");

        customStyle = `
          .custom-notification-${instanceId} {
            background-color: ${backgroundColor} !important;
            border-left: unset !important;

            .notification__close {
              opacity: 0 !important;
            }

            .notification__message {
              color: ${textColor} !important;
              font-size: ${fontSize}px !important;
            }
          }
        `
          .replace(" ", "")
          .trim()
          .replace(/(\r\n|\n|\r)/gm, "");

        style.innerHTML += customStyle;
      }

      setTimeout(() => {
        if (duration < 0) duration = 0;
        if (position === "top") position = "top-center";
        if (position === "bottom") position = "bottom-center";
        if (type === "custom") {
          type = "default";

          setTimeout(
            () => {
              const style = document.getElementById("dynamic_style");
              style.innerHTML = style.innerHTML.replace(customStyle, "");
            },
            duration * 1000 + 1000
          );
        }

        store.addNotification({
          title: "",
          message: message.replace(/&nbsp;/g, ""),
          type,
          container: position,
          animationIn: [`custom-notification-${instanceId}`, "animated", "flipInX"],
          animationOut: [`custom-notification-${instanceId}`, "animated", "fadeOut"],
          dismiss: {
            duration: duration * 1000,
            pauseOnHover: true,
            showIcon: true
          }
        });
      }, 150);
      return true;
    }
  }

  // Device

  public static printCurrentScreen() {}

  public static getPhotoFromGallery = () =>
    new Promise((resolve, reject) => {
      let listener = false;
      const input = document.createElement("input");
      input.classList.add("kuika-take-photo-gallery");
      input.setAttribute("type", "file");
      input.setAttribute("name", "kuika_photo_take");
      input.style.display = "none";
      input.accept = "image/*,application/pdf";
      listener = true;

      window.addEventListener("focus", () => {
        setTimeout(() => {
          if (listener) {
            listener = false;
            let files = Array.from(input.files);
            if (files.length === 0) {
              resolve("");
            }
          }
        }, 1000);
      });

      input.onchange = () => {
        let files = Array.from(input.files);
        if (files.length === 0) {
          resolve("");
        }

        const [file] = files;

        const reader = new FileReader();
        reader.addEventListener("load", (e) => {
          resolve(e.target.result);
        });
        reader.addEventListener("error", (e) => {
          reject(e.target.error);
        });

        reader.readAsDataURL(file);
      };

      input.click();
    });

  public static getPhotosFromGallery = (
    editPhoto: boolean,
    quality: string
  ): Promise<{
    data: {
      dataBase64: string;
      name: string;
      size: number;
      fileExtension: string;
    }[];
  }> => {
    return new Promise((resolve) => {
      const input = document.createElement("input");
      input.type = "file";
      input.multiple = true;
      input.accept = "image/*";

      const processImage = async (
        file: File
      ): Promise<{
        dataBase64: string;
        name: string;
        size: number;
        fileExtension: string;
      }> => {
        return new Promise((processResolve) => {
          const img = new Image();
          const reader = new FileReader();

          reader.onload = (e) => {
            img.src = e.target.result as string;
            img.onload = () => {
              if (quality === "default" || quality === "original") {
                processResolve({
                  dataBase64: e.target.result as string,
                  name: file.name,
                  size: file.size,
                  fileExtension: KMainFunctions.getExtensionByMimeType(file.name, file.type)
                });
                return;
              }

              let maxLength = 400;
              let maxSize = 102410;

              if (quality === "low") {
                maxLength = 400;
                maxSize = 102410;
              } else if (quality === "medium") {
                maxLength = 800;
                maxSize = 204820;
              } else if (quality === "high") {
                maxLength = 1200;
                maxSize = 409640;
              }

              const canvas = document.createElement("canvas");
              let width = img.width;
              let height = img.height;

              if (width > maxLength || height > maxLength) {
                if (width > height) {
                  height = Math.round((height * maxLength) / width);
                  width = maxLength;
                } else {
                  width = Math.round((width * maxLength) / height);
                  height = maxLength;
                }
              }

              canvas.width = width;
              canvas.height = height;
              const ctx = canvas.getContext("2d", {
                willReadFrequently: true,
                alpha: true
              });
              if (ctx) {
                ctx.clearRect(0, 0, width, height);
                ctx.imageSmoothingQuality = "high";
                ctx.drawImage(img, 0, 0, width, height);
              }

              let compressionQuality = 1.0;
              let dataUrl: string;
              do {
                dataUrl = canvas.toDataURL(file.type || "image/jpeg", compressionQuality);
                const size = Math.round((dataUrl.length - 22) * 0.75);
                if (size > maxSize) {
                  compressionQuality -= 0.1;
                } else {
                  break;
                }
              } while (compressionQuality >= 0.1);

              processResolve({
                dataBase64: dataUrl,
                name: file.name,
                size: Math.round((dataUrl.length - 22) * 0.75),
                fileExtension: KMainFunctions.getExtensionByMimeType(file.name, file.type)
              });
            };
          };
          reader.readAsDataURL(file);
        });
      };

      input.onchange = async () => {
        try {
          const files = Array.from(input.files);
          const filePromises = files.map(processImage);

          const results = await Promise.all(filePromises);
          resolve({ data: results.filter((result) => result !== null) });
        } catch (error) {
          resolve({ data: [] });
        }
      };

      input.oncancel = () => {
        resolve({ data: [] });
      };

      input.click();
    });
  };

  public static uploadFile = () => {
    return new Promise((resolve) => {
      let input = document.createElement("input");
      input.type = "file";
      input.multiple = false;
      input.accept = "*";

      input.onchange = () => {
        let files = Array.from(input.files);
        if (files.length === 0) {
          resolve("");
        }

        const [file] = files;

        const reader = new FileReader();
        reader.addEventListener("load", (e) => {
          resolve(e.target.result);
        });
        reader.addEventListener("error", (e) => {
          KMainFunctions.exceptionHandler(e);
          resolve({});
        });
        reader.readAsDataURL(file);
      };

      input.oncancel = () => {
        resolve({});
      };

      input.click();
    });
  };

  public static uploadFileWithInfo = (fileType?: string) => {
    return new Promise((resolve) => {
      let input = document.createElement("input");
      input.type = "file";
      input.multiple = false;

      input.accept = fileType || "*";

      input.onchange = () => {
        let files = Array.from(input.files);
        if (files.length === 0) {
          resolve({
            data: {}
          });
        }

        const [file] = files;
        var resultObj = {
          data: {}
        } as any;
        resultObj.data.name = file.name;
        resultObj.data.type = file.type;
        resultObj.data.size = file.size;
        const reader = new FileReader();
        reader.addEventListener("load", (e) => {
          resultObj.data.data = e.target.result;
          resolve(resultObj);
        });
        reader.addEventListener("error", (e) => {
          KMainFunctions.exceptionHandler(e);
          resolve({});
        });
        reader.readAsDataURL(file);
      };

      input.oncancel = () => {
        resolve({});
      };

      input.click();
    });
  };

  public static uploadFilesWithInfo = (fileType?: string) => {
    return new Promise((resolve) => {
      let input = document.createElement("input");
      input.type = "file";
      input.multiple = true;

      input.accept = fileType || "*";

      input.onchange = () => {
        let files = Array.from(input.files);
        if (files.length === 0) {
          resolve({
            data: []
          });
          return;
        }

        const results: any[] = [];
        let loadedCount = 0;

        files.forEach((file) => {
          const resultObj: any = {
            name: file.name,
            type: file.type,
            size: file.size,
            data: null
          };
          const reader = new FileReader();
          reader.addEventListener("load", (e) => {
            resultObj.data = e.target.result;
            results.push(resultObj);
            loadedCount++;
            if (loadedCount === files.length) {
              resolve({ data: results });
            }
          });
          reader.addEventListener("error", (e) => {
            KMainFunctions.exceptionHandler(e);
            loadedCount++;
            if (loadedCount === files.length) {
              resolve({ data: results });
            }
          });
          reader.readAsDataURL(file);
        });
      };

      input.oncancel = () => {
        resolve({ data: [] });
      };

      input.click();
    });
  };

  public static takePhotoKuikaFunction = (comp: {
    props: { showPhotoTake: () => void; hidePhotoTake: () => void };
    forceUpdate: () => void;
  }) =>
    new Promise((resolve, _reject) => {
      comp.props.showPhotoTake();
      setTimeout(() => {
        const imgNode: HTMLImageElement = document
          ?.getElementsByClassName("react-html5-camera-photo")[0]
          ?.getElementsByTagName("img")[0];
        if (imgNode) {
          imgNode.addEventListener("load", () => {
            comp.props.hidePhotoTake();
            comp.forceUpdate();
            resolve(imgNode.src);
          });
        }
        const myInterval = setInterval(() => {
          const imgNode: HTMLCollectionOf<Element> = document.getElementsByClassName("react-html5-camera-photo");
          if (!imgNode.length) {
            clearInterval(myInterval);
            resolve("");
          }
        }, 1000);
      }, 350);
    });

  // openInBrowser: _openInBrowser,
  public static openInBrowser(val: unknown, openAs: "current" | "newtab") {
    if (typeof val !== "string") {
      KMainFunctions.displayErrorNotification("Invalid URL");
      return;
    }

    let url: string = val;

    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      url = `https://${url}`;
    }

    if (!KMainFunctions.getIsValidHttpUrl(url)) {
      KMainFunctions.displayErrorNotification(`Invalid URL: "${url}"`);
      return;
    }

    if (openAs === "newtab") {
      setTimeout(() => window.open(url, "_blank").focus(), 100);
    } else {
      setTimeout(() => window.open(url, "_self").focus(), 100);
    }
  }

  public static openInWebView(val: string) {
    let url: string = val;
    if (url === undefined || url === null || url === "") {
      window.open("", "_blank").focus();
      return;
    }

    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      url = `https://${url}`;
    }

    setTimeout(() => window.open(url, "_blank").focus(), 100);
  }

  public static async printPdf(base64: string, screen: any) {
    const hash = window.location.hash || "";
    const isCallerMicroApp = hash !== "";
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    let base64WithoutPrefix = base64;
    if (base64.startsWith("data:application/pdf;base64,")) {
      base64WithoutPrefix = base64.substring("data:application/pdf;base64,".length);
    }

    const byteCharacters = atob(base64WithoutPrefix);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);

    if (isMobile) {
      window.open(blobUrl, "_blank");
      return;
    }

    if (isCallerMicroApp) {
      const pdfDataUrl = base64.startsWith("data:application/pdf;base64,")
        ? base64
        : `data:application/pdf;base64,${base64}`;
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(`<iframe width='100%' height='100%' src='${pdfDataUrl}'></iframe>`);
      }
      return;
    }

    const printJSModule = (await import("print-js")).default;
    printJSModule({
      printable: base64WithoutPrefix,
      type: "pdf",
      base64: true
    });
  }

  public static printExcel(base64: any) {
    console.log("TODO: SYSTEM FUNCTION NOT IMPLEMENTED YET: printExcel");
    console.log(base64);
  }

  // Local Storage
  // addToBag: _addToBag,
  // removeFromBag: _removeFromBag,
  // clearBag: _clearBag,

  // Location

  public static async locationCoordinatesOfAdress(address: string): Promise<any> {
    if (address === undefined || address === "") {
      return { data: { latitude: "0", longitude: "0" } };
    }
    if (!this.isDocumentReady()) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          const res = await this.locationCoordinatesOfAdress(address);
          resolve(res);
        }, 100);
      });
    }

    const geocoder = new google.maps.Geocoder();

    try {
      const response = await geocoder.geocode({ address });
      if (response?.results.length > 0) {
        const lat = response.results[0].geometry?.location?.lat();
        const lng = response.results[0].geometry?.location?.lng();
        const result = { data: { latitude: lat, longitude: lng } };
        return result;
      }
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: { latitude: undefined, longitude: undefined } };
    }
  }

  public static async locationAdressOfCoordinates(latitude: any, longitude: any): Promise<any> {
    if (latitude === undefined || latitude === "" || longitude === undefined || latitude === "") {
      return { data: { address: "", city: "", state: "", country: "" } };
    }
    if (!this.isDocumentReady()) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          const res = await this.locationAdressOfCoordinates(latitude, longitude);
          resolve(res);
        }, 100);
      });
    }

    const geocoder = new google.maps.Geocoder();

    try {
      const response = await geocoder.geocode({
        location: { lat: Number(latitude), lng: Number(longitude) }
      });

      let city: any;
      let state: any;
      let country: any;
      let address: any;
      let neighborhood: any;
      let street: any;
      let postalCode: any;

      const r = response.results[0];
      if (r) {
        address = r.formatted_address;
        const { address_components } = r;
        if (address_components?.length > 0) {
          for (let i = 0; i < address_components.length; i++) {
            if (address_components[i]?.types?.length > 0) {
              for (let j = 0; j < address_components[i].types.length; j++) {
                if (address_components[i]?.types) {
                  switch (address_components[i].types[j]) {
                    case "administrative_area_level_1":
                      city = address_components[i].long_name;
                      break;
                    case "administrative_area_level_2":
                      state = address_components[i].long_name;
                      break;
                    case "country":
                      country = address_components[i].long_name;
                      break;
                    case "administrative_area_level_4":
                      neighborhood = address_components[i].long_name;
                      break;
                    case "route":
                      street = address_components[i].long_name;
                      break;
                    case "postal_code":
                      postalCode = address_components[i].long_name;
                      break;
                  }
                }
              }
            }
          }
        }
      }
      const result = {
        data: {
          address,
          city,
          state,
          country,
          neighborhood,
          street,
          postalCode
        }
      };
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return {
        data: {
          address: undefined,
          city: undefined,
          state: undefined,
          country: undefined
        }
      };
    }
  }

  public static async locationGetCurrentCoordinates(): Promise<any> {
    try {
      if (ReactSystemFunctions.isMapWithLiveLocationTrackingPresented()) {
        if (watchPositionId == null) {
          const firstPosition = await this.initializeWatchPositionAndGetFirstPosition();
          return { data: firstPosition };
        }
        return {
          data: watchPositionData ?? {
            accuracy: undefined,
            latitude: undefined,
            longitude: undefined
          }
        };
      }

      if (watchPositionId != null) {
        ReactSystemFunctions.clearWatchPosition();
      }

      const coordinates = await this.locationGetCurrentCoordinatesPromise();
      const result = {
        data: {
          accuracy: coordinates?.coords?.accuracy,
          latitude: coordinates?.coords?.latitude,
          longitude: coordinates?.coords?.longitude
        }
      };
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return {
        data: {
          accuracy: undefined,
          latitude: undefined,
          longitude: undefined
        }
      };
    }
  }

  static async locationGetCurrentCoordinatesPromise(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true, // Use high-accuracy mode, if available
        timeout: 10000, // Set a timeout of 10 seconds
        maximumAge: 0 // Force a fresh location
      });
    });
  }

  private static isMapWithLiveLocationTrackingPresented = () => {
    const mapElements = document.getElementsByClassName("kuika_maps_with_live_location");

    if (mapElements && mapElements.length > 0) {
      return true;
    }
    return false;
  };

  private static initializeWatchPositionAndGetFirstPosition = (): Promise<{
    accuracy: number;
    latitude: number;
    longitude: number;
  }> => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation is not supported"));
        return;
      }

      watchPositionId = navigator.geolocation.watchPosition(
        (position) => {
          watchPositionData = position.coords;
          ReactSystemFunctions.dispatchLocationUpdate(position.coords);
          resolve({
            accuracy: position.coords.accuracy,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          });
        },
        (error) => {
          reject(error);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    });
  };

  private static dispatchLocationUpdate = (coords: GeolocationCoordinates) => {
    const event = new CustomEvent("kuika-watch-position-update", {
      detail: {
        latitude: coords.latitude,
        longitude: coords.longitude,
        accuracy: coords.accuracy
      }
    });
    window.dispatchEvent(event);
  };

  private static clearWatchPosition = () => {
    if (navigator.geolocation && watchPositionId !== null) {
      navigator.geolocation.clearWatch(watchPositionId);
      watchPositionId = null;
      watchPositionData = null;
    }
  };

  // UI
  public static changeVisibilityOf(screen: any, stateName: string, isVisible: string, _arg: string = "") {
    const obj = {};
    obj[stateName] = isVisible;
    screen.setState(obj);
  }

  public static toggleVisibilityOf(screen: any, stateName: string) {
    const obj = {};
    let isVisible = screen.state[stateName];
    if (isVisible === "hidden") {
      isVisible = "visible";
    } else {
      isVisible = "hidden";
    }
    obj[stateName] = isVisible;
    screen.setState(obj);
  }

  public static toggleEditabilityOf(screen: any, stateName: string) {
    const obj = {};
    let isVisible = screen.state[stateName];
    if (isVisible === "disabled") {
      isVisible = "enabled";
    } else {
      isVisible = "disabled";
    }
    obj[stateName] = isVisible;
    screen.setState(obj);
  }

  public static changeEnabledOf(screen: any, stateName: string, isEnabled: string) {
    const obj = {};
    obj[stateName] = isEnabled;
    screen.setState(obj);
  }

  public static hideIsNotAuthorized(screen: any, stateName: string, roleIds: string[]) {
    const obj = {} as any;
    let isVisible = "hidden";
    const { userInfo } = screen.props.context;
    if (userInfo == null || userInfo == undefined) return isVisible;
    const role =
      userInfo.roles &&
      userInfo.roles.find((r: { id: string; name: string }) => roleIds.find((p) => p === r.id || p === r.name));
    if (role || roleIds.length == 0) {
      isVisible = "visible";
    }
    obj[stateName] = isVisible;
    screen.setState(obj);
  }

  public static sendWhatsappMessage(number: string, message: string) {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectOnMobileValue = urlParams.get("redirectOnMobile");

    if (redirectOnMobileValue === "true") {
      this.postWebKitMessage(null, {
        actionType: "SEND_WP_MESSAGE",
        number: `${number}`,
        message: `${message}`
      });
    } else {
      window.open(`https://wa.me/${number}?text=${encodeURIComponent(message)}`);
    }
  }

  public static disableIsNotAuthorized(screen: any, stateName: string, roleIds: string[]) {
    const obj = {} as any;
    let isEnabled = "disabled";
    const { userInfo } = screen.props.context;
    const role = userInfo?.roles?.find((r: { id: string; name: string }) =>
      roleIds.find((p) => p === r.id || p === r.name)
    );
    if (role) {
      isEnabled = "enabled";
    }
    obj[stateName] = isEnabled;
    screen.setState(obj);
  }

  public static setValueOf(
    screen: any,
    componentName: any,
    value: any,
    multipleValuePropName?: string | null,
    _pk?: any
  ) {
    if (!screen) return;
    // pagination case start
    if (
      screen[`${componentName}_kuikaPaginationRef`] != undefined ||
      screen[`${componentName}_kuikaPaginationRef`] != null
    ) {
      if (
        screen[`${componentName}_kuikaPaginationRef`].current != undefined &&
        screen[`${componentName}_kuikaPaginationRef`].current != null &&
        screen[`${componentName}_kuikaPaginationRef`].current.setPaginationData != undefined
      ) {
        if (
          multipleValuePropName === "pageSize" &&
          screen[`${componentName}_kuikaPaginationRef`].current.setPageSize != undefined
        ) {
          screen[`${componentName}_kuikaPaginationRef`].current.setPageSize(value);
        } else {
          screen[`${componentName}_kuikaPaginationRef`].current.setPaginationData(value);
        }
      }
    }
    // pagination case end
    if (screen[`${componentName}_kuikaTableRef`] != undefined || screen[`${componentName}_kuikaTableRef`] != null) {
      if (
        screen[`${componentName}_kuikaTableRef`].current != undefined &&
        screen[`${componentName}_kuikaTableRef`].current != null &&
        screen[`${componentName}_kuikaTableRef`].current.setSelectedValues != undefined
      ) {
        if (
          multipleValuePropName === "selectedValues" &&
          screen[`${componentName}_kuikaTableRef`].current.setSelectedValues != undefined
        ) {
          screen[`${componentName}_kuikaTableRef`].current.setSelectedValues(value);
        }
      }
    }
    // MicroApp
    else if (
      screen[`${componentName}_kuikaMicroAppRef`] != undefined ||
      screen[`${componentName}_kuikaMicroAppRef`] != null
    ) {
      if (screen[`${componentName}_kuikaMicroAppRef`].current) {
        screen[`${componentName}_kuikaMicroAppRef`].current.setProjectId?.(value);
      }
    } else if (
      screen[`${componentName}_kuikaChatRef`] != undefined &&
      screen[`${componentName}_kuikaChatRef`] != null &&
      screen[`${componentName}_kuikaChatRef`].current
    ) {
      if (multipleValuePropName === "message" && screen[`${componentName}_kuikaChatRef`].current.setMessage) {
        screen[`${componentName}_kuikaChatRef`].current.setMessage(value);
      }

      if (
        multipleValuePropName === "currentlyEditingMessageId" &&
        screen[`${componentName}_kuikaChatRef`].current.setCurrentlyEditingMessageId
      ) {
        screen[`${componentName}_kuikaChatRef`].current.setCurrentlyEditingMessageId(value);
      }
    } else if (
      screen[`${componentName}_kuikaWebViewRef`] != undefined ||
      screen[`${componentName}_kuikaWebViewRef`] != null
    ) {
      if (screen[`${componentName}_kuikaWebViewRef`].current) {
        if (screen[`${componentName}_kuikaWebViewRef`].current.setUrl) {
          screen[`${componentName}_kuikaWebViewRef`].current.setUrl(value);
        }
      }
    } else if (
      screen[`${componentName}_kuikaCarouselRef`] != undefined ||
      screen[`${componentName}_kuikaCarouselRef`] != null
    ) {
      if (screen[`${componentName}_kuikaCarouselRef`].current) {
        if (screen[`${componentName}_kuikaCarouselRef`].current.setStartingIndex) {
          screen[`${componentName}_kuikaCarouselRef`].current.setStartingIndex(value);
        }
      }
    }
    // LocationSearch CASE START
    else if (
      screen[`${componentName}_kuikaPlacesAutocompleteInputRef`] != undefined &&
      screen[`${componentName}_kuikaPlacesAutocompleteInputRef`] != null
    ) {
      if (screen[`${componentName}_kuikaPlacesAutocompleteInputRef`].current != null) {
        if (screen[`${componentName}_kuikaPlacesAutocompleteInputRef`].current.handleChange) {
          screen[`${componentName}_kuikaPlacesAutocompleteInputRef`].current.handleChange(value);
        }
      }
    }
    // LocationSearch CASE END
    else if (
      screen[`${componentName}_kuikaDateRef`] != undefined ||
      screen[`${componentName}_kuikaDateRef`] != null ||
      screen[`${componentName}_kuikaDatePickerRef`] != undefined ||
      screen[`${componentName}_kuikaDatetimeRef`] != undefined
    ) {
      let refText =
        screen[`${componentName}_kuikaDateRef`] != undefined
          ? "_kuikaDateRef"
          : screen[`${componentName}_kuikaDatePickerRef`] !== undefined
            ? "_kuikaDatePickerRef"
            : screen[`${componentName}_kuikaDatetimeRef`] !== undefined
              ? "_kuikaDatetimeRef"
              : "";
      if (screen[`${componentName}${refText}`].current) {
        if (
          screen[`${componentName}${refText}`].current.setDisableBeforeDate &&
          multipleValuePropName === "disablebeforedate"
        ) {
          screen[`${componentName}${refText}`].current.setDisableBeforeDate(value);
          return;
        }
        if (
          screen[`${componentName}${refText}`].current.setDisableBeforeTime &&
          multipleValuePropName === "disablebeforetime"
        ) {
          screen[`${componentName}${refText}`].current.setDisableBeforeTime(value);
          return;
        }
        if (
          screen[`${componentName}${refText}`].current.setDisableAfterTime &&
          multipleValuePropName === "disableaftertime"
        ) {
          screen[`${componentName}${refText}`].current.setDisableAfterTime(value);
          return;
        }
      }
      const data = {};
      data[componentName] = value;
      screen.props.form.setFieldsValue(data);
      return Guid.create().toString();
    } else if (
      screen?.[`${componentName}_kuikaCalendarRef`]?.current != undefined &&
      screen?.[`${componentName}_kuikaCalendarRef`]?.current != null
    ) {
      if (multipleValuePropName === "defaultPanel") {
        screen?.[`${componentName}_kuikaCalendarRef`]?.current?.setPanel(value);
      }
      // _kuikaTextInputRef
    } else if (
      screen?.[`${componentName}_kuikaTextInputRef`]?.current != undefined &&
      screen?.[`${componentName}_kuikaTextInputRef`]?.current != null &&
      multipleValuePropName === "mask"
    ) {
      screen?.[`${componentName}_kuikaTextInputRef`]?.current?.setMask?.(value);
    } else {
      const data = {};
      if (multipleValuePropName) {
        let obj = screen.props.form.getFieldValue(componentName);
        if (obj === undefined) {
          obj = {};
        }
        if (typeof obj !== "object" || obj === null) {
          obj = {};
        }
        obj[multipleValuePropName] = value;
        data[componentName] = obj;
      } else {
        data[componentName] = value;
      }

      screen.props.form.setFieldsValue(data);
      return Guid.create().toString();
    }
  }

  public static toggleLeftMenu(screen: any): string {
    screen.setState({ isLeftMenuVisible: !screen.state.isLeftMenuVisible });
    return "";
  }

  public static async changePassword(
    screen: any,
    currentpassword: string,
    newpassword: string,
    dontSendEmail?: boolean,
    language?: string,
    callback?: () => {}
  ) {
    const response: any = await UserService.ChangePassword({
      currentpassword,
      newpassword,
      newpasswordConfirm: newpassword,
      dontSendEmail: dontSendEmail || false,
      language: language || ""
    } as IChangePasswordDto);

    if (response.status.toString().startsWith("4") || response.status.toString().startsWith("5")) {
      KuikaAppManager.hideSpinner(screen);
      throw new Error(`Password change failed: Reason: ${response.message}`);
    }
  }

  public static readFromLocalStorage(key: string) {
    return window.localStorage.getItem(key);
  }

  public static writeToLocalStorage(key: string, value: string) {
    window.localStorage.setItem(key, value);
  }

  public static deleteFromLocalStorage(key: string) {
    window.localStorage.removeItem(key);
  }

  public static readFromSessionStorage(key: string) {
    return window.sessionStorage.getItem(key);
  }

  public static writeToSessionStorage(key: string, value: string) {
    window.sessionStorage.setItem(key, value);
  }

  public static deleteFromSessionStorage(key: string) {
    window.sessionStorage.removeItem(key);
  }

  public static isDate(value: any, _value2: any): string {
    let result = value instanceof Date || value instanceof moment;
    if (result === true) return "";
    result = isNaN(Date.parse(value)) === false || moment(value).isValid();
    return result === true ? "" : "Invalid Date";
  }

  public static isEmpty(val: any, _val2?: any): boolean {
    if (typeof val === "number") {
      return false;
    }
    return _.isEmpty(val);
  }

  // setValueOfDI: _setValueOfDI,

  // Comparison
  public static isGreaterThan(val1: string | any[], val2: string | any[]): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    return Number(val1) > Number(val2);
  }

  public static isGreaterOrEqual(val1: string | any[], val2: string | any[]): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    return Number(val1) >= Number(val2);
  }

  public static isLessThan(val1: string | any[], val2: string | any[]): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    return Number(val1) < Number(val2);
  }

  public static isLessOrEqual(val1: string | any[], val2: string | any[]): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    return Number(val1) <= Number(val2);
  }

  public static isEqualTo(val1: string | boolean, val2: string | boolean): boolean {
    if (
      (val1?.toString()?.toLowerCase() === "true" && val2 === true) ||
      (val1?.toString()?.toLowerCase() === "false" && val2 === false) ||
      (val1 === true && val2?.toString()?.toLowerCase() === "true") ||
      (val1 === false && val2?.toString()?.toLowerCase() === "false") ||
      (val1?.toString()?.toLowerCase() === "true" && val2?.toString()?.toLowerCase() === "true") ||
      (val1?.toString()?.toLowerCase() === "false" && val2?.toString()?.toLowerCase() === "false")
    ) {
      return true;
    }

    return val1 == val2;
  }

  public static isShorterOrEqualLength(val1: string, val2: null): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    return val1.length <= Number(val2);
  }

  public static isShorterLength(val1: string, val2: null): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    return val1.length < Number(val2);
  }

  public static isLongerLength(val1: string, val2: null): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    return val1.length > Number(val2);
  }

  public static isLongerOrEqualLength(val1: string, val2: null): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    return val1.length >= Number(val2);
  }

  public static isEqualLength(val1: string, val2: null): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    return val1.length === Number(val2);
  }

  public static isNotEqualTo(val1: any, val2: any): boolean {
    if (
      (val1?.toString()?.toLowerCase() === "true" && val2 === true) ||
      (val1?.toString()?.toLowerCase() === "false" && val2 === false) ||
      (val1 === true && val2?.toString()?.toLowerCase() === "true") ||
      (val1 === false && val2?.toString()?.toLowerCase() === "false") ||
      (val1?.toString()?.toLowerCase() === "true" && val2?.toString()?.toLowerCase() === "true") ||
      (val1?.toString()?.toLowerCase() === "false" && val2?.toString()?.toLowerCase() === "false")
    ) {
      return false;
    }

    return val1 != val2;
  }

  public static startsWith(val1: string, val2: string | any): boolean {
    if (val1 === undefined || val2 === undefined) return false;
    if (val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    if (val1.startsWith && val1.startsWith(val2)) return true;
    return false;
  }

  public static doesNotStartWith(val1: string, val2: string | any): boolean {
    if (val1 === undefined || val2 === undefined) return false;
    if (val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    if (!val1.startsWith(val2)) return true;
    return false;
  }

  public static endsWith(val1: string, val2: string | any): boolean {
    if (val1 === undefined || val2 === undefined) return false;
    if (val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    if (val1.endsWith && val1.endsWith(val2)) return true;
    return false;
  }

  public static contains(val1: string | any[], val2: string | any): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    if (val1.indexOf && val1.indexOf(val2) > -1) return true;
    return false;
  }

  public static doesNotContain(val1: string | any[], val2: string | any): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    if (val1.indexOf && val1.indexOf(val2) === -1) return true;
    return false;
  }

  public static isEarlierThan(val1: moment.MomentInput, val2: moment.MomentInput): boolean {
    if (val1 === null || val2 === null) return false;
    if (val1 === undefined || val2 === undefined) return false;
    return moment(val1).isBefore(moment(val2));
  }

  public static isEarlierOrEqual(val1: moment.MomentInput, val2: moment.MomentInput): boolean {
    if (val1 === null || val2 === null) return false;
    if (val1 === undefined || val2 === undefined) return false;
    return moment(val1).isSameOrBefore(moment(val2), "day");
  }

  public static isLaterThan(val1: moment.MomentInput, val2: moment.MomentInput): boolean {
    if (val1 === undefined || val2 === undefined) return false;
    return moment(val1).isAfter(moment(val2));
  }

  public static isLaterOrEqual(val1: moment.MomentInput, val2: moment.MomentInput): boolean {
    if (val1 === null || val2 === null) return false;
    if (val1 === undefined || val2 === undefined) return false;
    return moment(val1).isSameOrAfter(moment(val2), "day");
  }

  /* public static isSameDay(val1, val2): boolean {
    if (val1 === null || val2 === null) return false;
    if (val1 === undefined || val2 === undefined) return false;
    alert("TODO: SYSTEM FUNCTION NOT IMPLEMENTED YET: isSameDay");
    return false;
  }

  public static isSameMonth(val1, val2): boolean {
    if (val1 === null || val2 === null) return false;
    if (val1 === undefined || val2 === undefined) return false;
    alert("TODO: SYSTEM FUNCTION NOT IMPLEMENTED YET: isSameMonth");
    return false;
  }

  public static isSameYear(val1, val2): boolean {
    if (val1 === null || val2 === null) return false;
    if (val1 === undefined || val2 === undefined) return false;
    alert("TODO: SYSTEM FUNCTION NOT IMPLEMENTED YET: isSameYear");
    return false;
  }
  */

  public static isNotEmpty(val: any, _x?: any): boolean {
    if (val === 0) {
      return true;
    }
    if (!val || val == "") {
      return false;
    }
    return true;
  }

  public static isGuid(val): boolean {
    return Guid.isGuid(val);
  }

  public static scanBarcode() {}

  // Remaining
  // isValid: _isValid,
  public static isValid(val1: any): boolean {
    if (typeof val1 === "string") return val1.length === 0;
    if (val1 === false) return false;
    if (val1 === true) return true;
    return true;
  }

  public static validateToken() {}

  public static async downloadFile(data: string | IRestResult, filename?: string): Promise<void> {
    if (!data || data === "") {
      this.notify(undefined, "Invalid file data.", "warning", "bottom-right", 3, null, null, null);
      return;
    }
    if (typeof data === "string" && KMainFunctions.isValidUrl(data)) {
      const blob: Blob = await KMainFunctions.toBlob(data);
      KMainFunctions.downloadFile(
        blob,
        KMainFunctions.generateFilenameForDownloadFile(
          filename,
          KMainFunctions.getExtensionByMimeType(filename, blob.type)
        )
      );
      return;
    }

    if (typeof data === "string" && Guid.parse(data).toString() !== Guid.EMPTY) {
      const url = KMainFunctions.getUrlByWithResourceId(data);
      const blob: Blob = await KMainFunctions.toBlob(url);
      KMainFunctions.downloadFile(
        blob,
        KMainFunctions.generateFilenameForDownloadFile(
          filename,
          KMainFunctions.getExtensionByMimeType(filename, blob.type)
        )
      );
      return;
    }

    if (typeof data === "string" && KMainFunctions.isBase64(data)) {
      const mimeType = await KMainFunctions.getFileType(data);
      const blob = new Blob([KMainFunctions.base64ToUint8Array(data)], {
        type: mimeType
      });
      KMainFunctions.downloadFile(
        blob,
        KMainFunctions.generateFilenameForDownloadFile(
          filename,
          KMainFunctions.getExtensionByMimeType(filename, mimeType)
        )
      );
      return;
    }

    if (typeof data === "string" && KMainFunctions.isRelativeUrl(data)) {
      const backendUrl: string = KuikaAppManager.GetBackendUrl();
      const absoluteUrl: string = data.startsWith("/") ? `${backendUrl}${data}` : `${backendUrl}/${data}`;
      const blob: Blob = await KMainFunctions.toBlob(absoluteUrl);
      KMainFunctions.downloadFile(
        blob,
        KMainFunctions.generateFilenameForDownloadFile(
          filename,
          KMainFunctions.getExtensionByMimeType(filename, blob.type)
        )
      );
      return;
    }

    if (typeof data === "object") {
      const blob: Blob = await KMainFunctions.toBlob(
        `${KMainFunctions.getBase64UrlPrefix(data.mimeType)}${data.content}`
      );
      KMainFunctions.downloadFile(
        blob,
        KMainFunctions.generateFilenameForDownloadFile(
          !!filename && filename !== "" ? filename : data.fileName,
          KMainFunctions.getExtensionByMimeType(!!filename && filename !== "" ? filename : data.fileName, blob.type)
        )
      );
      return;
    }

    this.notify(undefined, "Invalid file data.", "warning", "bottom-right", 3, null, null, null);
    return;
  }

  public static getLanguage(_languages: any, defaultLanguage: string): string {
    let retVal = "";
    const mlFromLocalStorage = localStorage.getItem("ml");
    if (!mlFromLocalStorage) {
      if (defaultLanguage) {
        localStorage.setItem("ml", defaultLanguage);
        retVal = defaultLanguage;
      }
    } else {
      retVal = mlFromLocalStorage;
    }
    return retVal;
  }

  public static toggleMenuCollapse(screen: any, stateName: string) {
    const obj = {} as any;
    var tmp = Object.keys(screen.props.form.getFieldsValue()).find((v) => v.includes(stateName));

    var value = screen.props.form.getFieldValue(tmp);
    obj.tmp = value;
    obj.tmp.collapsed = !obj.tmp.collapsed;
    screen.props.form.setFieldsValue(!value);
  }

  public static toggleHamburgerMenuCollapse(screen: any, stateName: string) {
    const obj = {} as any;
    var tmp = Object.keys(screen.props.form.getFieldsValue()).find((v) => v.includes(stateName));
    var value = screen.props.form.getFieldValue(tmp);
    obj[tmp] = { ...value, hamburgerCollapsed: !value.hamburgerCollapsed };
    screen.props.form.setFieldsValue(obj);
  }

  public static setLanguage(_screen: any, culture: string) {
    const currentML = localStorage.getItem("ml");
    if (currentML && currentML != culture) {
      if (localStorage.getItem("refreshToken") && localStorage.getItem("refreshToken").length) {
        LanguageService.SaveLanguage(culture).then((res) => {
          if (res && res.status === 200) {
            localStorage.setItem("ml", culture);
            window.location.reload();
          } else {
            console.error("Save language failed", {
              status: res.status,
              statusText: res?.statusText,
              url: res?.config?.url
            });
            KMainFunctions.displayErrorNotification(
              localStorage.getItem("ml") === "tr_TR"
                ? "Dil değiştirilemedi. Lütfen tekrar deneyin."
                : "Language could not be changed. Please try again."
            );
          }
        });
      }
    } else {
      localStorage.setItem("ml", culture);
      if (localStorage.getItem("refreshToken") && localStorage.getItem("refreshToken").length) {
        LanguageService.SaveLanguage(culture);
      }
    }
  }

  public static getAvailableLanguages(languages: any[]) {
    const languageList: any = [];
    languages?.map((x: { ShortName: string; IsDefault: any; Name: any }) => {
      if (x.ShortName !== "FixedValues") {
        languageList.push({
          shortName: x.ShortName,
          isDefault: x.IsDefault,
          name: x.Name
        });
      }
    });
    return languageList;
  }

  public static translateCustomActions(languages: any, actionId: any, defaultLanguage: any, defaultValue: string) {
    if (!languages) return defaultValue;

    const lastUnderscoreIndex = actionId.lastIndexOf("_");
    const stringWithoutLastUnderscore = actionId.substring(0, lastUnderscoreIndex).replace(/_/g, "-");
    actionId = stringWithoutLastUnderscore + actionId.substring(lastUnderscoreIndex);

    const cache = this.getTranslateCache(languages);
    const langName = this.getLanguage(languages, defaultLanguage);

    // Try selected language (PropertyName-only lookup)
    const langMaps = cache.byName.get(langName);
    if (langMaps) {
      const value = langMaps.propOnly.get(actionId);
      if (value) return value;
    }

    // Fallback to FixedValues
    const fixedMaps = cache.byShortName.get("FixedValues");
    if (fixedMaps) {
      const value = fixedMaps.propOnly.get(actionId);
      if (value) return value;
    }

    return defaultValue;
  }

  public static translate(languages: any, diId: any, propertyName: any, defaultLanguage: any) {
    if (!languages) return "";

    const cache = this.getTranslateCache(languages);
    const langName = this.getLanguage(languages, defaultLanguage);
    const key = `${diId}\0${propertyName}`;

    // Try selected language
    const langMaps = cache.byName.get(langName);
    if (langMaps) {
      const value = langMaps.idProp.get(key);
      if (value) return value;
    }

    // Fallback to FixedValues
    const fixedMaps = cache.byShortName.get("FixedValues");
    if (fixedMaps) {
      const value = fixedMaps.idProp.get(key);
      if (value) return value;
    }

    return "";
  }

  public static getEmailValidationMessage() {
    const language = localStorage.getItem("ml");
    let retValue = "";
    switch (language) {
      case "en_US":
        retValue = "Please Enter a Valid Email.";
        break;

      case "fr_FR":
        retValue = "Veuillez saisir un e-mail valide.";
        break;

      case "tr_TR":
        retValue = "Geçerli bir mail adresi giriniz.";
        break;
      default:
        retValue = "Please Enter a Valid Email.";
        break;
    }
    return retValue;
  }

  public static openInMap(p1: any, p2: any, _p3: any, _p4: any) {
    window.open(`https://www.google.com/maps/@${p1},${p2},12.00z`);
    return;
  }

  public static phoneNumberCall(number: any) {
    window.open(`tel:${number}`);
  }

  public static mailTo(receivers: string, cc?: string, bcc?: string, subject?: string, body?: string) {
    if (!receivers) return;
    let divider = "?";

    let mailToURL = `mailto:${receivers}`;

    if (cc) {
      mailToURL += `${divider}cc=${cc}`;
      divider = "&";
    }

    if (bcc) {
      mailToURL += `${divider}bcc=${bcc}`;
      divider = "&";
    }

    if (subject) {
      mailToURL += `${divider}subject=${subject}`;
      divider = "&";
    }

    if (body) {
      mailToURL += `${divider}body=${body}`;
      divider = "&";
    }

    window.open(mailToURL);
  }
  // validatePhoneNumber: _validatePhoneNumber,
  // validateEmail: _validateEmail,

  // toLocaleString: _toLocaleString,
  // trimRight: _trimRight,
  // toTitleCase: _toTitleCase,
  // substring: _substring,
  // concatenate: _concatenate,

  // registerPopup: _registerPopup,
  // deregisterPopup: _deregisterPopup,

  // attachFile: _attachFile,
  // attachFileUrl: _attachFileUrl,
  // downloadFile: _downloadFile,
  // downloadFileUrl: _downloadFileUrl,

  // scanBarcodeKuikaFunction: _scanBarcodeKuikaFunction,

  // searchOnClientSide: _searchOnClientSide,
  // kuikaSearchOnClientSide: _kuikaSearchOnClientSide,

  // getFromLangPack: _getFromLangPack,
  // setLanguage: _setLanguage,
  // getLanguage: _getLanguage,
  // getAvailableLanguages: _getAvailableLanguages,
  // translate: _translate,
  // translateToStringArray: _translateToStringArray,

  // isNotEmpty: _isNotEmpty,
  // getColorForTableRow: _getColorForTableRow,
  // increment: _increment,
  // and: _and,
  // or: _or,
  // not: _not,

  // base64ToBlob: _base64ToBlob,
  // downloadFile: _downloadFile,
  // authGoogleExternalLogin: _authGoogleExternalLogin,
  public static goToFullScreen(): void {
    const elem: any = document.getElementsByTagName("html")[0];

    const urlParams = new URLSearchParams(window.location.search);
    const redirectOnMobileValue = urlParams.get("redirectOnMobile");

    if (redirectOnMobileValue === "true") {
      this.postWebKitMessage(null, {
        actionType: "GO_TO_FULL_SCREEN"
      });
    } else if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
  }

  public static getLocale(): any {
    let mlKey = localStorage.getItem("ml");

    if (!mlKey) {
      mlKey = "en_US";
    }

    switch (mlKey) {
      case "hy_AM":
        return hy_AM;

      case "az_AZ":
        return az_AZ;

      case "bg_BG":
        return bg_BG;

      case "ca_ES":
        return ca_ES;

      case "hr_HR":
        return hr_HR;

      case "cs_CZ":
        return cs_CZ;

      case "da_DK":
        return da_DK;

      case "nl_NL":
        return nl_NL;

      case "en_US":
        return en_US;

      case "en_GB":
        return en_GB;

      case "et_EE":
        return et_EE;

      case "fi_FI":
        return fi_FI;

      case "fr_FR":
        return fr_FR;

      case "ka_GE":
        return ka_GE;

      case "de_DE":
        return de_DE;

      case "el_GR":
        return el_GR;

      case "hu_HU":
        return hu_HU;

      case "is_IS":
        return is_IS;

      case "it_IT":
        return it_IT;

      case "kk_KZ":
        return kk_KZ;

      case "lv_LV":
        return lv_LV;

      case "lt_LT":
        return lt_LT;

      case "mk_MK":
        return mk_MK;

      case "nb_NO":
        return nb_NO;

      case "pl_PL":
        return pl_PL;

      case "pt_PT":
        return pt_PT;

      case "ro_RO":
        return ro_RO;

      case "ru_RU":
        return ru_RU;

      case "sr_RS":
        return sr_RS;

      case "sk_SK":
        return sk_SK;

      case "sl_SI":
        return sl_SI;

      case "es_ES":
        return es_ES;

      case "sv_SE":
        return sv_SE;

      case "tr_TR":
        return tr_TR;

      case "uk_UA":
        return uk_UA;

      default:
        return en_US;
    }
  }

  public static updateUserName(
    currentUserName: string,
    newUserName: string,
    dontSendEmail?: boolean,
    language?: string
  ): void {
    const obj = {
      userName: currentUserName,
      newUserName,
      dontSendEmail: dontSendEmail || false,
      language: language || ""
    } as IUpdateUsernameDto;
    UserService.UpdateUserName(obj);
  }

  public static updateUserStartingScreen(currentUserName: string, startingScreenId: string): void {
    const obj: IUpdateUserStartingScreen = {
      userName: currentUserName,
      startingScreenId
    };
    UserService.UpdateUserStartingScreen(obj);
  }

  public static async componentToPDF(targetComponent: string, quality: string, orientation: string) {
    const generatePDF = (await import("react-to-pdf")).default;
    const Resolution = (await import("react-to-pdf")).Resolution;

    const options: any = {
      method: "build",
      resolution: Resolution[quality],
      overrides: {
        pdf: {
          compress: true
        },
        canvas: {
          useCORS: true
        }
      },
      page: {
        orientation: orientation ?? "portrait"
      }
    };
    const getTargetElement = () => document.getElementById(targetComponent);
    var a = await generatePDF(getTargetElement, options);
    var blobValue = a.output("blob");
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blobValue);
    });
  }

  public static async componentToPDFSave(
    targetComponent: string,
    filename: string,
    quality: string,
    orientation: string
  ) {
    const generatePDF = (await import("react-to-pdf")).default;
    const Resolution = (await import("react-to-pdf")).Resolution;

    const urlParams = new URLSearchParams(window.location.search);
    const redirectOnMobileValue = urlParams.get("redirectOnMobile");

    let file = filename;
    if (!file.endsWith(".pdf")) {
      file = `${file}.pdf`;
    }

    const options: any = {
      filename: file,
      method: "save",
      resolution: Resolution[quality],
      overrides: {
        pdf: {
          compress: true
        },
        canvas: {
          useCORS: true
        }
      },
      page: {
        orientation: orientation ?? "portrait"
      }
    };
    const getTargetElement = () => document.getElementById(targetComponent);
    const result = await generatePDF(getTargetElement, options);
    if (redirectOnMobileValue && redirectOnMobileValue === "true") {
      const blob = result.output("blob");
      const base64 = await KMainFunctions.convertBlobToBase64(blob);
      this.postWebKitMessage(null, {
        actionType: "DOWNLOAD_BLOB",
        filename: `${file}`,
        base64Str: `${base64}`,
        mimeType: `${blob.type}`
      });
    }
  }

  public static scrollTo(elemenetId: string) {
    if (!elemenetId) return;
    const element = window.document.getElementById(elemenetId);
    if (!element) return;
    element.scrollIntoView({ behavior: "smooth" });
  }

  public static setFocusTo(elementId: string) {
    if (!elementId) return;
    const element = window.document.getElementById(elementId);
    const element2: HTMLElement = window.document.querySelector(`[focusId="${elementId}"]`);
    if (!element && !element2) return;
    setTimeout(() => {
      element?.focus();
      element2?.focus();
    }, 0);
  }

  public static openPdf(data: string, warnLandscape: boolean, openAs: "newTab" | "currentPage"): void {
    if (KMainFunctions.isBase64(data) || data.startsWith("data:application/pdf;base64")) {
      KMainFunctions.openBase64Pdf(data, warnLandscape, openAs);
      return;
    }

    if (KMainFunctions.isValidUrl(data)) {
      KMainFunctions.openUrlPdf(data, openAs);
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const redirectOnMobileValue = urlParams.get("redirectOnMobile");

    if (redirectOnMobileValue === "true") {
      this.postWebKitMessage(null, {
        actionType: "GET_REPORT",
        link: `${data}`,
        warnLandscape: `${warnLandscape}`,
        openAs: `${openAs}`
      });
      return;
    }

    this.notify(undefined, "Invalid pdf data.", "warning", "bottom-right", 3, null, null, null);
    return;
  }

  public static async share(data: string): Promise<void> {
    try {
      if (!navigator.share || !data) return;

      let text: string | undefined;
      let files: File[];

      if (
        (data.toLowerCase().startsWith("http://") || data.toLowerCase().startsWith("https://")) &&
        data.indexOf(" ") < 0
      ) {
        if (data.toLowerCase().endsWith(".pdf")) {
          const blob: Blob = await KMainFunctions.toBlob(data);
          files = [new File([blob], `${Guid.create().toString()}.${blob.type.split("/")[1]}`, { type: blob.type })];
        } else {
          text = data;
        }
      } else if (data.startsWith("BEGIN:VCARD") || data.startsWith("VCARD")) {
        const vcfBlob = new Blob([data], { type: "text/vcard" });
        const vcfFile = new File([vcfBlob], "Share.vcf", {
          type: "text/vcard"
        });
        try {
          await navigator.share({ files: [vcfFile] });
        } catch {
          const url = URL.createObjectURL(vcfBlob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "Share.vcf";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }
        return;
      } else if (data.includes(";base64,")) {
        const blob: Blob = await KMainFunctions.toBlob(data);
        const mimeType = data.split(";base64,")[0].replace("data:", "");
        const ext = mimeType.split("/")[1] || "txt";
        const fileName = `${Guid.create().toString()}.${ext}`;
        files = [new File([blob], fileName, { type: mimeType })];
      } else {
        text = data;
      }
      const shareData: ShareData = {};
      if (text) shareData.text = text;
      if (files?.length) shareData.files = files;
      await navigator.share(shareData);
    } catch (e) {
      KMainFunctions.exceptionHandler(e);
    }
  }

  public static selectLanguage(): string {
    return "";
  }

  public static getVersionInfo(): string {
    return "1.0.0";
  }

  public static getMyNotifications(_username: any, _no: any, _no2: any, _no3: any) {
    console.log("TODO: SYSTEM FUNCTION NOT IMPLEMENTED YET: getMyNotifications");
  }

  public static markAsReadNotification(_username: any, _notificationId: any) {
    console.log("TODO: SYSTEM FUNCTION NOT IMPLEMENTED YET: markAsReadNotification");
  }

  public static async sendPushNotificationToUsername(
    username: string,
    title: string,
    message: string,
    extraData: any
  ): Promise<void> {
    NotificationService.SendPushNotificationToUsername({
      username,
      title,
      message,
      extraData
    });
  }

  public static isValidEmail(val1: any, _val2: any): any {
    if (!val1) return true;

    return /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test(
      val1?.toString()?.trim()
    );
    // return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(val1?.toString());
  }

  public static SendPushNotification(p1, p2, p3) {}

  public static async isLoggedIn() {
    const token = localStorage.getItem("tokenString");
    if (token && token.length > 0) {
      const result = await UserService.ValidateToken();
      return KMainFunctions.IsResStatus2XX(result);
    }
    return false;
  }

  // STRIPE ACTIONS START
  public static async stripePayment(amount: string, currency: string, description: string): Promise<IStripePayment> {
    const stripePaymentDto = {
      amount,
      currency,
      description
    } as IStripePaymentDto;
    const res = await StripeService.OneTimePayment(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return {} as IStripePayment;
  }

  public static async getPaymentReceiptLink(paymentIntent: string): Promise<string> {
    const dto = {
      paymentIntent
    } as IStripeCaptureDto;
    const res = await StripeService.GetPaymentReceiptLink(dto);
    if (res.status === 200) {
      return res.data;
    }
    return {} as any;
  }

  public static async getPaymentReceiptBase64(paymentIntent: string): Promise<string> {
    const dto = {
      paymentIntent
    } as IStripeCaptureDto;
    const res = await StripeService.GetPaymentReceiptBase64(dto);
    if (res.status === 200) {
      return res.data;
    }
    return {} as any;
  }

  public static async checkPaymentIntentStatus(paymentIntent: string): Promise<any> {
    const dto = {
      paymentIntent
    } as IStripeCaptureDto;
    const res = await StripeService.CheckPaymentIntentStatus(dto);
    if (res.status === 200) {
      return res;
    }
    return {} as any;
  }

  public static async openStripePaymentDrawer(
    screen: any,
    cllbck: any,
    amount: string,
    currency: string,
    description: string,
    applicationFee: string,
    destination: string,
    captureMethod: string,
    paymentType: string,
    supportedPaymentTypes?: string
  ): Promise<any> {
    const stripePaymentDto = {
      amount,
      currency,
      description,
      applicationFeeAmount: applicationFee,
      ConnectedAccount: destination,
      captureMethod,
      supportedPaymentTypes
    } as IStripePaymentDto;
    const endPoint =
      paymentType === "single" ? StripeService.OneTimePayment : StripeService.OneTimePaymentWithDestination;
    const res = await endPoint(stripePaymentDto);
    if (res.status === 200) {
      const response = {};
      screen?.props.showStripeDrawer(res.data, cllbck, screen, false);
      return res.data;
    }
    return "";
  }

  public static async setupIntent(screen: any, cllbck: any, supportedPaymentTypes: string): Promise<any> {
    const stripePaymentDto = {
      supportedPaymentTypes
    } as any;
    const res = await StripeService.SetupIntent(stripePaymentDto);
    if (res.status === 200) {
      const response = {};
      screen?.props.showStripeDrawer(res.data, cllbck, screen, true);
      return res.data;
    }
    return "";
  }

  public static async refundStripePayment(paymentIntent: string, reason: string, amount: string): Promise<boolean> {
    const stripePaymentDto = {
      amount,
      reason,
      paymentIntent
    } as IStripeRefundDto;
    const res = await StripeService.RefundPayment(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return false;
  }

  public static async captureReservedFunds(paymentIntent: string, amount: string): Promise<boolean> {
    const stripePaymentDto = {
      amount,
      paymentIntent
    } as IStripeCaptureDto;
    const res = await StripeService.CapturePayment(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return false;
  }

  public static async chargePaymentMethod(
    paymentmethod: string,
    currency: string,
    amount: string,
    stripeCustomerId: string,
    description: string,
    paymenttype: string,
    feeamount: string,
    destination: string
  ): Promise<any> {
    const stripePaymentDto = {
      paymentmethod,
      amount,
      currency,
      stripeCustomerId,
      description,
      paymenttype,
      feeamount,
      destination
    } as IStripeChargePaymentMethodDto;
    const res = await StripeService.ChargePaymentMethod(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return false;
  }

  public static async getConnectedAccountBalance(connectedAccount: string): Promise<any> {
    const stripePaymentDto = {
      connectedAccount
    } as IStripeConnectedAccountDto;
    const res = await StripeService.GetConnectedAccountBalance(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return undefined;
  }

  public static async getConnectedAccountStatus(connectedAccount: string): Promise<any> {
    const stripePaymentDto = {
      connectedAccount
    } as IStripeConnectedAccountDto;
    const res = await StripeService.GetConnectedAccountStatus(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return false;
  }

  public static async getConnectedAccountOnboardingLink(connectedAccount: string): Promise<any> {
    const stripePaymentDto = {
      connectedAccount,
      returnLocation: KMainFunctions.windowLocationOrigin
    } as IStripeConnectedAccountOnboardingDto;
    const res = await StripeService.GetConnectedAccountOnboardingLink(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return KMainFunctions.windowLocationOrigin;
  }

  public static async createConnectedAccount(type: string, country: string, email: string): Promise<any> {
    const stripePaymentDto = {
      type,
      country,
      email
    } as IStripeCreateConnectedAccountDto;
    const res = await StripeService.CreateConnectedAccount(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return "";
  }

  public static async connectedAccountWithdraw(
    amount: string,
    connectedAccount: string,
    currency: string
  ): Promise<any> {
    const stripePaymentDto = {
      amount,
      connectedAccount,
      currency
    } as IStripeConnectedAccountWithdraw;
    const res = await StripeService.ConnectedAccountWithdraw(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return "";
  }

  public static async connectedAccountPayout(amount: string, connectedAccount: string, currency: string): Promise<any> {
    const stripePaymentDto = {
      amount,
      connectedAccount,
      currency
    } as IStripeConnectedAccountPayout;
    const res = await StripeService.ConnectedAccountPayout(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return "";
  }

  public static async cancelStripePayment(paymentIntent: string): Promise<boolean> {
    const dto = {
      paymentIntent
    } as IStripeCaptureDto;
    const res = await StripeService.CancelPaymentIntent(dto);
    if (res.status === 200) {
      return res.data;
    }
    return false;
  }

  public static async updateStripeUserInfo(
    email: string,
    name: string,
    phone: string,
    description: string
  ): Promise<boolean> {
    const dto = {
      email,
      name,
      phone,
      description
    } as IStripeUpdateCustomerDto;
    const res = await StripeService.UpdateStripeUserInfo(dto);
    if (res.status === 200) {
      return res.data;
    }
    return false;
  }

  public static async removeStripePaymentMethod(paymentmethod: string): Promise<any> {
    const stripePaymentDto = {
      paymentmethod
    } as IStripeDeletePaymentMethodDto;
    const res = await StripeService.DeletePaymentMethod(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return undefined;
  }

  public static async getCustomerPaymentMethods(): Promise<any> {
    const res = await StripeService.GetCustomerPaymentMethods();
    if (res.status === 200) {
      return res;
    }
    return undefined;
  }

  public static async getCustomerPaymentMethodsbyId(stripeCustomerId: string): Promise<any> {
    const res = await StripeService.GetCustomerPaymentMethodsbyId({
      stripeCustomerId
    });
    if (res.status === 200) {
      return res;
    }
    return undefined;
  }

  public static async printPDFQZ(
    printerName: string,
    pdfBase64: string,
    pageW: number,
    pageH: number,
    totalHeight: number,
    stickyPaper: boolean,
    onePage: boolean,
    pdfList: any,
    key: string
  ): Promise<boolean> {
    const qz = (await import("qz-tray")).default;
    const { KEYUTIL, KJUR, stob64, hextorstr } = await import("jsrsasign");

    const privateKey = key;

    qz.security.setSignatureAlgorithm("SHA512"); // Since 2.1
    qz.security.setSignaturePromise((toSign: any) => {
      return function (resolve: (arg0: any) => void, reject: (arg0: any) => void) {
        try {
          const pk = KEYUTIL.getKey(privateKey);
          const sig = new KJUR.crypto.Signature({ alg: "SHA512withRSA" }); // Use "SHA1withRSA" for QZ Tray 2.0 and older
          sig.init(pk);
          sig.updateString(toSign);
          const hex = sig.sign();
          resolve(stob64(hextorstr(hex)));
        } catch (err) {
          console.error(err);
          reject(err);
        }
      };
    });

    try {
      const config = qz.configs.create(printerName);
      config.config = {
        orientation: "portrait",
        size: {
          width: pageW,
          height: pageH
        },
        units: "in"
      };

      if (totalHeight == 0) totalHeight = pageH;

      qz.security.setCertificatePromise((resolve: (arg0: string) => void, _reject: any) => {
        resolve(`-----BEGIN CERTIFICATE-----
          MIID4TCCAsmgAwIBAgIUTix9J/qAFmdZj1DlZ32r5UCBQzgwDQYJKoZIhvcNAQEL
          BQAwfzELMAkGA1UEBhMCVFIxCzAJBgNVBAgMAlRSMQswCQYDVQQHDAJUUjEOMAwG
          A1UECgwFSURBVEExDjAMBgNVBAsMBUlEQVRBMRcwFQYDVQQDDA4qLmlkYXRhLmNv
          bS50cjEdMBsGCSqGSIb3DQEJARYOKi5pZGF0YS5jb20udHIwIBcNMjIwNDIwMTQ0
          MDQwWhgPMjA1MzEwMTMxNDQwNDBaMH8xCzAJBgNVBAYTAlRSMQswCQYDVQQIDAJU
          UjELMAkGA1UEBwwCVFIxDjAMBgNVBAoMBUlEQVRBMQ4wDAYDVQQLDAVJREFUQTEX
          MBUGA1UEAwwOKi5pZGF0YS5jb20udHIxHTAbBgkqhkiG9w0BCQEWDiouaWRhdGEu
          Y29tLnRyMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA7ksdRHbjfxrB
          tVaskaDR5Zx3JGxsmE5cpbcwRZ0s8H3VkyxKlfSER9tMJs/CGlTtOsmCPgVW5uW9
          qkXOGB0LMFCkM2qfW22hq5eLFunWDicAgkc4rvIgTHbtMR+aM4hxQh4F04OaN5gy
          xFwDAwpKDJ6p43qX/TLzPaM7TUEX7SjYdA38oKjK3SFHzUDrvIKkieySmF12lyGJ
          UMrndN9scgH1DpD6uBHHqwUi7bUMRw2vaFGAXrkaBytfIlB/rzgsPIA0Ir0SfcON
          hK3oOXJe68pIY00AJkbmzp7SgjxGU/lpVhJI/wMRqHjXJ7106avX5h/IqDkfEtjG
          QI004UqriwIDAQABo1MwUTAdBgNVHQ4EFgQU9+kYlFmzC7HX7RGKDZ3KJJj4l8Yw
          HwYDVR0jBBgwFoAU9+kYlFmzC7HX7RGKDZ3KJJj4l8YwDwYDVR0TAQH/BAUwAwEB
          /zANBgkqhkiG9w0BAQsFAAOCAQEAQbRjJC6k5ZFYOgHTAhBsrwsvZ6ukbzEHbBhC
          rbE7NzTYS2QhYMbYM6O0e0jJ57dnEk03V4fXuaKLRVfKAqwFNEZgydwOZ7rZXi6O
          6Pi2IIxN7LHYtYrZwnANaWfUvwbULa439Fh1L5mVbKNpI0qLoC8JSO1gn+7BFv0v
          4AkgeFoEXa2IqlpupGIHFKPNA3M3RGNNFrysDDDKwV+cc2oAmXnxsEPI59sF4D1C
          l71cSa0tP2ZrHiv6PqgYQRSp4Tx2NlohkAmR/cZYmHjWb+jPYb/uVSNQP3ytoo+7
          XO7lMjGj++rQ+cqglSQrz6Tga4XFqseviYcWz11N8r5r6n7qww==
          -----END CERTIFICATE-----
          `);
      });

      if (onePage) {
        qz.websocket.connect().then(() => {
          const base64string = pdfBase64.split(",")[1];
          var printData: any = [];
          printData = pdfBase64.startsWith("^XA")
            ? [pdfBase64]
            : [
                "^XA\n",
                `^MN${stickyPaper ? "Y" : "N"}\n`,
                `^LL${totalHeight * 203.2}\n`,
                {
                  type: "pdf",
                  format: "base64",
                  data: base64string,
                  options: {
                    language: "ZPL",
                    pageHeight: totalHeight * 203.2,
                    pageWidth: pageW * 203.2
                  }
                },
                "^XZ\n"
              ];
          qz.print(config, printData)
            .catch()
            .then(() => {
              qz.websocket.disconnect();
            });
        });
      } else {
        qz.websocket.connect().then(() => {
          pdfList = pdfBase64.split("#####");
          for (const item of pdfList) {
            const base64string = item.split(",")[1];
            var printData: any = [];
            printData = item.startsWith("^XA")
              ? [item]
              : [
                  "^XA\n",
                  `^MN${stickyPaper ? "Y" : "N"}\n`,
                  `^LL${totalHeight * 203.2}\n`,
                  {
                    type: "pdf",
                    format: "base64",
                    data: base64string,
                    options: {
                      language: "ZPL",
                      pageHeight: totalHeight * 203.2,
                      pageWidth: pageW * 203.2
                    }
                  },
                  "^XZ\n"
                ];
            qz.print(config, printData)
              .catch()
              .then(() => {
                qz.websocket.disconnect();
              });
          }
        });
      }
      return true;
    } catch {
      return false;
    }
  }

  public static async generateQrCode(value: any) {
    try {
      const QRCode = (await import("qrcode")).default;
      const qr = await QRCode.toDataURL(value, { errorCorrectionLevel: "H" });
      return qr;
    } catch (err) {
      console.error(err);
      return "";
    }
  }

  public static updateUserRoles(roles: any) {
    if (window.userInfo) {
      window.userInfo.roles = roles;
    }
  }

  public static async generateVcf(
    name: string,
    surname: string,
    email: string,
    mobile: string,
    workPhone: string,
    homePhone: string,
    _gender: string,
    photo: string,
    nickname: string,
    note: string,
    organization: string,
    role: string,
    title: string,
    url: string,
    workUrl: string,
    homeUrl: string
  ): Promise<string> {
    const VCard = (await import("vcard-creator")).default;
    const vCard = new VCard();
    vCard.addName(surname, name);

    if (!_.isEmpty(email)) {
      vCard.addEmail(email);
    }

    if (!_.isEmpty(mobile)) {
      vCard.addPhoneNumber(mobile, "CELL");
    }

    if (!_.isEmpty(workPhone)) {
      vCard.addPhoneNumber(workPhone, "WORK");
    }

    if (!_.isEmpty(homePhone)) {
      vCard.addPhoneNumber(homePhone, "HOME");
    }

    if (!_.isEmpty(photo)) {
      vCard.addPhoto(photo);
    }

    if (!_.isEmpty(nickname)) {
      vCard.addNickname(nickname);
    }

    if (!_.isEmpty(note)) {
      vCard.addNote(note);
    }

    if (!_.isEmpty(organization)) {
      vCard.addCompany(organization);
    }

    if (!_.isEmpty(role)) {
      vCard.addRole(role);
    }

    if (!_.isEmpty(title)) {
      vCard.addJobtitle(title);
    }

    if (!_.isEmpty(url)) {
      vCard.addURL(url);
    }

    if (!_.isEmpty(workUrl)) {
      vCard.addURL(workUrl, "WORK");
    }

    if (!_.isEmpty(homeUrl)) {
      vCard.addURL(homeUrl, "HOME");
    }

    return vCard.toString();
  }

  public static async downloadVcf(
    name: string,
    surname: string,
    email: string,
    mobile: string,
    workPhone: string,
    homePhone: string,
    gender: string,
    photo: string,
    nickname: string,
    note: string,
    organization: string,
    role: string,
    title: string,
    url: string,
    workUrl: string,
    homeUrl: string
  ): Promise<void> {
    const vcfString = await this.generateVcf(
      name,
      surname,
      email,
      mobile,
      workPhone,
      homePhone,
      gender,
      photo,
      nickname,
      note,
      organization,
      role,
      title,
      url,
      workUrl,
      homeUrl
    );

    const blob = new Blob([vcfString], {
      type: "text/vcard"
    });

    const objectUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = `${name}_${surname}.vcf`;
    a.click();
  }

  public static isWeb(): boolean {
    return true;
  }

  public static isIOS(): boolean {
    return false;
  }

  public static isAndroid(): boolean {
    return false;
  }

  public static async isOnline(): Promise<boolean> {
    if (typeof navigator !== "undefined" && !navigator.onLine) {
      return false;
    }

    return true;
  }

  /**
   * Fetch fresh offline database from server.
   * Same as mobile: KtSystemFunctions.fetchOfflineDb() / SwiftSystemFunctions.fetchOfflineDb()
   *
   * Mobile flow:
   * 1. Check unsent records → if any, show warning and return null
   * 2. Call API to fetch database
   * 3. Import database to local storage (KPersister.SaveFile)
   * 4. Return base64 content
   */
  public static async fetchOfflineDb(): Promise<string | null> {
    const syncService = OfflineSyncService.getInstance();
    const wasmService = KuikaCoreWasmBridgeService.getInstance();
    const persistenceService = OfflineDbPersistenceService.getInstance();

    // Check for unsent records first (same as mobile)
    const hasPending = await syncService.hasPendingChanges();
    if (hasPending) {
      // Mobile shows: "k_unsentdata_available"
      console.warn("Cannot fetch: unsent records available. Push changes first.");
      return null;
    }

    const loadingId = this.showLoadingNotification(translationService.translate("offline_db.downloading"));

    try {
      const result = await syncService.fetchData();
      if (result.success && result.data) {
        // CRITICAL: Import database to WASM (same as mobile KPersister.SaveFile)
        await wasmService.Db_ImportDatabaseBase64(result.data);

        // Persist to storage for offline access
        await persistenceService.saveDatabase(result.data);

        this.removeNotification(loadingId);
        this.showResultNotification(translationService.translate("offline_db.download_success"), "success");
        return result.data;
      }

      this.removeNotification(loadingId);
      this.showResultNotification(translationService.translate("offline_db.download_error"), "danger");
      return null;
    } catch (error) {
      console.error("fetchOfflineDb failed:", error);
      this.removeNotification(loadingId);
      this.showResultNotification(translationService.translate("offline_db.download_error"), "danger");
      return null;
    }
  }

  /**
   * Push local changes to server.
   * Same as mobile: KtSystemFunctions.pushOfflineDb() / SwiftSystemFunctions.pushOfflineDb()
   *
   * Mobile flow:
   * 1. Export unsent records database (GetUnsentRecordsDbBase64)
   * 2. Call API to push database
   * 3. Mark all records as synced (SetSentFromMobileToSent)
   * 4. Return true
   */
  public static async pushOfflineDb(): Promise<boolean> {
    if (!navigator.onLine) {
      this.showResultNotification(translationService.translate("offline_db.push_offline_warning"), "warning");
      return false;
    }

    const syncService = OfflineSyncService.getInstance();
    const wasmService = KuikaCoreWasmBridgeService.getInstance();

    const loadingId = this.showLoadingNotification(translationService.translate("offline_db.uploading"));

    try {
      const result = await syncService.pushChanges();

      if (result.success) {
        // CRITICAL: Mark records as synced (same as mobile SetSentFromMobileToSent)
        const pendingChangesJson = await wasmService.Db_GetPendingChanges();
        const pendingChanges = JSON.parse(pendingChangesJson);

        // Build sync map: { tableName: [id1, id2, ...] }
        const syncedRecords: Record<string, string[]> = {};
        for (const [tableName, records] of Object.entries(pendingChanges)) {
          syncedRecords[tableName] = (records as { Id: string }[]).map((r) => r.Id);
        }

        await wasmService.Db_MarkAsSynced(JSON.stringify(syncedRecords));

        this.removeNotification(loadingId);
        this.showResultNotification(translationService.translate("offline_db.upload_success"), "success");
        return true;
      }

      this.removeNotification(loadingId);
      this.showResultNotification(translationService.translate("offline_db.upload_error"), "danger");
      return false;
    } catch (error) {
      console.error("pushOfflineDb failed:", error);
      this.removeNotification(loadingId);
      this.showResultNotification(translationService.translate("offline_db.upload_error"), "danger");
      return false;
    }
  }

  /**
   * Delete local offline database.
   * Same as mobile: KtSystemFunctions.deleteOfflineDb() / SwiftSystemFunctions.deleteOfflineDb()
   */
  public static async deleteOfflineDb(): Promise<boolean> {
    const loadingId = this.showLoadingNotification(translationService.translate("offline_db.deleting"));

    try {
      const syncService = OfflineSyncService.getInstance();
      await syncService.deleteOfflineDatabase();

      this.removeNotification(loadingId);
      this.showResultNotification(translationService.translate("offline_db.delete_success"), "success");
      return true;
    } catch (error) {
      console.error("deleteOfflineDb failed:", error);
      this.removeNotification(loadingId);
      this.showResultNotification(translationService.translate("offline_db.delete_error"), "danger");
      return false;
    }
  }

  private static showLoadingNotification(message: string): string {
    return store.addNotification({
      message,
      type: "default",
      container: "bottom-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 0 }
    });
  }

  private static removeNotification(id: string): void {
    if (id) store.removeNotification(id);
  }

  private static showResultNotification(message: string, type: "success" | "danger" | "warning"): void {
    store.addNotification({
      message,
      type,
      container: "bottom-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 3000, pauseOnHover: true, showIcon: true }
    });
  }

  // ARITHMETIC

  public static increment(value, seed) {
    return this.toDecimal(undefined, value) + this.toDecimal(undefined, seed);
  }

  public static decrament(value, value2) {
    return this.toDecimal(undefined, value) - this.toDecimal(undefined, value2);
  }

  public static sum(value, value2) {
    return this.toDecimal(undefined, value) + this.toDecimal(undefined, value2);
  }

  public static subtract(value, value2) {
    return this.toDecimal(undefined, value) - this.toDecimal(undefined, value2);
  }

  public static divide(value, value2) {
    return this.toDecimal(undefined, value) / this.toDecimal(undefined, value2);
  }

  public static multiply(value, value2) {
    return this.toDecimal(undefined, value) * this.toDecimal(undefined, value2);
  }

  public static subArray(value, startingIndex: number, count: number) {
    if (!value) return null;

    if (Array.isArray(value) && value.every((item) => typeof item === "number")) {
      const inputVal: number[] = value;
      const retVal: number[] = [];

      for (let i = startingIndex; i < startingIndex + count; i++) {
        if (i >= 0 && i < inputVal.length) {
          retVal.push(inputVal[i]);
        }
      }

      return retVal;
    }
    if (typeof value === "string") {
      return this.subString(value, startingIndex, count).split("");
    }
    if (Array.isArray(value)) {
      const retVal: any[] = [];

      for (let i = startingIndex; i < startingIndex + count; i++) {
        if (i >= 0 && i < value.length) {
          retVal.push(value[i]);
        }
      }

      return retVal;
    }

    return value;
  }

  public static subString(value: string | null | undefined, startingIndex: number, count: number): any {
    if (value === null || value === undefined) return null;
    return value.substring(startingIndex, startingIndex + count);
  }

  // public static concatenate(
  //   arrayOrString1: string | any[] | null | undefined,
  //   arrayOrString2: string | any[] | null | undefined
  // ): any {
  //   const isArr1 = Array.isArray(arrayOrString1);
  //   const isArr2 = Array.isArray(arrayOrString2);

  //   if (isArr1 || isArr2) {
  //     const result: any[] = [];

  //     if (isArr1) result.push(...(arrayOrString1 as any[]));
  //     else if (arrayOrString1 != null) result.push(arrayOrString1);

  //     if (isArr2) result.push(...(arrayOrString2 as any[]));
  //     else if (arrayOrString2 != null) result.push(arrayOrString2);

  //     return result.map((x) => x?.toString?.() ?? "").join("");
  //   }

  //   const s1 = arrayOrString1?.toString() ?? "";
  //   const s2 = arrayOrString2?.toString() ?? "";
  //   return s1 + s2;
  // }

  public static async iyzicoInitializeCheckoutForm(
    screen: any,
    cllbck: any,
    userName: string,
    pricingPlanReferenceCode: string,
    phoneNumber: string,
    identityNumber: string,
    address: string,
    city: string,
    country: string,
    zipCode: string
  ) {
    const ad = {
      address1: address,
      address2: "",
      city,
      country,
      zipCode
    } as IIyzicoAddressDto;
    const u = {
      userName,
      pricingPlanReferenceCode,
      address: ad,
      phoneNumber,
      identityNumber
    } as IIyzicoCheckoutFormDto;
    await IyzicoService.CheckoutForm(u)
      .then((response) => {
        if (response && response.data && response.data.checkoutFormContent) {
          screen?.props.showIyzicoDrawer({ data: response.data }, cllbck, screen);
        } else {
          KuikaAppManager.hideSpinner(screen);
        }
      })
      .catch(() => {
        KuikaAppManager.hideSpinner(screen);
      });
  }

  public static generateLink(screenName?: string, parameters?: { [key: string]: any }) {
    let linkString = window.location.href;

    if (screenName) {
      let lastIndex = linkString.lastIndexOf("/");
      if (lastIndex !== -1) {
        linkString = linkString.substring(0, lastIndex);
        linkString += `/${screenName}`;
      }
    }

    if (Object.keys(parameters).length > 0) {
      linkString += "?";
    }

    let index: number = 0;
    for (const [key, value] of Object.entries(parameters)) {
      const escapedString: string = encodeURIComponent(String(value));
      linkString += `${key}=${escapedString}`;
      if (index < Object.keys(parameters).length - 1) {
        linkString += "&";
      }
      index += 1;
    }

    return linkString;
  }

  public static runUIVisionMacro(stringifiedMacro: string) {
    try {
      const json = JSON.parse(stringifiedMacro);

      const isExtensionLoaded = function () {
        const $root = document.documentElement;
        return !!$root && !!$root.getAttribute("data-kantu");
      };
      const openExternal = function (url) {
        const $el = document.createElement("a");
        $el.setAttribute("target", "_blank");
        $el.setAttribute("href", url);
        $el.style.position = "absolute";
        $el.style.top = "-9999px";
        $el.style.left = "-9999px";
        document.body.appendChild($el);
        $el.click();
        setTimeout(() => {
          $el.remove();
        }, 200);
      };
      const openWebsite = function () {
        openExternal("https://ui.vision/rpa/home/getrpa");
      };
      if (!isExtensionLoaded()) {
        if (confirm("UI.Vision RPA is not installed yet. Do you want to download it now?")) {
          return openWebsite();
        }
      } else {
        return window.dispatchEvent(
          new CustomEvent("kantuSaveAndRunMacro", {
            detail: {
              direct: 1,
              closeRpa: 1,
              json
            }
          })
        );
      }
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  public static async copyToClipboard(value?: string) {
    try {
      await navigator.clipboard.writeText(value);
    } catch (e) {
      KMainFunctions.exceptionHandler(e);
    }
  }

  public static signinwithgoogle(screen: any): Promise<{}> {
    screen.props.googleLogin();
    localStorage.setItem("isGoogleLoginInProgress", "true");
    localStorage.setItem("isGoogleLoginAborted", "false");

    const previousUser = _.cloneDeep(window.userInfo ?? {});

    return new Promise((resolve, reject) => {
      const interval = setInterval(() => {
        if (localStorage.getItem("isGoogleLoginInProgress") === "false") {
          clearInterval(interval);
          if (localStorage.getItem("isGoogleLoginAborted") === "true") {
            localStorage.removeItem("isGoogleLoginInProgress");
            localStorage.removeItem("isGoogleLoginAborted");
            KuikaAppManager.hideSpinner(screen);
            reject();
          } else {
            resolve({});
          }

          if (previousUser && !_.isEqual(previousUser, window.userInfo)) {
            clearInterval(interval);
            localStorage.removeItem("isGoogleLoginInProgress");
            localStorage.removeItem("isGoogleLoginAborted");
            resolve({});
          }
        }
      }, 200);
    });
  }

  public static getPublicIpAddress(): string {
    try {
      // Send a cross-origin request to get the public IP address
      const request = new XMLHttpRequest();
      request.open("GET", "https://api.ipify.org?format=json", false);
      request.send(null);
      if (request.status === 200) {
        const response = JSON.parse(request.responseText);
        return response.ip;
      }
      return "";
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return "";
    }
  }

  public static sendVerificationCode(screen: any) {
    UserService.SendVerificationCode({
      email: USER,
      dontSendEmail: false,
      language: ""
    })
      .then(() => {})
      .catch((e) => {
        KMainFunctions.exceptionHandler(e);
      });

    return "Mail send";
  }

  public static async generateOTP(userName: string) {
    const TOTP = (await import("totp-generator")).TOTP;

    const secret = this.convertToOtpSecret(userName.toLowerCase());

    let algorithm: "SHA-1" | "SHA-256" | "SHA-512" = "SHA-1";

    if (OTP_ALGORITHM === "SHA256") algorithm = "SHA-256";
    else if (OTP_ALGORITHM === "SHA512") algorithm = "SHA-512";

    const generatedOTP = await TOTP.generate(secret, {
      period: OTP_PERIOD,
      digits: OTP_DIGITS,
      algorithm
    });

    return generatedOTP.otp;
  }

  public static generateAuthenticatorAppUri(userName?: string) {
    try {
      const language = localStorage.getItem("ml");
      if (!userName) {
        let message = "";
        switch (language) {
          case "en_US":
            message = "Unable to generate authenticator app (OTP) URI without username.";
            break;

          case "fr_FR":
            message = "Impossible de générer l'URI de l'application d'authentification (OTP) sans nom d'utilisateur.";
            break;

          case "tr_TR":
            message = "Kullanıcı adı olmadan Kimlik Doğrulayıcı (OTP) ugulama URI'yı oluşturulamaz.";
            break;
        }
        throw new Error(message);
      }

      if (!OTP_SECRET_KEY) {
        let message = "Authenticator (OTP) application settings are missing. Please contact your Administrator";
        switch (language) {
          case "en_US":
            message = "Authenticator (OTP) application settings are missing. Please contact your Administrator";
            break;

          case "fr_FR":
            message =
              "Les paramètres de l'application Authentificateur (OTP) sont manquants. Veuillez contacter votre administrateur";
            break;

          case "tr_TR":
            message = "Kimlik Doğrulayıcı (OTP) uygulama ayarları eksik. Lütfen Yöneticinizle iletişime geçin";
            break;
        }
        throw new Error(message);
      }
      const usrName = userName?.toString()?.toLowerCase() ?? "";
      const domainName = this.removeSpecialCharacter(window.kuika?.info?.workspace ?? "");
      const secret = this.convertToOtpSecret(usrName);
      const url = `otpauth://totp/${domainName}:${usrName}?secret=${secret}&issuer=${domainName}&algorithm=${OTP_ALGORITHM}&digits=${OTP_DIGITS}&period=${OTP_PERIOD}`;
      return url;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return "";
    }
  }

  public static convertToOtpSecret(userName: string) {
    const secretKey: string = `${userName.toLowerCase()}${OTP_SECRET_KEY}KUIKAMOBILEKEYKUIKAMOBILEKEY2345KUIKAMOBILEKEYKUIKAMOBILEKEY2345`;
    const secret = this.subString(this.ignoreNonAllowedCharacters4Base32Secret(secretKey), 0, 64);

    return secret ?? "";
  }

  public static async changeTwoFactorAuthenticationType(authenticationType) {
    try {
      await UserService.ChangeTwoFactorAuthenticationType({
        authenticationType
      });
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  public static removeSpecialCharacter(value: string): string {
    return value.replace(/[^A-Za-z0-9 ]/g, "");
  }

  public static ignoreNonAllowedCharacters4Base32Secret(value: string) {
    return value.replace(/[^A-Za-z2-7 ]/g, "");
  }

  public static importTableConfigs = (screen, tableName, configJSON) => {
    const screenTable = Object.keys(screen).filter((v) => v.includes(tableName));
    const refTable = screenTable.find((v) => v.includes("kuikaTableRef") || v.includes("kuikaPivotTableRef"));
    if (
      screen[refTable] != undefined &&
      screen[refTable] != null &&
      screen[refTable].current != undefined &&
      screen[refTable].current != null &&
      screen[refTable].current.setTableConfigJson != undefined &&
      configJSON != undefined &&
      configJSON != null &&
      configJSON != ""
    ) {
      screen[refTable].current.setTableConfigJson(configJSON);
    }
  };

  public static exportTableConfigs = (screen, tableName) => {
    const screenTable = Object.keys(screen).filter((v) => v.includes(tableName));
    const refTable = screenTable.find((v) => v.includes("kuikaTableRef") || v.includes("kuikaPivotTableRef"));
    if (
      screen[refTable] != undefined &&
      screen[refTable] != null &&
      screen[refTable].current != undefined &&
      screen[refTable].current != null &&
      screen[refTable].current.getTableConfigJson != undefined
    ) {
      return screen[refTable].current.getTableConfigJson();
    }
    return "";
  };

  public static clearTableFilteringConfigs = (screen, tableName) => {
    const screenTable = Object.keys(screen).filter((v) => v.includes(tableName));
    const refTable = screenTable.find((v) => v.includes("kuikaTableRef"));
    if (
      screen[refTable] != undefined &&
      screen[refTable] != null &&
      screen[refTable].current != undefined &&
      screen[refTable].current != null &&
      screen[refTable].current.clearFilterConfigs != undefined
    ) {
      screen[refTable].current.clearFilterConfigs();
    }
  };

  public static resetTableConfigs = (screen, tableName) => {
    const screenTable = Object.keys(screen).filter((v) => v.includes(tableName));
    const refTable = screenTable.find((v) => v.includes("kuikaTableRef") || v.includes("kuikaPivotTableRef"));
    if (
      screen[refTable] != undefined &&
      screen[refTable] != null &&
      screen[refTable].current != undefined &&
      screen[refTable].current != null &&
      screen[refTable].current.resetTableConfigs != undefined
    ) {
      screen[refTable].current.resetTableConfigs();
    }
  };

  public static searchTable = (screen, tableName, searchText) => {
    const screenTable = Object.keys(screen).filter((v) => v.includes(tableName));
    const refTable = screenTable.find((v) => v.includes("kuikaTableRef") || v.includes("kuikaPivotTableRef"));
    if (
      screen[refTable] != undefined &&
      screen[refTable] != null &&
      screen[refTable].current != undefined &&
      screen[refTable].current != null &&
      screen[refTable].current.searchTable != undefined
    ) {
      screen[refTable].current.searchTable(searchText);
    }
  };

  public static exportTable = (screen, tableName) => {
    const screenTable = Object.keys(screen).filter((v) => v.includes(tableName));
    const refTable = screenTable.find((v) => v.includes("kuikaTableRef") || v.includes("kuikaPivotTableRef"));
    if (
      screen[refTable] != undefined &&
      screen[refTable] != null &&
      screen[refTable].current != undefined &&
      screen[refTable].current != null &&
      screen[refTable].current.exportTable != undefined
    ) {
      screen[refTable].current.exportTable();
    }
  };

  public static exportNodeTree = (screen, nodeTreeName) => {
    const screenKeys = Object.keys(screen).filter((v) => v.includes(nodeTreeName));
    const refKey = screenKeys.find((v) => v.includes("kuikaNodeTreeRef"));
    if (
      refKey &&
      screen[refKey] != undefined &&
      screen[refKey] != null &&
      screen[refKey].current != undefined &&
      screen[refKey].current != null &&
      screen[refKey].current.exportNodeTree != undefined
    ) {
      screen[refKey].current.exportNodeTree();
    }
  };

  public static readNFC = () => {
    KMainFunctions.displayWarningNotification("Action ReadNFC is not supported on web.");
    return null;
  };

  public static isInList(value1: unknown, value2: unknown): boolean {
    if (value1 === null || value1 === undefined || value2 === null || value2 === undefined) {
      return false;
    }
    if (Array.isArray(value2)) {
      const date1 = new Date(value1.toString());
      const isNotNaN = !isNaN(date1.getTime());

      for (let i = 0; i < value2.length; i++) {
        const date2 = new Date(value2[i].toString());
        if (isNotNaN && !isNaN(date2.getTime()) && date1.getTime() === date2.getTime()) {
          return true;
        }

        if (value2[i] === value1) {
          return true;
        }
      }
      return false;
    }
    return false;
  }

  public static async downloadFileFromServer(fileid, filename) {
    ServerFilesService.DownloadFile(fileid, filename);
    return "";
  }

  public static async downloadFileFromBucket(keyName, bucketName, fileName, encrypt) {
    ServerFilesService.DownloadFileFromBucket(keyName, bucketName, fileName, encrypt);
    return "";
  }

  public static async deleteFileFromServer(fileid) {
    return ServerFilesService.DeleteFile(fileid);
  }

  public static isDocumentReady() {
    switch (document.readyState) {
      case "complete":
        return true;
      default:
        return false;
    }
  }

  public static mqttpublish = (client, topic, message, qos, retain = false) => {
    if (!client || !client.connected) {
      console.error("MQTT client is not connected");
      return;
    }

    if (qos === undefined || qos === null) {
      qos = 0;
    }

    qos = Number(qos);

    client.publish(topic, message, { qos, retain }, (error) => {
      if (error) {
        console.error("MQTT publish failed:", error);
      }
    });
  };

  public static mqttsubscribe = async (client, subscribeAction, topic) => {
    return new Promise((resolve, reject) => {
      const mqttTopic = topic;

      if (!client._resubscribeTopics || !client._resubscribeTopics[topic]) {
        client.subscribe(topic, { nl: false }, (err) => {
          if (err) {
            resolve({ isSuccess: false });
          }

          client.on("message", (topic, message) => {
            if (mqttTopic === topic) {
              subscribeAction(message.toString());
            }
          });

          resolve({ isSuccess: true });
        });
      } else {
        resolve({ isSuccess: true });
      }
    });
  };

  public static getMqttClientId(clientName, screenName) {
    var mqttClientId = this.readFromLocalStorage(`${clientName}_${screenName}_MQTT_CLIENT_ID`);
    if (mqttClientId === undefined || mqttClientId === null) {
      mqttClientId = Guid.create().toString();
      this.writeToLocalStorage(`${clientName}_${screenName}_MQTT_CLIENT_ID`, mqttClientId);
    }
    return mqttClientId;
  }

  public static async openImportMappedExcelModal(
    screen: any,
    datasourceId: string,
    tableName: string,
    primaryKey: string,
    mappedColumnsJson: string,
    parametersJson?: string,
    ...paramValues: any[]
  ) {
    const mappedColumns: IImportMappedExcelColumnMapDefinition[] = JSON.parse(mappedColumnsJson);
    const parameterDefinitions: IImportMappedExcelParameter[] = parametersJson ? JSON.parse(parametersJson) : [];

    // Combine parameter metadata with values
    const parameters = parameterDefinitions.map((def, index) => ({
      ...def,
      value: paramValues[index]
    }));

    screen?.props?.showImportMappedExcelModal(datasourceId, tableName, primaryKey, mappedColumns, parameters);

    return new Promise<void>((resolve, reject) => {
      const interval = setInterval(() => {
        if (screen.props.isImportMappedExcelModalVisible === false) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }

  public static async VerifyRecaptchaToken(token: string) {
    if (!token) {
      this.notify(null, "Recaptcha token is missing.", "danger", "bottom-right", null, null, null, null);
      return false;
    }

    return true;
  }

  public static async confirmation(
    confirmationMessage: string,
    confirmationFontFamily: string = "Poppins",
    _confirmationHeader: string,
    _icon: "warning" | "trash" | "info" | "question" | "confirmation" | "notification",
    _iconBackgroundColor: string
  ): Promise<boolean> {
    const confirmationHeader = _confirmationHeader || null;
    const icon = _icon || null;
    const iconBackgroundColor = _iconBackgroundColor || "#246dff";

    const warningIcon = `<img src="common/alert-triangle.svg" alt="warning" style="width: 40px; height: 40px;" />`;
    const trashIcon = `<img src="common/trash.svg" alt="trash" style="width: 40px; height: 40px;" />`;
    const infoIcon = `<img src="common/info-circle.svg" alt="info" style="width: 40px; height: 40px;" />`;
    const questionIcon = `<img src="common/question-mark.svg" alt="question" style="width: 40px; height: 40px;" />`;
    const confirmationIcon = `<img src="common/check.svg" alt="confirmation" style="width: 40px; height: 40px;" />`;
    const notificationIcon = `<img src="common/bell.svg" alt="notification" style="width: 40px; height: 40px;" />`;

    const iconMap = {
      warning: warningIcon,
      trash: trashIcon,
      info: infoIcon,
      question: questionIcon,
      confirmation: confirmationIcon,
      notification: notificationIcon
    };

    const modalOptions: any = {
      title: confirmationMessage,
      icon: icon ? iconMap[icon] : undefined,
      showCancelButton: true,
      confirmButtonText: translationService.translate("common.confirm", localStorage.getItem("ml") as ELanguage),
      cancelButtonText: translationService.translate("common.cancel", localStorage.getItem("ml") as ELanguage),
      customClass: {
        title: `swal2-font-${confirmationFontFamily.toLowerCase().replaceAll(" ", "-")}`,
        confirmButton: `swal2-font-${confirmationFontFamily.toLowerCase().replaceAll(" ", "-")}`,
        cancelButton: `swal2-font-${confirmationFontFamily.toLowerCase().replaceAll(" ", "-")}`,
        container: `swal2-font-${confirmationFontFamily.toLowerCase().replaceAll(" ", "-")}`
      }
    };

    if (confirmationHeader && confirmationHeader !== "") {
      modalOptions.html = `
        <div style="margin-bottom: 16px;">
          <h3 style="font-size: 28px; margin: 0 0 24px 0;">${confirmationHeader}</h3>
          <p>${confirmationMessage}</p>
        </div>`;
      modalOptions.header = `<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; width: 100%; border-bottom: 1px solid #DCDFE4; padding-bottom: 12px;">
              <span style="font-size: 12px; font-weight: 700; text-transform: uppercase; margin: 0 12px 0 12px;">${confirmationHeader}</span>
              <div id="swal-close-button" style="cursor: pointer; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; margin-right: 12px;">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
          </div>`;
      delete modalOptions.title;

      modalOptions.didOpen = () => {
        const closeButton = document.getElementById("swal-close-button");
        if (closeButton) {
          closeButton.addEventListener("click", () => Swal.close());
        }
      };
    }

    if (icon) {
      modalOptions.html = modalOptions.html || `<p>${confirmationMessage}</p>`;
      const backgroundColor = iconBackgroundColor || "#246dff";
      const backgroundColor2 = this.lightenColor(backgroundColor, 95);
      const iconContent = iconMap[icon] || icon;
      const gradient = `linear-gradient(37deg, ${backgroundColor} -4.04%, ${backgroundColor2} 68.6%)`;
      modalOptions.html = `
        <div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 16px; width: 400px; border-bottom: 1px solid #DCDFE4; padding-bottom: 12px;">
        ${modalOptions.header || ""}
        <div style="background: ${gradient}; width: 80px; height: 80px; border-radius: 16px; display: flex; align-items: center; justify-content: center; margin-bottom: 24px; box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.12); margin-top: ${
          confirmationHeader ? "0" : "16px"
        };">
            <span>${iconContent}</span>
          </div>
          ${
            confirmationHeader
              ? `<h3 style="font-size: 16px; font-weight: 600; margin: 0 0 16px 0;">${confirmationHeader}</h3>`
              : ""
          }
          <p style="margin: 0; color: #41546E; font-size: 14px; font-weight: 400; padding: 0 12px; marginBottom: ${
            confirmationHeader ? "0" : "16px"
          }">${confirmationMessage}</p>
        </div>`;
      delete modalOptions.title;
      delete modalOptions.icon;
    } else {
      modalOptions.html = `
        <div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 16px; width: 400px; border-bottom: 1px solid #DCDFE4; padding-bottom: 12px;">
        ${modalOptions.header || ""}
          ${
            confirmationHeader
              ? `<h3 style="font-size: 16px; font-weight: 600; margin: 0 0 16px 0;">${confirmationHeader}</h3>`
              : ""
          }
          <p style="margin: 0; color: #41546E; font-size: 14px; font-weight: 400; padding: ${
            !confirmationHeader ? "12px" : "0 12px"
          }; marginBottom: ${confirmationHeader ? "0" : "16px"}">${confirmationMessage}</p>
        </div>`;
      delete modalOptions.title;
      delete modalOptions.icon;
    }

    return (await Swal.fire(modalOptions)).isConfirmed;
  }

  private static lightenColor(hex: string, percent: number): string {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    }

    r = Math.min(255, Math.round(r + (255 - r) * (percent / 120)));
    g = Math.min(255, Math.round(g + (255 - g) * (percent / 120)));
    b = Math.min(255, Math.round(b + (255 - b) * (percent / 120)));

    return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
  }

  public static getEntityValueFromDynamicForm(screen: any, diId: number) {
    if (!screen) return null;
    if (typeof screen !== "object") return null;

    const dynamicFormKey = Object.keys(screen).find((key) => key.endsWith(`${diId}_value_kuikaDynamicFormRef`));

    if (dynamicFormKey && screen[dynamicFormKey] && screen[dynamicFormKey].current) {
      return screen[dynamicFormKey].current.generateEntityValue();
    }
    return null;
  }

  public static clearDynamicForm(screen: any, diId: number) {
    if (!screen) return null;
    if (typeof screen !== "object") return null;

    const dynamicFormKey = Object.keys(screen).find((key) => key.endsWith(`${diId}_value_kuikaDynamicFormRef`));

    if (dynamicFormKey && screen[dynamicFormKey] && screen[dynamicFormKey].current) {
      screen[dynamicFormKey].current.clearForm();
    }

    return null;
  }

  public static setEntityAttributeValueInDynamicForm(screen: any, diId: number, attributeId: string, value: any) {
    if (!screen) return null;
    if (typeof screen !== "object") return null;

    const dynamicFormKey = Object.keys(screen).find((key) => key.endsWith(`${diId}_value_kuikaDynamicFormRef`));

    if (dynamicFormKey && screen[dynamicFormKey] && screen[dynamicFormKey].current) {
      screen[dynamicFormKey].current.setEntityAttributeValue(attributeId, value);
    }

    return null;
  }

  public static getEntityAttributeValueInDynamicForm(screen: any, diId: number, attributeId: string) {
    if (!screen) return null;
    if (typeof screen !== "object") return null;

    const dynamicFormKey = Object.keys(screen).find((key) => key.endsWith(`${diId}_value_kuikaDynamicFormRef`));

    if (dynamicFormKey && screen[dynamicFormKey] && screen[dynamicFormKey].current) {
      return screen[dynamicFormKey].current.getEntityAttributeValue(attributeId);
    }

    return null;
  }

  public static getIsDynamicFormValid(screen: any, diId: number): boolean {
    if (!screen) return false;
    if (typeof screen !== "object") return false;

    const dynamicFormKey = Object.keys(screen).find((key) => key.endsWith(`${diId}_value_kuikaDynamicFormRef`));

    if (dynamicFormKey && screen[dynamicFormKey] && screen[dynamicFormKey].current) {
      return screen[dynamicFormKey].current.getIsFormValid();
    }

    return false;
  }

  public static getWfPageComponent(screen: any, screenName: string, callback?: any, drawerId?: string) {
    const closeCallback =
      callback ||
      (() => {
        if (drawerId && screen.setState) {
          screen.setState({ [`NavVisible${drawerId}`]: false }, () => {
            if (screen.callCallbackFunction) {
              screen.callCallbackFunction(Number.parseInt(drawerId));
            }
          });
        }
      });
    const props = {
      onClose: closeCallback,
      screenInputs: window.kuika.navigationScreenInputs,
      navigator: screen.props?.navigator,
      form: screen.props?.form,
      context: screen.props?.context
    };
    
  }

  public static addToBag(scope: any, key: string, bagItem: any): boolean {
    ReactSystemFunctions.bags[key] = bagItem;
    return true;
  }

  public static removeFromBag(scope: any, key: string): boolean {
    if (ReactSystemFunctions.bags[key]) {
      delete ReactSystemFunctions.bags[key];
      return true;
    }
    return false;
  }

  public static clearBag(scope: any): boolean {
    ReactSystemFunctions.bags = {};
    return true;
  }

  public static getFromBag(scope: any, key: string): any {
    return ReactSystemFunctions.bags[key] || null;
  }

  public static bagHasKey(scope: any, key: string): boolean {
    return ReactSystemFunctions.bags.hasOwnProperty(key);
  }

  public static toggleLayout(screen: any, position: string): boolean {
    if (!screen || !position) {
      return false;
    }

    const validPositions = ["left", "right", "top", "bottom"];
    if (!validPositions.includes(position.toLowerCase())) {
      return false;
    }

    const pos = position.toLowerCase();
    let targetElementId: string;
    let layoutDiId: number;

    switch (pos) {
      case "left":
        targetElementId = "layout_left";
        layoutDiId = -12;
        break;
      case "right":
        targetElementId = "layout_right";
        layoutDiId = -13;
        break;
      case "top":
        targetElementId = "layout_header";
        layoutDiId = -10;
        break;
      case "bottom":
        targetElementId = "layout_footer";
        layoutDiId = -11;
        break;
      default:
        return false;
    }

    try {
      const matchingElements = document.querySelectorAll(`[id*="${targetElementId}"]`);
      if (!matchingElements?.length) {
        return false;
      }
      const lastIndex = matchingElements.length - 1;
      const targetElement = matchingElements[lastIndex] as HTMLElement;

      const currentVisibility = window.getComputedStyle(targetElement).visibility;
      const isCurrentlyVisible = currentVisibility !== "hidden";

      if (isCurrentlyVisible) {
        targetElement.style.display = "none";
        targetElement.style.width = "0px";
        targetElement.style.height = "0px";
        targetElement.style.overflow = "hidden";
        targetElement.style.visibility = "hidden";
      } else {
        targetElement.style.display = "";
        targetElement.style.width = "";
        targetElement.style.height = "";
        targetElement.style.overflow = "";
        targetElement.style.visibility = "visible";
      }

      return true;
    } catch (error) {
      console.error("Error in toggleLayout:", error);
      return false;
    }
  }

  public static getAppDateFormat(): string | null {
    return "";
  }

  public static getAppTimeFormat(): string | null {
    return "";
  }

  // Cache Functions
  public static async pushToCache(scope: any, key: string, cacheItem: any): Promise<any> {
    try {
      const itemString = JSON.stringify(cacheItem);
      const request = {
        key,
        value: itemString,
        cacheRegion: 12
      };
      const response = await CacheService.PushToCache(request);
      return response.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async fetchFromCache(scope: any, key: string): Promise<any> {
    try {
      const response = await CacheService.FetchFromCache(key, 12);
      if (response.data?.value) {
        return JSON.parse(response.data.value);
      }
      return null;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async fetchFromCacheToList(scope: any, key: string): Promise<any[]> {
    try {
      const response = await CacheService.FetchFromCache(key, 12);
      if (response.data?.value) {
        const result = JSON.parse(response.data.value);
        if (Array.isArray(result)) {
          return result;
        }
      }
      return [];
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return [];
    }
  }

  public static async removeFromCache(scope: any, key: string): Promise<any> {
    try {
      const response = await CacheService.RemoveFromCache(key, 12);
      return response.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async checkKeyExistence(scope: any, key: string): Promise<{ isExist: boolean }> {
    try {
      const response = await CacheService.CheckKeyExistence(key, 12);
      return response.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  

  // ── Document Management System Actions ───────────────────────────

  /**
   * GET /v1/api/documentmanagement/tree — Returns a flat node list for the Directory element.
   * Folders are always returned in full; documents are paginated.
   * The X-Total-Documents response header carries the total count for the Pagination element.
   * @param folderId    Optional: returns only the subtree of this folder
   * @param page        Page number (default: 1)
   * @param pageSize    Number of documents per page (default: 50, max: 200)
   * @param searchQuery Search filter by document name (optional)
   */
  public static async getDocumentTree(
    screen: any,
    folderId?: string,
    page?: number,
    pageSize?: number,
    searchQuery?: string,
    hideEmptyFolders?: boolean,
    createdBy?: string
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      // RootNodeId (Guid.Empty = "00000000-0000-0000-0000-000000000000") is a synthetic sentinel
      // injected by the backend when no folderId is given. Sending it back as a Guid parameter
      // would select the wrong folder (or cause a 404). Treat it as "no folder" instead.
      if (folderId && folderId !== "00000000-0000-0000-0000-000000000000") params.set("folderId", folderId);
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (searchQuery) params.set("searchQuery", searchQuery);
      if (hideEmptyFolders) params.set("hideEmptyFolders", "true");
      if (createdBy) params.set("createdBy", createdBy);
      const qs = params.toString();
      const url = qs ? `documentmanagement/tree?${qs}` : "documentmanagement/tree";
      const result = await KuikaAppManager.ApiRequest(screen, url, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/archived-tree — Returns a flat node list of archived documents with their folders.
   * Same shape as getDocumentTree — use with the Directory element.
   * hideEmptyFolders defaults to true (only folders containing archived documents are returned).
   * @param folderId         Optional: returns only the subtree of this folder
   * @param page             Page number (default: 1)
   * @param pageSize         Number of documents per page (default: 50, max: 200)
   * @param searchQuery      Search filter by document name (optional)
   * @param hideEmptyFolders Omit folders with no archived documents (default: true)
   */
  public static async getArchivedDocumentTree(
    screen: any,
    folderId?: string,
    page?: number,
    pageSize?: number,
    searchQuery?: string,
    hideEmptyFolders?: boolean
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (folderId && folderId !== "00000000-0000-0000-0000-000000000000") params.set("folderId", folderId);
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (searchQuery) params.set("searchQuery", searchQuery);
      // hideEmptyFolders defaults to true on the server side; only send when explicitly false
      if (hideEmptyFolders === false) params.set("hideEmptyFolders", "false");
      const qs = params.toString();
      const url = qs ? `documentmanagement/archived-tree?${qs}` : "documentmanagement/archived-tree";
      const result = await KuikaAppManager.ApiRequest(screen, url, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/folders/tree — Returns a flat folder-only node list.
   * No documents are included. Each node: { id, name, parentId, nodeType: "folder" }.
   * Suitable for folder-picker UIs (e.g. a move-to-folder dialog).
   * @param folderId       Optional: returns only the subtree of this folder
   * @param folderPage     Folder page number (default: 1)
   * @param folderPageSize Number of folders per page (default: 200, max: 1000)
   */
  public static async getDocumentFolderTree(
    screen: any,
    folderId?: string,
    folderPage?: number,
    folderPageSize?: number,
    searchQuery?: string,
    hideEmptyFolders?: boolean
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (folderId && folderId !== "00000000-0000-0000-0000-000000000000") params.set("folderId", folderId);
      if (folderPage) params.set("folderPage", String(folderPage));
      if (folderPageSize) params.set("folderPageSize", String(folderPageSize));
      if (searchQuery) params.set("searchQuery", searchQuery);
      if (hideEmptyFolders) params.set("hideEmptyFolders", "true");
      const qs = params.toString();
      const url = qs ? `documentmanagement/folders/tree?${qs}` : "documentmanagement/folders/tree";
      const result = await KuikaAppManager.ApiRequest(screen, url, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/folders/{folderId}/documents
   * Returns the paginated list of documents directly inside the given folder (non-recursive).
   * Each node: { id, name, parentId, mimeType, nodeType: "document" }.
   * The X-Total-Documents response header carries the total count for the Pagination element.
   * @param folderId    Required: the folder whose documents to list
   * @param page        Page number (default: 1)
   * @param pageSize    Documents per page (default: 50, max: 200)
   * @param searchQuery Filter by document name (optional)
   */
  public static async getFolderDocuments(
    screen: any,
    folderId: string,
    page?: number,
    pageSize?: number,
    searchQuery?: string
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (searchQuery) params.set("searchQuery", searchQuery);
      const qs = params.toString();
      const base = `documentmanagement/folders/${folderId}/documents`;
      const url = qs ? `${base}?${qs}` : base;
      const result = await KuikaAppManager.ApiRequest(screen, url, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * DELETE /v1/api/documentmanagement/{documentId}/share/{shareId}
   * Revokes (invalidates) a specific share link. Use shareId from getDocumentShares.
   * Requires manage permission on the document.
   * @param documentId Required: document GUID
   * @param shareId    Required: share link GUID to revoke
   */
  public static async revokeShareLink(screen: any, documentId: string, shareId: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/share/${shareId}`,
        undefined,
        "delete"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * GET /v1/api/documentmanagement/stats — Returns aggregate storage statistics.
   * Result: { totalDocuments, archivedDocuments, totalFolders, totalStorageBytes, documentsByMimeType }
   * @param folderId Optional: limit stats to this folder
   * @param includeSubfolders Optional (default true): when false, only the folder itself is counted (no subtree)
   */
  public static async getStorageStats(screen: any, folderId?: string, includeSubfolders?: boolean): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (folderId) params.set("folderId", folderId);
      if (includeSubfolders !== undefined) params.set("includeSubfolders", String(includeSubfolders));
      const qs = params.toString();
      const url = `documentmanagement/stats${qs ? `?${qs}` : ""}`;
      const result = await KuikaAppManager.ApiRequest(screen, url, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: null };
    }
  }

  /**
   * GET /v1/api/documentmanagement/folders/{folderId}/permissions
   * Lists permission grants on a folder (principalType, principalId, permissionLevel, expiresAt).
   * Requires manage permission on the folder.
   * @param folderId Required: folder GUID
   * @param page     Page number (default: 1)
   * @param pageSize Items per page (default: 100)
   */
  public static async getFolderPermissions(
    screen: any,
    folderId: string,
    page?: number,
    pageSize?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      const qs = params.toString();
      const base = `documentmanagement/folders/${folderId}/permissions`;
      const result = await KuikaAppManager.ApiRequest(screen, qs ? `${base}?${qs}` : base, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/{documentId}/share
   * Lists active (non-expired) share links for a document.
   * Fields: id, permissionLevel, expiresAt, maxUseCount, useCount, createdAt.
   * ShareToken is intentionally excluded. Requires manage permission.
   * @param documentId Required: document GUID
   * @param page       Page number (default: 1)
   * @param pageSize   Items per page (default: 50)
   */
  public static async getDocumentShares(
    screen: any,
    documentId: string,
    page?: number,
    pageSize?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      const qs = params.toString();
      const base = `documentmanagement/${documentId}/share`;
      const result = await KuikaAppManager.ApiRequest(screen, qs ? `${base}?${qs}` : base, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/mine
   * Returns non-archived documents uploaded by the current user, newest first.
   * The X-Total-Documents response header carries the total count.
   * @param page          Page number (default: 1)
   * @param pageSize      Documents per page (default: 50, max: 200)
   * @param includeShared When true, also returns documents shared with the user (default: false)
   */
  public static async getMyDocuments(
    screen: any,
    page?: number,
    pageSize?: number,
    includeShared?: boolean,
    sortBy?: string
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (includeShared !== undefined) params.set("includeShared", String(includeShared));
      if (sortBy) params.set("sortBy", sortBy);
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/mine?${qs}` : "documentmanagement/mine",
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/folders/{folderId}/subfolders
   * Returns direct child subfolders (one level only, not recursive).
   * Each node: { id, name, parentId, nodeType: "folder" }.
   * The X-Total-Folders response header carries the total count.
   * @param folderId Required: parent folder GUID
   * @param page     Page number (default: 1)
   * @param pageSize Items per page (default: 200)
   */
  public static async getFolderSubfolders(
    screen: any,
    folderId: string,
    page?: number,
    pageSize?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      const qs = params.toString();
      const base = `documentmanagement/folders/${folderId}/subfolders`;
      const result = await KuikaAppManager.ApiRequest(screen, qs ? `${base}?${qs}` : base, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/{documentId} — Returns metadata for a single document.
   * Fields: id, documentName, mimeType, currentVersion, isArchived, folderId, downloadUrl.
   * @param documentId Required: document GUID
   */
  public static async getDocumentMetadata(screen: any, documentId: string): Promise<any> {
    try {
      const result = await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}`, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: null };
    }
  }

  /**
   * GET /v1/api/documentmanagement/{documentId}/versions — Returns all versions of a document.
   * Each item: { id, version, contentSize, contentHash, createdAt, createdUserId }.
   * @param documentId Required: document GUID
   */
  public static async getDocumentVersions(screen: any, documentId: string): Promise<any> {
    try {
      const result = await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/versions`,
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * DELETE /v1/api/documentmanagement/folders/{folderId} — Deletes an empty folder.
   * Returns true on success. The folder must contain no subfolders or documents.
   * @param folderId Required: folder GUID
   */
  public static async deleteFolder(screen: any, folderId: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/folders/${folderId}`, undefined, "delete");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * PUT /v1/api/documentmanagement/folders/{folderId}/move — Moves a folder under a new parent.
   * Pass null/empty for targetParentId to move to the root level.
   * @param folderId       Required: folder GUID to move
   * @param targetParentId Optional: new parent folder GUID (null = root)
   */
  public static async moveFolder(screen: any, folderId: string, targetParentId?: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/folders/${folderId}/move`,
        { targetParentId: targetParentId || null },
        "put"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * GET /v1/api/documentmanagement/{documentId}/permissions — Lists permission grants on a document.
   * Each item: { id, principalType, principalId, permissionLevel, expiresAt }.
   * Requires manage permission.
   * @param documentId Required: document GUID
   * @param page       Page number (default: 1)
   * @param pageSize   Items per page (default: 100)
   */
  public static async getDocumentPermissions(
    screen: any,
    documentId: string,
    page?: number,
    pageSize?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      const qs = params.toString();
      const base = `documentmanagement/${documentId}/permissions`;
      const result = await KuikaAppManager.ApiRequest(screen, qs ? `${base}?${qs}` : base, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement?includeArchived=true — Lists archived documents.
   * The X-Total-Count response header carries the total count for the Pagination element.
   * @param page     Page number (default: 1)
   * @param pageSize Documents per page (default: 50, max: 200)
   */
  public static async getArchivedDocuments(
    screen: any,
    page?: number,
    pageSize?: number,
    archivedAfter?: string,
    archivedBefore?: string,
    sortBy?: string
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      params.set("includeArchived", "true");
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (archivedAfter) params.set("archivedAfter", archivedAfter);
      if (archivedBefore) params.set("archivedBefore", archivedBefore);
      if (sortBy) params.set("sortBy", sortBy);
      const result = await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement?${params.toString()}`,
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * POST /v1/api/documentmanagement/{documentId}/duplicate — Duplicates a document into a target folder.
   * The duplicate is fully independent (new encryption key, name gets " (copy)" suffix).
   * Returns the new document metadata.
   * @param documentId     Required: source document GUID
   * @param targetFolderId Optional: destination folder GUID (null = root)
   */
  public static async duplicateDocument(screen: any, documentId: string, targetFolderId?: string): Promise<any> {
    try {
      const result = await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/duplicate`,
        { folderId: targetFolderId || null },
        "post"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: null };
    }
  }

  /**
   * GET /v1/api/documentmanagement/search — Searches documents by name across all accessible documents.
   * Excludes archived documents. Sorted by creation date (newest first).
   * The X-Total-Documents response header carries the total count.
   * @param query    Search string (optional — returns all if omitted)
   * @param page     Page number (default: 1)
   * @param pageSize Documents per page (default: 50, max: 200)
   */
  public static async searchDocuments(
    screen: any,
    query?: string,
    page?: number,
    pageSize?: number,
    folderId?: string,
    createdAfter?: string,
    createdBefore?: string,
    createdBy?: string
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (query) params.set("query", query);
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (folderId) params.set("folderId", folderId);
      if (createdAfter) params.set("createdAfter", createdAfter);
      if (createdBefore) params.set("createdBefore", createdBefore);
      if (createdBy) params.set("createdBy", createdBy);
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/search?${qs}` : "documentmanagement/search",
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/{documentId}/audit — Returns the audit log for a document.
   * Each item: { action, userId, ipAddress, createdAt, details }.
   * Requires manage permission. The X-Total-Count header carries the total count.
   * @param documentId Required: document GUID
   * @param page       Page number (default: 1)
   * @param pageSize   Items per page (default: 50, max: 200)
   */
  public static async getDocumentAuditLog(
    screen: any,
    documentId: string,
    page?: number,
    pageSize?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      const qs = params.toString();
      const base = `documentmanagement/${documentId}/audit`;
      const result = await KuikaAppManager.ApiRequest(screen, qs ? `${base}?${qs}` : base, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/shared — Returns documents shared with the current user.
   * "Shared with me" view: documents explicitly granted via permissions, excluding own uploads.
   * The X-Total-Documents response header carries the total count.
   * @param page     Page number (default: 1)
   * @param pageSize Documents per page (default: 50, max: 200)
   */
  public static async getSharedWithMeDocuments(screen: any, page?: number, pageSize?: number): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/shared?${qs}` : "documentmanagement/shared",
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/shared-by-me — Returns documents the current user has shared with others.
   * Lists own documents that have at least one active permission grant.
   * The X-Total-Documents response header carries the total count.
   * @param page     Page number (default: 1)
   * @param pageSize Documents per page (default: 50, max: 200)
   */
  public static async getDocumentsSharedByMe(screen: any, page?: number, pageSize?: number): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/shared-by-me?${qs}` : "documentmanagement/shared-by-me",
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/recently-modified
   * Returns non-archived documents modified (or created) within the last N days. Sorted by most recently modified first.
   * @param days     Look-back window in days (default: 30)
   * @param page     Page number (default: 1)
   * @param pageSize Documents per page (default: 50, max: 200)
   */
  public static async getRecentlyModifiedDocuments(
    screen: any,
    days?: number,
    page?: number,
    pageSize?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (days) params.set("days", String(days));
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/recently-modified?${qs}` : "documentmanagement/recently-modified",
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/search/advanced — Advanced document search combining all filter parameters.
   * All parameters are optional. The X-Total-Documents header carries the total count.
   * @param query        Name search string (optional)
   * @param folderId     Restrict search to a folder subtree (optional)
   * @param createdAfter ISO date string (optional)
   * @param createdBefore ISO date string (optional)
   * @param createdBy    Creator user GUID (optional)
   * @param page         Page number (default: 1)
   * @param pageSize     Documents per page (default: 50, max: 200)
   */
  public static async searchDocumentsAdvanced(
    screen: any,
    query?: string,
    folderId?: string,
    createdAfter?: string,
    createdBefore?: string,
    createdBy?: string,
    page?: number,
    pageSize?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (query) params.set("query", query);
      if (folderId) params.set("folderId", folderId);
      if (createdAfter) params.set("createdAfter", createdAfter);
      if (createdBefore) params.set("createdBefore", createdBefore);
      if (createdBy) params.set("createdBy", createdBy);
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/search/advanced?${qs}` : "documentmanagement/search/advanced",
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/{documentId}/activity-summary
   * Returns: totalDownloads, lastDownloadAt, activePermissions, activeShares, totalVersions.
   * Requires manage permission on the document.
   * @param documentId Required: document GUID
   */
  public static async getDocumentActivitySummary(screen: any, documentId: string): Promise<any> {
    try {
      const result = await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/activity-summary`,
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: null };
    }
  }

  /**
   * GET /v1/api/documentmanagement/folders/{folderId}/stats
   * Returns: folderId, totalDocuments, archivedDocuments, subfolderCount, totalStorageBytes, lastUpdatedAt.
   * @param folderId          Required: folder GUID
   * @param includeSubfolders When true (default), recursively aggregates the entire subtree
   */
  public static async getFolderStats(screen: any, folderId: string, includeSubfolders?: boolean): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (includeSubfolders !== undefined) params.set("includeSubfolders", String(includeSubfolders));
      const qs = params.toString();
      const base = `documentmanagement/folders/${folderId}/stats`;
      const result = await KuikaAppManager.ApiRequest(screen, qs ? `${base}?${qs}` : base, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: null };
    }
  }

  /**
   * GET /v1/api/documentmanagement/admin/audit — Admin-level paginated audit log across ALL DMS entities.
   * Optional filters: action, userId, from/to date range, entityType.
   * Requires admin/manage role.
   */
  public static async getAllAuditLogs(
    screen: any,
    page?: number,
    pageSize?: number,
    action?: string,
    userId?: string,
    from?: string,
    to?: string,
    entityType?: string
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (action) params.set("action", action);
      if (userId) params.set("userId", userId);
      if (from) params.set("from", from);
      if (to) params.set("to", to);
      if (entityType) params.set("entityType", entityType);
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/admin/audit?${qs}` : "documentmanagement/admin/audit",
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * PUT /v1/api/documentmanagement/{documentId}/metadata — Sets (replaces) the free-form JSON metadata on a document.
   * Pass a valid JSON object as a string, e.g. '{"category":"invoice","year":"2026"}'.
   * Requires edit permission on the document.
   * @param documentId Required: document GUID
   * @param metadata   JSON string
   */
  public static async setDocumentMetadata(screen: any, documentId: string, metadata: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}/metadata`, { metadata }, "put");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * GET /v1/api/documentmanagement/by-metadata?key=&value= — Returns documents where Metadata JSON contains the given key/value pair.
   * Works on flat JSON values only (no nested objects).
   * The X-Total-Documents header carries the total count.
   * @param metadataKey   JSON key to match (e.g. "category")
   * @param metadataValue JSON value to match (e.g. "invoice")
   * @param page          Page number (default: 1)
   * @param pageSize      Documents per page (default: 50, max: 200)
   */
  public static async getDocumentsByMetadata(
    screen: any,
    metadataKey: string,
    metadataValue: string,
    page?: number,
    pageSize?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      params.set("key", metadataKey);
      params.set("value", metadataValue);
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      const result = await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/by-metadata?${params.toString()}`,
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/{documentId}/file — Downloads a document to the user's device.
   * Requires at least view permission.
   * @param documentId Required: document GUID
   * @param fileName   Optional: override the filename shown in the browser's save dialog.
   *                   If omitted, uses the filename from the Content-Disposition response header,
   *                   falling back to "document".
   * @param watermark  Optional: if true, the server applies the DMS watermark before streaming.
   *                   Requires watermarkView or higher permission; view-only users are blocked (403).
   */
  public static async downloadDocument(
    screen: any,
    documentId: string,
    fileName?: string,
    watermark?: boolean
  ): Promise<void> {
    try {
      const base = KuikaAppManager.GetBackendUrl().replace(/\/$/, "");
      const qs = watermark ? "?watermark=true" : "";
      const resp = await axios.get(`${base}/documentmanagement/${documentId}/file${qs}`, {
        responseType: "blob"
      });

      // Resolve filename: caller prop → Content-Disposition header → fallback
      let resolvedName = fileName?.trim() || undefined;
      if (!resolvedName) {
        const cd: string = resp.headers?.["content-disposition"] ?? "";
        // Handles both filename="foo.pdf" and filename*=UTF-8''foo.pdf
        const match = /filename\*?=(?:UTF-8'')?["']?([^;"'\r\n]+)/i.exec(cd);
        resolvedName = match ? decodeURIComponent(match[1].trim().replace(/['"]/g, "")) : "document";
      }

      KMainFunctions.downloadFile(resp.data, resolvedName);
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  /**
   * POST /v1/api/documentmanagement — Uploads a new document.
   * ⚠️ Maximum 50 MB. Use Chunked Upload for larger files.
   */
  public static async uploadDocument(
    screen: any,
    fileName: string,
    mimeType: string,
    base64Content: string,
    documentName?: string,
    folderId?: string
  ): Promise<string | null> {
    try {
      const raw = base64Content?.includes(",") ? base64Content.split(",")[1] : base64Content;

      // 50 MB validation — base64 length * 0.75 ≈ actual byte size
      const MAX_BYTES = 50 * 1024 * 1024;
      const estimatedBytes = Math.ceil((raw?.length ?? 0) * 0.75);
      if (estimatedBytes > MAX_BYTES) {
        const mb = Math.round(estimatedBytes / 1024 / 1024);
        throw new Error(
          `File size exceeds the 50 MB limit (estimated: ${mb} MB). Use Chunked Upload for larger files.`
        );
      }

      const bytes = atob(raw);
      const buf = new Uint8Array(bytes.length);
      for (let i = 0; i < bytes.length; i++) buf[i] = bytes.charCodeAt(i);
      const blob = new Blob([buf], { type: mimeType });

      const formData = new FormData();
      formData.append("file", blob, fileName);
      formData.append("documentName", documentName || fileName);
      if (folderId) formData.append("folderId", folderId);

      const result = await KuikaAppManager.ApiRequest(screen, "documentmanagement", formData, "post");
      return result?.data?.id ?? null;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** DELETE /v1/api/documentmanagement/{documentId} — Soft delete */
  public static async deleteDocument(screen: any, documentId: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}`, undefined, "delete");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /** POST /v1/api/documentmanagement/folders — Creates a new folder. @returns folderId */
  public static async createDocumentFolder(screen: any, name: string, parentFolderId?: string): Promise<string | null> {
    try {
      const result = await KuikaAppManager.ApiRequest(
        screen,
        "documentmanagement/folders",
        { name, parentFolderId: parentFolderId || null },
        "post"
      );
      return result?.data?.id ?? null;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** PUT /v1/api/documentmanagement/{documentId}/move — Moves the document to a folder. folderId=null → root */
  public static async moveDocument(screen: any, documentId: string, folderId?: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/move`,
        { folderId: folderId || null },
        "put"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /** PUT /v1/api/documentmanagement/folders/{folderId} — Renames the folder */
  public static async renameDocumentFolder(screen: any, folderId: string, name: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/folders/${folderId}`, { name }, "put");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * POST /v1/api/documentmanagement/{documentId}/share — Creates a share link.
   * @param expiresInDays  Number of days the link is valid (optional)
   * @returns shareUrl
   */
  public static async createDocumentShareLink(
    screen: any,
    documentId: string,
    expiresInDays?: number
  ): Promise<string | null> {
    try {
      const expiresAt = expiresInDays ? new Date(Date.now() + expiresInDays * 24 * 60 * 60 * 1000).toISOString() : null;
      const result = await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/share`,
        { permissionLevel: "view", expiresAt, maxUseCount: null },
        "post"
      );
      return result?.data?.shareUrl ?? null;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /**
   * POST /v1/api/documentmanagement/{documentId}/permissions — Grants permission to a user or role.
   * @param principalType  "user" (default) | "role"
   */
  public static async grantDocumentPermission(
    screen: any,
    documentId: string,
    principalId: string,
    permissionLevel: string,
    principalType?: string,
    expiresInDays?: number
  ): Promise<boolean> {
    const validLevels = ["view", "watermarkView", "edit", "manage"];
    if (!validLevels.includes(permissionLevel)) {
      KMainFunctions.exceptionHandler(
        new Error(`Invalid permissionLevel: "${permissionLevel}". Valid values: ${validLevels.join(", ")}`)
      );
      return false;
    }

    const validTypes = ["user", "role"];
    const resolvedType = principalType ?? "user";
    if (!validTypes.includes(resolvedType)) {
      KMainFunctions.exceptionHandler(new Error(`Invalid principalType: "${resolvedType}". Valid values: user, role`));
      return false;
    }

    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/permissions`,
        {
          principalType: resolvedType,
          principalId,
          permissionLevel,
          expiresAt: null,
          expiresInDays: expiresInDays ?? null
        },
        "post"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /** PATCH /v1/api/documentmanagement/{documentId} — Renames the document */
  public static async renameDocument(screen: any, documentId: string, name: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}`, { name }, "patch");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * DELETE /v1/api/documentmanagement/{documentId}/permissions/{permissionId}
   * Revokes a permission granted on the document.
   */
  public static async revokeDocumentPermission(
    screen: any,
    documentId: string,
    permissionId: string
  ): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/permissions/${permissionId}`,
        undefined,
        "delete"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * POST /v1/api/documentmanagement/folders/{folderId}/permissions
   * Grants permission on the folder. permissionLevel: view | edit | manage. principalType: user | role
   */
  public static async grantFolderPermission(
    screen: any,
    folderId: string,
    principalId: string,
    permissionLevel: string,
    principalType?: string,
    expiresInDays?: number
  ): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/folders/${folderId}/permissions`,
        {
          principalType: principalType ?? "user",
          principalId,
          permissionLevel,
          expiresAt: null,
          expiresInDays: expiresInDays ?? null
        },
        "post"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * DELETE /v1/api/documentmanagement/folders/{folderId}/permissions/{permissionId}
   * Revokes a permission granted on the folder.
   */
  public static async revokeFolderPermission(screen: any, folderId: string, permissionId: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/folders/${folderId}/permissions/${permissionId}`,
        undefined,
        "delete"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /** POST /v1/api/documentmanagement/{documentId}/archive — Moves the document to the archive */
  public static async archiveDocument(screen: any, documentId: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}/archive`, undefined, "post");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /** POST /v1/api/documentmanagement/{documentId}/unarchive — Removes the document from the archive */
  public static async unarchiveDocument(screen: any, documentId: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}/unarchive`, undefined, "post");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /** POST /v1/api/documentmanagement/{documentId}/restore — Restores a soft-deleted document */
  public static async restoreDocument(screen: any, documentId: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}/restore`, undefined, "post");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  // ── End Document Management ───────────────────────────────────────

  public static getCurrentUrl = () => {
    return window.location.href;
  };

  public static printTcpl(value: any, printName: any) {
    return false;
  }

  private static getParentOfBaseTableElementRef = (screen, refValue: string) => {
    return (
      screen[`${refValue}_kuikaTableRef`] ||
      screen[`${refValue}_kuikaGalleryViewRef`] ||
      screen[`${refValue}_kuikaCarouselRef`] ||
      screen[`${refValue}_kuikaFlexGridRef`]
    );
  };
}
